var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolveticaCompressedRgRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Apr  4 10:45:53 2019\n By Aleksey,,,\n(c) 1999-2019 Typodermic Fonts Inc.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "CoolveticaCompressedRg-Regular",
    horizAdvX: 271
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Coolvetica Compressed Rg",
    fontWeight: 400,
    fontStretch: "extra-condensed",
    unitsPerEm: 1000,
    panose1: "2 11 6 8 3 6 2 2 0 4",
    ascent: 767,
    descent: -233,
    xHeight: 483,
    capHeight: 664,
    bbox: "-253 -233 464 904",
    underlineThickness: 20,
    underlinePosition: -163,
    unicodeRange: "U+0017-E006"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 223,
    d: "M69 0q-50 0 -50 45v574q0 45 50 45h85q50 0 50 -45v-574q0 -45 -50 -45h-85zM170 619q0 13 -16 13h-85q-17 0 -17 -13v-574q0 -14 17 -14h85q16 0 16 14v574z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 223,
    d: "M69 0q-50 0 -50 45v574q0 45 50 45h85q50 0 50 -45v-574q0 -45 -50 -45h-85zM170 619q0 13 -16 13h-85q-17 0 -17 -13v-574q0 -14 17 -14h85q16 0 16 14v574z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0017",
    horizAdvX: 89
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 89
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 131,
    d: "M28 0v103h73v-103h-73zM40 178q-6 50 -10 101.5t-4 106.5v278h79v-253q0 -62 -3.5 -120t-10.5 -113h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 188,
    d: "M19 450zM19 450v222h58v-222h-58zM111 450v222h58v-222h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 295,
    d: "M48 0l14 210h-41l5 51h39l10 148h-42l4 51h41l14 204h52l-13 -204h49l14 204h52l-13 -204h41l-4 -51h-41l-9 -148h43l-5 -51h-42l-13 -210h-53l14 210h-50l-13 -210h-53zM118 261h49l10 148h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 288,
    d: "M114 -60v67q-51 7 -73 38t-22 90v64h71v-74q0 -53 50 -53q29 0 39 15.5t10 40.5v96q0 25 -24 47q-17 15 -44 32t-53 42q-18 17 -32.5 40.5t-14.5 56.5v101q0 48 22 77.5t71 35.5v74h57v-75q50 -8 69 -43t19 -88v-56h-70v72q0 23 -11.5 37t-35.5 14q-23 0 -34.5 -12.5 t-11.5 -31.5v-91q0 -20 5 -32t25 -28q28 -23 55.5 -38t49.5 -36q17 -16 27 -37.5t10 -56.5v-97q0 -56 -23 -86.5t-74 -37.5v-67h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 299,
    d: "M10 0zM39 -15l180 696h41l-181 -696h-40zM129 427q0 -41 -15.5 -60.5t-43.5 -19.5q-29 0 -44.5 21t-15.5 60v157q0 39 15.5 60t44.5 21q28 0 43.5 -19.5t15.5 -60.5v-159zM89 586q0 42 -20 42t-20 -42v-159q0 -42 20 -42t20 42v159zM289 77q0 -41 -15.5 -60.5 t-43.5 -19.5q-29 0 -44.5 21t-15.5 60v157q0 39 15.5 60t44.5 21q28 0 43.5 -19.5t15.5 -60.5v-159zM249 236q0 42 -20 42t-20 -42v-159q0 -42 20 -42t20 42v159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 270,
    d: "M19 267q0 42 18 61t42 24v4q-53 9 -53 79v119q0 21 6.5 40.5t20 35t35 25t50.5 9.5h30v-70h-29q-22 0 -32.5 -14t-10.5 -34v-118q0 -25 9.5 -35.5t35.5 -10.5h22v-62h-25q-25 0 -34.5 -12.5t-9.5 -35.5v-155q0 -52 48 -52q29 0 37.5 22t8.5 57v238h65v-261 q0 -125 -115 -125q-59 0 -89 32.5t-30 94.5v144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 96,
    d: "M19 450v222h58v-222h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 172,
    d: "M107 -143q-18 43 -31.5 95.5t-23 109.5t-14.5 117t-5 119q0 57 4.5 115.5t14 114t23.5 106.5t32 94h52q-30 -96 -46 -207.5t-16 -223.5q0 -111 15.5 -225t46.5 -215h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 172,
    d: "M13 -143q30 101 45.5 215t15.5 225q0 112 -15.5 223.5t-45.5 207.5h52q18 -43 31.5 -94t23 -106.5t14 -113.5t4.5 -115q0 -59 -5 -119.5t-14 -117.5t-22.5 -109.5t-31.5 -95.5h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 248,
    d: "M175 450l-52 69l-51 -69l-34 23l52 72l-80 26l12 38l79 -25v88h44v-88l79 25l13 -38l-80 -26l51 -71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 257,
    d: "M100 224v82h-81v57h81v80h57v-80h81v-57h-81v-82h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 112,
    d: "M19 -105q17 10 24.5 25t7.5 40v40h-32v103h74v-133q0 -52 -19 -80.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 130,
    d: "M16 272v63h99v-63h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "\xAD",
    horizAdvX: 130,
    d: "M16 272v63h99v-63h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 112,
    d: "M19 0v103h74v-103h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 161,
    d: "M3 0l95 664h60l-96 -664h-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 277,
    d: "M258 155q0 -81 -30.5 -120t-87.5 -39q-60 0 -90.5 41t-30.5 120v350q0 79 30.5 120t90.5 41q57 0 87.5 -39t30.5 -120v-354zM183 510q0 89 -44 89q-45 0 -45 -90v-354q0 -90 45 -90q44 0 44 89v356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 155,
    d: "M63 0v555h-50v60q33 0 44.5 11.5t14.5 37.5h63v-664h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 267,
    d: "M19 0v154q0 35 8 61.5t29 52.5q11 13 25.5 26.5t29.5 27t28.5 25.5t21.5 22q11 14 15 28.5t4 34.5v117q0 25 -9 37t-34 12q-26 0 -35 -13.5t-9 -40.5v-85h-71v79q0 32 4 56.5t16 41t34.5 24.5t60.5 8q34 0 56.5 -7t35 -21.5t17.5 -36.5t5 -52v-121q0 -34 -7.5 -54.5 t-23.5 -39.5q-9 -11 -23 -23.5t-28 -25.5t-27.5 -26t-22.5 -23q-16 -19 -20.5 -34.5t-4.5 -33.5v-104h158v-66h-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 267,
    d: "M253 123q0 -62 -29.5 -94.5t-88.5 -32.5q-116 0 -116 125v72h71v-76q0 -52 44 -52q45 0 45 52v155q0 23 -11.5 35.5t-38.5 12.5h-31v62h34q26 0 35.5 12.5t9.5 33.5v123q0 20 -10.5 33.5t-32.5 13.5q-21 0 -32.5 -13t-11.5 -35v-74h-71v67q0 58 30 91.5t85 33.5 q30 0 51 -9.5t34.5 -25t20 -35.5t6.5 -40v-123q0 -70 -52 -79v-4q24 -5 41.5 -24.5t17.5 -60.5v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: "\u0417",
    horizAdvX: 267,
    d: "M253 123q0 -62 -29.5 -94.5t-88.5 -32.5q-116 0 -116 125v72h71v-76q0 -52 44 -52q45 0 45 52v155q0 23 -11.5 35.5t-38.5 12.5h-31v62h34q26 0 35.5 12.5t9.5 33.5v123q0 20 -10.5 33.5t-32.5 13.5q-21 0 -32.5 -13t-11.5 -35v-74h-71v67q0 58 30 91.5t85 33.5 q30 0 51 -9.5t34.5 -25t20 -35.5t6.5 -40v-123q0 -70 -52 -79v-4q24 -5 41.5 -24.5t17.5 -60.5v-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 273,
    d: "M153 520h-3l-86 -290h89v290zM152 0v167h-139v62l122 435h89v-434h36v-63h-36v-167h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 272,
    d: "M253 123q0 -62 -29.5 -94.5t-88.5 -32.5q-22 0 -42.5 5.5t-37 19t-26.5 37.5t-10 62v51h71v-55q0 -29 13 -40t31 -11q44 0 44 52v190q0 26 -11.5 35.5t-29.5 9.5q-29 0 -44 -25h-73l11 337h207v-66h-142l-8 -213h4q11 14 27 22.5t43 8.5q18 0 34.5 -4.5t29 -16.5 t20 -31.5t7.5 -49.5v-191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 272,
    d: "M253 121q0 -125 -115 -125q-60 0 -89.5 32.5t-29.5 94.5v416q0 63 29.5 96t89.5 33q55 0 85 -29t30 -86v-56h-71v53q0 48 -44 48t-44 -53v-172h4q11 20 29 32.5t45 12.5q37 0 59 -23.5t22 -66.5v-207zM182 311q0 23 -10.5 33.5t-28.5 10.5q-37 0 -49 -41v-197 q0 -52 44 -52t44 52v194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 225,
    d: "M49 0q1 66 10.5 147t23.5 162.5t31 157t33 129.5h-134v68h200v-61q-17 -58 -33.5 -134.5t-29 -158.5t-20 -162.5t-7.5 -147.5h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 267,
    d: "M176 551q0 20 -10.5 33.5t-32.5 13.5t-32 -13.5t-10 -33.5v-125q0 -20 8.5 -33t33.5 -13q26 0 34.5 13t8.5 33v125zM179 273q0 22 -10 33.5t-36 11.5q-25 0 -35 -11.5t-10 -33.5v-156q0 -52 45 -52q46 0 46 52v156zM253 123q0 -127 -120 -127q-119 0 -119 127v142 q0 41 17.5 60.5t41.5 24.5v4q-52 9 -52 80v124q0 21 6.5 40.5t20 35t34.5 25t51 9.5t51 -9.5t35 -25t20.5 -35t6.5 -40.5v-124q0 -71 -52 -80v-4q24 -5 41.5 -24.5t17.5 -60.5v-142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 272,
    d: "M178 309h-4q-11 -20 -29 -32.5t-45 -12.5q-37 0 -59 24t-22 66v189q0 125 116 125q118 0 118 -127v-416q0 -63 -29.5 -96t-89.5 -33q-55 0 -84 29t-29 86v66h70v-63q0 -48 43 -48q44 0 44 53v190zM178 547q0 52 -44 52t-44 -52v-176q0 -44 39 -44q37 0 49 41v179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 112,
    d: "M19 24v103h74v-103h-74zM19 361v103h74v-103h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 112,
    d: "M19 361v103h74v-103h-74zM19 -81q17 10 24.5 25t7.5 40v40h-32v103h74v-133q0 -52 -19 -80.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 257,
    d: "M19 302v61l219 106v-64l-156 -71v-4l156 -70v-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 257,
    d: "M19 381v57h219v-57h-219zM19 227v57h219v-57h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 257,
    d: "M19 197v63l156 70v4l-156 71v64l219 -106v-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 260,
    d: "M93 0v99h73v-99h-73zM95 174v65q0 33 4 51.5t11 31.5q11 23 28 44.5t25 41.5q4 9 6 21t2 35v82q0 28 -8 40t-34 12q-29 0 -37 -14.5t-8 -41.5v-71h-71v58q0 33 3.5 59t15.5 44t35 27t63 9q36 0 58 -7.5t34.5 -23.5t16.5 -40.5t4 -58.5v-79q0 -28 -3 -43.5t-9 -27.5 q-14 -29 -29.5 -49t-26.5 -44q-6 -14 -8 -28t-2 -39v-54h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 351,
    d: "M291 -63q-36 -21 -107 -21q-54 0 -86.5 12.5t-50 36.5t-23 59.5t-5.5 82.5v324q0 47 5.5 83t22.5 60.5t48.5 37t82.5 12.5q50 0 80 -11.5t46.5 -35t22 -59t5.5 -83.5v-261q0 -43 -18.5 -64.5t-53.5 -21.5q-20 0 -31 7t-16 19h-4q-10 -15 -21.5 -20.5t-25.5 -5.5 q-32 0 -43 22.5t-11 64.5v188q0 23 1.5 41.5t7 31t16 19.5t27.5 7q32 0 46 -27h3l3 23h33v-309q0 -20 19 -20q22 0 22 32v273q0 40 -4 68t-15.5 44.5t-33 24t-55.5 7.5q-36 0 -58 -8t-33.5 -25t-15.5 -45.5t-4 -68.5v-324q0 -39 4 -65.5t16.5 -43.5t35 -24.5t60.5 -7.5 q52 0 93 15zM153 165q0 -18 6 -25.5t18 -7.5q13 0 20.5 9t7.5 33v209q0 36 -28 36q-24 0 -24 -27v-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 279,
    d: "M196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0410",
    horizAdvX: 279,
    d: "M196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0391",
    horizAdvX: 279,
    d: "M196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 273,
    d: "M19 0v664h137q53 0 74 -26.5t21 -74.5v-129q0 -70 -49 -80v-4q26 -5 41.5 -23t15.5 -60v-181q0 -43 -21 -64.5t-72 -21.5h-147zM184 272q0 45 -43 45h-48v-252h49q42 0 42 45v162zM181 550q0 25 -8.5 37t-31.5 12h-48v-220h49q18 0 28.5 10.5t10.5 36.5v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0412",
    horizAdvX: 273,
    d: "M19 0v664h137q53 0 74 -26.5t21 -74.5v-129q0 -70 -49 -80v-4q26 -5 41.5 -23t15.5 -60v-181q0 -43 -21 -64.5t-72 -21.5h-147zM184 272q0 45 -43 45h-48v-252h49q42 0 42 45v162zM181 550q0 25 -8.5 37t-31.5 12h-48v-220h49q18 0 28.5 10.5t10.5 36.5v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0392",
    horizAdvX: 273,
    d: "M19 0v664h137q53 0 74 -26.5t21 -74.5v-129q0 -70 -49 -80v-4q26 -5 41.5 -23t15.5 -60v-181q0 -43 -21 -64.5t-72 -21.5h-147zM184 272q0 45 -43 45h-48v-252h49q42 0 42 45v162zM181 550q0 25 -8.5 37t-31.5 12h-48v-220h49q18 0 28.5 10.5t10.5 36.5v124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 272,
    d: "M182 271h71v-150q0 -125 -115 -125q-60 0 -89.5 32.5t-29.5 94.5v419q0 126 117 126q57 0 87 -30t30 -96v-116h-71v119q0 53 -44 53t-44 -53v-427q0 -53 43 -53q45 0 45 52v154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "\u0421",
    horizAdvX: 272,
    d: "M182 271h71v-150q0 -125 -115 -125q-60 0 -89.5 32.5t-29.5 94.5v419q0 126 117 126q57 0 87 -30t30 -96v-116h-71v119q0 53 -44 53t-44 -53v-427q0 -53 43 -53q45 0 45 52v154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 277,
    d: "M19 0v664h124q115 0 115 -116v-425q0 -63 -29 -93t-86 -30h-124zM138 68q26 0 35 18.5t9 51.5v390q0 32 -10 50t-39 18h-40v-528h45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 218,
    d: "M19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0415",
    horizAdvX: 218,
    d: "M19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0395",
    horizAdvX: 218,
    d: "M19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 218,
    d: "M19 0v664h186v-68h-110v-223h94v-67h-94v-306h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 272,
    d: "M204 0l-4 35h-3q-9 -17 -25 -28t-47 -11q-51 0 -78.5 32.5t-27.5 94.5v416q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 43 -52q38 0 45 46v167h-50v67h121v-345h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 280,
    d: "M185 0v319h-90v-319h-76v664h76v-277h90v277h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u041D",
    horizAdvX: 280,
    d: "M185 0v319h-90v-319h-76v664h76v-277h90v277h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u0397",
    horizAdvX: 280,
    d: "M185 0v319h-90v-319h-76v664h76v-277h90v277h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 114,
    d: "M19 0v664h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04CF",
    horizAdvX: 114,
    d: "M19 0v664h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04C0",
    horizAdvX: 114,
    d: "M19 0v664h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0406",
    horizAdvX: 114,
    d: "M19 0v664h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0399",
    horizAdvX: 114,
    d: "M19 0v664h76v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 266,
    d: "M173 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-116 0 -116 125v122h71v-126q0 -52 44 -52q45 0 45 52v547z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "\u0408",
    horizAdvX: 266,
    d: "M173 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-116 0 -116 125v122h71v-126q0 -52 44 -52q45 0 45 52v547z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 276,
    d: "M192 0l-62 284h-3l-31 -85v-199h-77v664h77v-278h4q4 15 10 34.5t16.5 50.5t26.5 77.5t40 115.5h76l-87 -260l86 -404h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u041A",
    horizAdvX: 276,
    d: "M192 0l-62 284h-3l-31 -85v-199h-77v664h77v-278h4q4 15 10 34.5t16.5 50.5t26.5 77.5t40 115.5h76l-87 -260l86 -404h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u039A",
    horizAdvX: 276,
    d: "M192 0l-62 284h-3l-31 -85v-199h-77v664h77v-278h4q4 15 10 34.5t16.5 50.5t26.5 77.5t40 115.5h76l-87 -260l86 -404h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 224,
    d: "M19 0v664h76v-595h116v-69h-192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 394,
    d: "M307 0v342v36t0.5 50.5t1 51.5t1.5 40h-4l-75 -520h-69l-75 520h-4q1 -15 1.5 -30t1 -35t0.5 -47v-66v-342h-67v664h116l61 -490h4l62 490h112v-664h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u041C",
    horizAdvX: 394,
    d: "M307 0v342v36t0.5 50.5t1 51.5t1.5 40h-4l-75 -520h-69l-75 520h-4q1 -15 1.5 -30t1 -35t0.5 -47v-66v-342h-67v664h116l61 -490h4l62 490h112v-664h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u039C",
    horizAdvX: 394,
    d: "M307 0v342v36t0.5 50.5t1 51.5t1.5 40h-4l-75 -520h-69l-75 520h-4q1 -15 1.5 -30t1 -35t0.5 -47v-66v-342h-67v664h116l61 -490h4l62 490h112v-664h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 294,
    d: "M183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "\u039D",
    horizAdvX: 294,
    d: "M183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    d: "M255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u041E",
    d: "M255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u039F",
    d: "M255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 268,
    d: "M95 262v-262h-76v664h140q53 0 74 -26.5t21 -74.5v-200q0 -48 -21 -74.5t-74 -26.5h-64zM95 327h49q21 0 30 12t9 35v180q0 21 -9 31.5t-30 10.5h-49v-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u0420",
    horizAdvX: 268,
    d: "M95 262v-262h-76v664h140q53 0 74 -26.5t21 -74.5v-200q0 -48 -21 -74.5t-74 -26.5h-64zM95 327h49q21 0 30 12t9 35v180q0 21 -9 31.5t-30 10.5h-49v-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u03A1",
    horizAdvX: 268,
    d: "M95 262v-262h-76v664h140q53 0 74 -26.5t21 -74.5v-200q0 -48 -21 -74.5t-74 -26.5h-64zM95 327h49q21 0 30 12t9 35v180q0 21 -9 31.5t-30 10.5h-49v-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 270,
    d: "M255 124q0 -105 -88 -122v-130q0 -38 34 -38q31 0 31 37v104h67v-100q0 -50 -22 -79t-74 -29q-54 0 -77 30t-23 79v127q-87 17 -87 122v412q0 63 29.5 97t89.5 34t90 -33.5t30 -96.5v-414zM180 543q0 26 -11 40.5t-34 14.5t-33.5 -14.5t-10.5 -39.5v-422q0 -53 44 -53 q45 0 45 52v422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 272,
    d: "M19 0v664h140q53 0 74 -26.5t21 -74.5v-152q0 -68 -50 -80v-4q25 -5 38.5 -23.5t13.5 -56.5v-247h-74v253q0 22 -8 32t-30 10h-51v-295h-74zM182 554q0 42 -40 42h-49v-239h50q18 0 28.5 10.5t10.5 36.5v150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 282,
    d: "M186 461v85q0 24 -11.5 38t-35.5 14q-23 0 -34.5 -12.5t-11.5 -32.5v-71q0 -29 5.5 -42.5t21.5 -28.5q13 -13 28 -25t30.5 -23t29.5 -22.5t24 -22.5q17 -18 25 -40.5t8 -60.5v-97q0 -61 -29 -92.5t-95 -31.5t-95.5 32.5t-29.5 96.5v74h71v-80q0 -54 51 -54q48 0 48 49v84 q0 35 -6.5 51t-24.5 33q-27 26 -54.5 46.5t-48.5 47.5q-33 43 -33 110v68q0 51 28.5 82.5t90.5 31.5q33 0 56 -9.5t36.5 -27t19.5 -41.5t6 -52v-77h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "\u0405",
    horizAdvX: 282,
    d: "M186 461v85q0 24 -11.5 38t-35.5 14q-23 0 -34.5 -12.5t-11.5 -32.5v-71q0 -29 5.5 -42.5t21.5 -28.5q13 -13 28 -25t30.5 -23t29.5 -22.5t24 -22.5q17 -18 25 -40.5t8 -60.5v-97q0 -61 -29 -92.5t-95 -31.5t-95.5 32.5t-29.5 96.5v74h71v-80q0 -54 51 -54q48 0 48 49v84 q0 35 -6.5 51t-24.5 33q-27 26 -54.5 46.5t-48.5 47.5q-33 43 -33 110v68q0 51 28.5 82.5t90.5 31.5q33 0 56 -9.5t36.5 -27t19.5 -41.5t6 -52v-77h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 263,
    d: "M93 0v596h-80v68h237v-68h-82v-596h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u0422",
    horizAdvX: 263,
    d: "M93 0v596h-80v68h237v-68h-82v-596h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u03A4",
    horizAdvX: 263,
    d: "M93 0v596h-80v68h237v-68h-82v-596h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 276,
    d: "M182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 279,
    d: "M86 0l-79 664h75l56 -530h4l56 530h73l-78 -664h-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 410,
    d: "M62 0l-55 664h73l35 -522h4l43 522h86l45 -522h4l34 522h71l-55 -664h-99l-41 522h-4l-41 -522h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 292,
    d: "M281 664l-87 -318l90 -346h-77l-60 256h-4l-60 -256h-76l90 336l-87 328h76l59 -243h4l58 243h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u0425",
    horizAdvX: 292,
    d: "M281 664l-87 -318l90 -346h-77l-60 256h-4l-60 -256h-76l90 336l-87 328h76l59 -243h4l58 243h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u03A7",
    horizAdvX: 292,
    d: "M281 664l-87 -318l90 -346h-77l-60 256h-4l-60 -256h-76l90 336l-87 328h76l59 -243h4l58 243h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 276,
    d: "M102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u04AE",
    horizAdvX: 276,
    d: "M102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u03A5",
    horizAdvX: 276,
    d: "M102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 252,
    d: "M13 0v69l148 527h-147v68h222v-68l-146 -528h150v-68h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "\u0396",
    horizAdvX: 252,
    d: "M13 0v69l148 527h-147v68h222v-68l-146 -528h150v-68h-227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 172,
    d: "M35 -130v849h124v-61h-67v-728h67v-60h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 161,
    d: "M98 0l-95 664h60l95 -664h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 172,
    d: "M13 -130v60h67v728h-67v61h123v-849h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 257,
    d: "M97 664h65l89 -237h-64l-57 168h-4l-55 -168h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 186,
    d: "M0 -98v48h188v-48h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 191,
    d: "M21 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 266,
    d: "M175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "\u0430",
    horizAdvX: 266,
    d: "M175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M178 376q0 49 -41 49q-20 0 -30 -14.5t-16 -45.5v-252q5 -28 16 -41t31 -13q40 0 40 48v269zM21 0v672h71v-230h4q12 23 29 34t43 11q46 0 64 -29.5t18 -84.5v-269q0 -51 -20.5 -79.5t-62.5 -28.5q-52 0 -76 53h-4l-2 -49h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 266,
    d: "M176 178h69v-69q0 -57 -26.5 -85t-85.5 -28q-112 0 -112 113v265q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-265q0 -48 43 -48q42 0 42 48v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "\u0441",
    horizAdvX: 266,
    d: "M176 178h69v-69q0 -57 -26.5 -85t-85.5 -28q-112 0 -112 113v265q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-265q0 -48 43 -48q42 0 42 48v69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M94 107q0 -26 10.5 -37t30.5 -11t30 12.5t16 41.5v257q-5 30 -14.5 42.5t-30.5 12.5q-20 0 -31 -11.5t-11 -37.5v-269zM186 0l-2 49h-4q-22 -53 -75 -53q-40 0 -62 24.5t-22 69.5v304q0 45 22.5 69t61.5 24q25 0 42 -10.5t28 -34.5h4v230h71v-672h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 269,
    d: "M248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "\u0435",
    horizAdvX: 269,
    d: "M248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 209,
    d: "M198 418h-70v-418h-72v418h-45v65h45v81q0 108 114 108h26v-65h-26q-42 0 -42 -43v-81h70v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M250 -120q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-21 -46 -73 -46q-43 0 -62 27t-19 82v283q0 43 21 69t63 26q28 0 45.5 -13.5t29.5 -39.5h4l2 49h64v-603zM94 125q0 -31 9 -45t31 -14q25 0 33.5 19.5t13.5 48.5v221 q-5 29 -13 49.5t-33 20.5q-41 0 -41 -49v-251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 273,
    d: "M180 0v379q0 45 -40 45q-21 0 -33 -13.5t-14 -45.5v-365h-72v672h72v-233h4q20 48 75 48q45 0 63 -28t18 -70v-389h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "\u04BB",
    horizAdvX: 273,
    d: "M180 0v379q0 45 -40 45q-21 0 -33 -13.5t-14 -45.5v-365h-72v672h72v-233h4q20 48 75 48q45 0 63 -28t18 -70v-389h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 114,
    d: "M21 0v483h72v-483h-72zM21 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "\u0456",
    horizAdvX: 114,
    d: "M21 0v483h72v-483h-72zM21 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 127,
    d: "M-122 -27h69v-93q0 -48 43 -48q44 0 44 48v603h72v-603q0 -113 -115 -113q-59 0 -86 28t-27 85v93zM34 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "\u0458",
    horizAdvX: 127,
    d: "M-122 -27h69v-93q0 -48 43 -48q44 0 44 48v603h72v-603q0 -113 -115 -113q-59 0 -86 28t-27 85v93zM34 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 270,
    d: "M187 0l-60 200h-4l-30 -64v-136h-72v672h72v-393h4q3 7 7 17.5t13 32t25.5 58t43.5 96.5h78l-85 -199l84 -284h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 114,
    d: "M21 0v672h72v-672h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 424,
    d: "M330 0v379q0 46 -39 46q-19 0 -28.5 -11t-16.5 -35v-379h-69v379q0 46 -39 46q-19 0 -28.5 -11.5t-16.5 -34.5v-379h-72v483h67l2 -49h4q11 29 28 41t43 12q28 0 48 -14.5t28 -43.5q14 33 34.5 45.5t44.5 12.5q36 0 59.5 -24.5t23.5 -69.5v-393h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 273,
    d: "M180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 268,
    d: "M247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u043E",
    horizAdvX: 268,
    d: "M247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u03BF",
    horizAdvX: 268,
    d: "M247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M178 376q0 49 -42 49q-20 0 -29.5 -11t-15.5 -35v-275q6 -24 15.5 -34.5t29.5 -10.5t31 11t11 37v269zM21 -233v716h64l2 -49h4q12 28 29.5 40.5t45.5 12.5q40 0 62 -24t22 -69v-304q0 -45 -22 -69.5t-61 -24.5q-51 0 -71 46h-4v-275h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "\u0440",
    d: "M178 376q0 49 -42 49q-20 0 -29.5 -11t-15.5 -35v-275q6 -24 15.5 -34.5t29.5 -10.5t31 11t11 37v269zM21 -233v716h64l2 -49h4q12 28 29.5 40.5t45.5 12.5q40 0 62 -24t22 -69v-304q0 -45 -22 -69.5t-61 -24.5q-51 0 -71 46h-4v-275h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M396 -120q0 -57 -25.5 -85t-81.5 -28q-110 0 -110 113v162h-4q-20 -46 -72 -46q-46 0 -64 29t-18 83v286q0 45 22 69t62 24q28 0 45.5 -12.5t29.5 -41.5h4l2 50h64v-586q0 -35 8 -50t30 -15q39 0 39 48v93h69v-93zM94 107q0 -26 10.5 -37t30.5 -11t29.5 11.5t16.5 37.5 v267q-7 27 -16.5 38.5t-29.5 11.5q-41 0 -41 -49v-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 207,
    d: "M21 0v483h67l2 -56h4q11 29 28.5 44.5t44.5 15.5q16 0 28 -6v-66q-12 7 -31 7q-31 0 -47.5 -17t-23.5 -62v-343h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 265,
    d: "M175 335v56q0 37 -42 37q-43 0 -43 -33v-54q0 -17 4.5 -25.5t21.5 -19.5q23 -16 47 -27t46 -27q19 -14 28.5 -33t9.5 -54v-63q0 -49 -27 -72.5t-85 -23.5q-62 0 -89.5 25.5t-27.5 74.5v59h68v-61q0 -20 10.5 -29.5t35.5 -9.5q43 0 43 36v62q0 16 -5.5 26t-25.5 24 q-7 4 -18.5 11t-25 15t-26.5 16.5t-22 16.5q-17 15 -23.5 33.5t-6.5 45.5v60q0 40 27.5 63t81.5 23q56 0 84 -26t28 -73v-53h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "\u0455",
    horizAdvX: 265,
    d: "M175 335v56q0 37 -42 37q-43 0 -43 -33v-54q0 -17 4.5 -25.5t21.5 -19.5q23 -16 47 -27t46 -27q19 -14 28.5 -33t9.5 -54v-63q0 -49 -27 -72.5t-85 -23.5q-62 0 -89.5 25.5t-27.5 74.5v59h68v-61q0 -20 10.5 -29.5t35.5 -9.5q43 0 43 36v62q0 16 -5.5 26t-25.5 24 q-7 4 -18.5 11t-25 15t-26.5 16.5t-22 16.5q-17 15 -23.5 33.5t-6.5 45.5v60q0 40 27.5 63t81.5 23q56 0 84 -26t28 -73v-53h-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 257,
    d: "M174 274h62v-165q0 -58 -22 -85.5t-80 -27.5q-59 0 -86 27.5t-27 85.5v507h71v-133h144v-65h-144v-309q0 -48 43 -48q21 0 30 11.5t9 36.5v165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 272,
    d: "M94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 255,
    d: "M80 0l-74 483h73l49 -376h4l48 376h69l-72 -483h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "\u03BD",
    horizAdvX: 255,
    d: "M80 0l-74 483h73l49 -376h4l48 376h69l-72 -483h-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 375,
    d: "M55 0l-49 483h68l32 -364h4l37 364h80l39 -364h4l31 364h67l-49 -483h-92l-38 370h-4l-38 -370h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 267,
    d: "M259 483l-79 -231l82 -252h-76l-51 175h-4l-51 -175h-74l82 246l-79 237h74l51 -166h4l48 166h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "\u0445",
    horizAdvX: 267,
    d: "M259 483l-79 -231l82 -252h-76l-51 175h-4l-51 -175h-74l82 246l-79 237h74l51 -166h4l48 166h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    d: "M94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "\u0443",
    d: "M94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 230,
    d: "M14 0v68l126 350h-124v65h197v-65l-125 -352h128v-66h-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 172,
    d: "M123 -131q-64 0 -64 94v259q0 44 -37 44v59q37 0 37 43v258q0 94 64 94h36v-57h-14q-29 0 -29 -37v-258q0 -56 -38 -71v-4q38 -15 38 -71v-259q0 -37 29 -37h14v-57h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 145,
    d: "M44 -125v861h56v-861h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 172,
    d: "M13 -131v57h13q29 0 29 37v259q0 57 38 71v4q-38 15 -38 71v258q0 37 -29 37h-13v57h35q64 0 64 -94v-258q0 -43 38 -43v-59q-38 0 -38 -44v-259q0 -94 -64 -94h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 257,
    d: "M177 296q-15 0 -27.5 3t-24.5 7t-23.5 7t-23.5 3q-32 0 -59 -27v60q10 10 24 17t36 7q15 0 27.5 -3.5t24.5 -7l24 -7t24 -3.5q33 0 59 27v-60q-25 -23 -61 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonbreakingspace",
    unicode: "\xA0",
    horizAdvX: 89
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 131,
    d: "M103 492v-103h-74v103h74zM91 314q6 -50 10 -101.5t4 -106.5v-278h-79v253q0 62 3 120t11 113h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 263,
    d: "M104 -4v92q-85 12 -85 111v278q0 98 85 111v82h57v-82q43 -7 62.5 -34.5t19.5 -76.5v-69h-68v74q0 48 -43 48t-43 -48v-288q0 -48 43 -48t43 48v76h68v-71q0 -49 -19.5 -76.5t-62.5 -34.5v-92h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M252 250h-158v-181h158v-69h-233v541q0 62 30 94.5t89 32.5q114 0 114 -125v-138h-70v142q0 52 -44 52t-44 -52v-229h158v-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 320,
    d: "M226 229q-14 -9 -31 -14.5t-34 -5.5q-18 0 -35 5.5t-31 14.5l-38 -41l-36 37l41 38q-21 29 -21 67q0 17 5.5 34.5t14.5 31.5l-39 38l36 35l36 -39q14 9 31 15t35 6t35.5 -6t31.5 -15l37 39l36 -35l-39 -37q8 -15 14 -32.5t6 -35.5q0 -19 -6 -35.5t-14 -30.5l39 -38 l-35 -37zM237 330q0 32 -22.5 54.5t-54.5 22.5t-53.5 -23t-21.5 -55t22 -54t54 -22t54 22t22 55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 276,
    d: "M104 0v108h-71v46h71v88h-71v46h71v4l-98 372h73l59 -256h4l57 256h71l-95 -373v-3h77v-46h-77v-88h77v-46h-77v-108h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 145,
    d: "M44 -125v384h56v-384h-56zM44 356v380h56v-380h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 230,
    d: "M211 -42q0 -50 -22.5 -74t-71.5 -24q-53 0 -75.5 26t-22.5 77v52h57v-63q0 -20 8.5 -29.5t28.5 -9.5t28 9t8 28v90q0 24 -20 37.5t-44 29t-44 39t-20 65.5v141q0 25 10 44t30 29q-40 30 -40 85v72q0 39 23 62.5t68 23.5q48 0 70 -26.5t22 -71.5v-51h-56v58q0 18 -7.5 28 t-26.5 10q-18 0 -26.5 -9.5t-8.5 -23.5v-75q0 -12 4 -19.5t16 -17.5q19 -15 39 -25.5t36 -23t26.5 -30.5t10.5 -49v-151q0 -53 -26 -77q13 -13 19.5 -29.5t6.5 -41.5v-85zM149 339q0 17 -10.5 27t-33.5 24q-14 -3 -20 -12t-6 -21v-149q0 -21 18 -34.5t42 -24.5q10 7 10 28 v162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 220,
    d: "M19 535v93h67v-93h-67zM133 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 277,
    d: "M258 121q0 -64 -31 -94.5t-88 -30.5q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM227 538q0 48 -23.5 74t-65.5 26t-65 -25.5t-23 -73.5v-416q0 -97 89 -97q42 0 65 23.5t23 71.5v417zM163 374v55q0 27 -23 27q-16 0 -19.5 -13.5 t-3.5 -32.5v-159q0 -19 3.5 -33t20.5 -14q22 0 22 27v72h30v-70q0 -58 -53 -58q-54 0 -54 59v192q0 29 13.5 44.5t39.5 15.5t40 -16t14 -45v-51h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 178,
    d: "M111 528q-5 -3 -10 -5.5t-15 -5.5q-15 -5 -19 -11.5t-4 -18.5v-55q0 -22 21 -22q11 0 17 6t10 17v95zM114 373l-1 24h-3q-5 -9 -15 -18t-31 -9q-26 0 -36.5 13.5t-10.5 37.5v58q0 30 12.5 43.5t45.5 23.5q18 5 27 10t9 15v39q0 19 -23 19t-23 -21v-36h-44v41 q0 29 18.5 42.5t51.5 13.5q66 0 66 -53v-243h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 218,
    d: "M8 200zM8 318l84 118l29 -29l-64 -89l64 -89l-29 -29zM96 318l84 118l29 -29l-64 -89l64 -89l-29 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 257,
    d: "M182 54v341h-163v56h219v-397h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 217,
    d: "M197 379q0 -94 -88 -94q-44 0 -67 24t-23 71v192q0 46 23.5 71t65.5 25q43 0 66 -25.5t23 -71.5v-192zM173 571q0 35 -17 54t-48 19t-48 -18.5t-17 -53.5v-192q0 -71 66 -71q64 0 64 70v192zM125 384v69q0 15 -15 15h-18v-84h-25v201h49q19 0 26.5 -9t7.5 -26v-43 q0 -23 -17 -26v-3q17 -5 17 -27v-67h-25zM125 547q0 16 -15 16h-18v-73h18q15 0 15 14v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 216,
    d: "M19 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 131,
    d: "M65 544q-29 0 -42 18t-13 47t13 46t42 17t42 -17t13 -46t-13 -47t-42 -18zM65 573q26 0 26 36q0 35 -26 35q-25 0 -25 -35q0 -36 25 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 257,
    d: "M19 81zM100 224v82h-81v57h81v80h57v-80h81v-57h-81v-82h-57zM19 81v57h219v-57h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 152,
    d: "M19 350zM19 350v68q0 19 4 32.5t15 27.5q11 13 25.5 25.5t22.5 22.5q6 8 8 15t2 20v45q0 22 -18 22q-11 0 -15 -5.5t-4 -18.5v-47h-39v44q0 16 2 28t8 20.5t17.5 12.5t30.5 4q35 0 46 -14.5t11 -44.5v-46q0 -36 -18 -54q-8 -9 -21.5 -22t-23.5 -24q-8 -9 -10.5 -16.5 t-2.5 -18.5v-40h76v-36h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 152,
    d: "M19 347zM135 409q0 -62 -58 -62t-58 66v38h38v-40q0 -26 20 -26q19 0 19 22v64q0 25 -22 25h-16v34h17q12 0 15.5 5.5t3.5 18.5v51q0 12 -3.5 17.5t-14.5 5.5q-19 0 -19 -24v-35h-38v31q0 32 14.5 49t42.5 17q29 0 42.5 -17t13.5 -40v-52q0 -35 -25 -41v-3 q12 -3 20 -12.5t8 -31.5v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 191,
    d: "M49 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 276,
    d: "M188 -100v704h-62v-704h-60v558q-53 8 -53 58v92q0 56 75 56h182l-22 -60v-704h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 112,
    d: "M19 282v103h74v-103h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 104,
    d: "M20 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 104,
    d: "M16 350zM45 350v253h-29v33q19 0 25.5 6.5t8.5 21.5h34v-314h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 176,
    d: "M155 440q0 -36 -17 -52.5t-52 -16.5t-51.5 16.5t-16.5 52.5v160q0 36 16.5 52.5t51.5 16.5t52 -16.5t17 -52.5v-160zM110 600q0 28 -24 28q-23 0 -23 -28v-160q0 -28 23 -28q24 0 24 28v160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 218,
    d: "M8 201zM8 229l64 90l-64 88l30 29l83 -117l-83 -118zM96 229l64 90l-64 88l30 29l83 -117l-83 -118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 299,
    d: "M21 0zM30 -15l180 696h41l-181 -696h-40zM50 350v253h-29v33q19 0 25.5 6.5t8.5 21.5h34v-314h-39zM220 234h-3l-34 -133h37v133zM220 0v66h-66v34l55 214h50v-213h18v-35h-18v-66h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 299,
    d: "M13 0zM23 -15l180 696h41l-181 -696h-40zM42 350v253h-29v33q19 0 25.5 6.5t8.5 21.5h34v-314h-39zM169 0v68q0 19 4 32.5t15 27.5q11 13 25.5 25.5t22.5 22.5q6 8 8 15t2 20v45q0 22 -18 22q-11 0 -15 -5.5t-4 -18.5v-47h-39v44q0 16 2 28t8 20.5t17.5 12.5t30.5 4 q35 0 46 -14.5t11 -44.5v-46q0 -36 -18 -54q-8 -9 -21.5 -22t-23.5 -24q-8 -9 -10.5 -16.5t-2.5 -18.5v-40h76v-36h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 299,
    d: "M13 0zM48 -15l180 696h41l-181 -696h-40zM228 234h-3l-34 -133h37v133zM228 0v66h-66v34l55 214h50v-213h18v-35h-18v-66h-39zM129 409q0 -62 -58 -62t-58 66v38h38v-40q0 -26 20 -26q19 0 19 22v64q0 25 -22 25h-16v34h17q12 0 15.5 5.5t3.5 18.5v51q0 12 -3.5 17.5 t-14.5 5.5q-19 0 -19 -24v-35h-38v31q0 32 14.5 49t42.5 17q29 0 42.5 -17t13.5 -40v-52q0 -35 -25 -41v-3q12 -3 20 -12.5t8 -31.5v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 260,
    d: "M167 492v-100h-74v100h74zM164 318v-66q0 -33 -4 -51t-10 -31q-5 -11 -12.5 -22t-15.5 -22t-15 -22t-11 -21q-4 -8 -6 -20t-2 -35v-83q0 -27 8.5 -39.5t34.5 -12.5q29 0 36.5 15t7.5 42v71h71v-58q0 -33 -3 -59t-15 -44t-35.5 -27.5t-63.5 -9.5q-36 0 -58 8t-34 24 t-16 40.5t-4 58.5v79q0 28 3 43.5t8 27.5q11 23 29 46.5t27 45.5q6 14 8.5 28.5t2.5 39.5v54h69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM49 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM107 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM206 682l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM241 746q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM48 711v93h67v-93h-67zM162 711v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM138 712q17 0 25 12t8 32t-8 32t-25 12t-25 -12t-8 -32t8 -32t25 -12zM138 681q-33 0 -49 20.5t-16 54.5t16 54.5t49 20.5t49 -20.5t16 -54.5t-16 -54.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 372,
    d: "M174 0v146h-78l-15 -146h-74l78 664h270v-68h-107v-214h97v-68h-97v-246h113v-68h-187zM103 211h71v385h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 272,
    d: "M19 0zM182 271h71v-150q0 -125 -115 -125q-60 0 -89.5 32.5t-29.5 94.5v419q0 126 117 126q57 0 87 -30t30 -96v-116h-71v119q0 53 -44 53t-44 -53v-427q0 -53 43 -53q45 0 45 52v154zM102 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM23 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\u0400",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM23 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM81 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 218,
    d: "M11 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM181 682l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM19 711v93h67v-93h-67zM133 711v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\u0401",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM19 711v93h67v-93h-67zM133 711v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 127,
    d: "M0 0zM32 0v664h76v-664h-76zM-26 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 131,
    d: "M11 0zM19 0v664h76v-664h-76zM39 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 161,
    d: "M0 0zM42 0v664h76v-664h-76zM150 682l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 154,
    d: "M0 0zM38 0v664h76v-664h-76zM-14 704v93h67v-93h-67zM100 704v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u0407",
    horizAdvX: 154,
    d: "M0 0zM38 0v664h76v-664h-76zM-14 704v93h67v-93h-67zM100 704v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u03AA",
    horizAdvX: 154,
    d: "M0 0zM38 0v664h76v-664h-76zM-14 704v93h67v-93h-67zM100 704v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 288,
    d: "M30 0v314h-26v68h26v282h124q115 0 115 -116v-425q0 -63 -29 -93t-86 -30h-124zM149 68q26 0 35 18.5t9 51.5v390q0 32 -10 50t-39 18h-40v-214h50v-68h-50v-246h45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\u0110",
    horizAdvX: 288,
    d: "M30 0v314h-26v68h26v282h124q115 0 115 -116v-425q0 -63 -29 -93t-86 -30h-124zM149 68q26 0 35 18.5t9 51.5v390q0 32 -10 50t-39 18h-40v-214h50v-68h-50v-246h45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 294,
    d: "M19 0zM183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM249 746q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5 t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM48 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM105 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM206 682l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM239 746q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5 t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM45 711v93h67v-93h-67zM159 711v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 257,
    d: "M169 333l63 -63l-40 -39l-63 62l-63 -63l-40 40l63 63l-62 62l40 40l62 -62l62 62l40 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    d: "M26 -15l13 53q-23 32 -23 85v416q0 62 31 95.5t88 33.5q34 0 58 -12l7 25h46l-15 -58q11 -16 17.5 -37.5t6.5 -47.5v-417q0 -63 -31 -94t-88 -31q-32 0 -59 11l-5 -22h-46zM180 417h-4l-79 -332q11 -20 39 -20q44 0 44 52v300zM91 245h4l78 331q-11 22 -38 22 q-44 0 -44 -53v-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM50 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM106 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM206 682l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM47 711v93h67v-93h-67zM161 711v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 276,
    d: "M6 0zM102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75zM110 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 272,
    d: "M19 664h76v-99h64q53 0 74 -26.5t21 -74.5v-229q0 -48 -21 -74.5t-74 -26.5h-64v-134h-76v664zM95 500v-301h49q26 0 32.5 21.5t6.5 51.5v181q0 23 -9 35t-30 12h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 285,
    d: "M197 271q0 31 -10 46.5t-42 15.5h-23v61h16q40 0 40 41v132q0 44 -44 44q-26 0 -35.5 -16.5t-9.5 -46.5v-548h-70v563q0 59 28 86t91 27q55 0 85 -22t30 -77v-131q0 -71 -52 -80v-4q34 -5 50 -30.5t16 -70.5v-150q0 -59 -24.5 -87t-83.5 -28q-25 0 -44 6v61q16 -6 33 -6 q49 0 49 54v160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM45 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM100 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM200 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM234 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM42 535v93h67v-93h-67zM156 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM135 536q17 0 25 12t8 32t-8 32t-25 12t-25 -12t-8 -32t8 -32t25 -12zM135 505q-33 0 -49 20.5t-16 54.5t16 54.5t49 20.5t49 -20.5t16 -54.5t-16 -54.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 422,
    d: "M402 109q0 -113 -115 -113q-82 0 -103 59h-4q-12 -29 -32 -44t-55 -15q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q51 0 76 -19q26 19 74 19q114 0 114 -113v-150 h-157v-117q0 -48 43 -48t43 48v59h71v-57zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM331 375q0 49 -43 49t-43 -49v-99h86v99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 266,
    d: "M21 0zM176 178h69v-69q0 -57 -26.5 -85t-85.5 -28q-112 0 -112 113v265q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-265q0 -48 43 -48q42 0 42 48v69zM101 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM46 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\u0450",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM46 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM103 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM203 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM45 535v93h67v-93h-67zM159 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\u0451",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM45 535v93h67v-93h-67zM159 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 140,
    d: "M0 0zM-6 623l38 44l111 -133l-28 -29zM47 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 146,
    d: "M4 0zM32 505l-28 29l111 133l38 -44zM21 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 184,
    d: "M0 0zM56 0v483h72v-483h-72zM161 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 156,
    d: "M0 0zM-13 535v93h67v-93h-67zM101 535v93h67v-93h-67zM41 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\u0457",
    horizAdvX: 156,
    d: "M0 0zM-13 535v93h67v-93h-67zM101 535v93h67v-93h-67zM41 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 272,
    d: "M251 622l-41 -22q20 -33 30.5 -73.5t10.5 -85.5v-300q0 -38 -4.5 -65.5t-17.5 -45t-35.5 -26t-58.5 -8.5q-37 0 -59.5 8t-34.5 23t-16 36.5t-4 48.5v276q0 43 23.5 64t60.5 21q23 0 42 -9t31 -33h4v42q0 25 -7 50t-19 48l-87 -47v35l72 39q-32 49 -73 74h67 q33 -17 57 -47l59 32v-35zM138 59q14 0 22.5 4.5t13 15.5t6 29.5t1.5 47.5v218q-8 23 -18.5 30t-27.5 7q-22 0 -31.5 -13.5t-9.5 -52.5v-246q0 -40 44 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73zM239 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5 q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM46 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM103 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM204 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM236 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5 t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM44 535v93h67v-93h-67zM158 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 257,
    d: "M19 305v56h219v-56h-219zM91 143v98h74v-98h-74zM91 426v99h74v-99h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 268,
    d: "M27 -13l14 44q-20 26 -20 78v265q0 59 27.5 86t85.5 27q33 0 56 -9l7 19h45l-16 -46q21 -27 21 -77v-265q0 -59 -27.5 -86t-85.5 -27q-35 0 -57 9l-6 -18h-44zM177 303h-4l-73 -229q10 -13 34 -13q43 0 43 48v194zM91 179h4l72 230q-10 13 -33 13q-43 0 -43 -48v-195z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM49 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM105 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM206 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM46 535v93h67v-93h-67zM160 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    d: "M21 0zM94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368zM105 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    d: "M21 -233v905h71v-230h4q20 45 76 45q27 0 42.5 -12.5t23.5 -33t10 -47.5t2 -56v-210q0 -29 -3 -53t-11 -41.5t-24 -27.5t-41 -10q-26 0 -45 10.5t-30 34.5h-4v-274h-71zM178 376q0 49 -41 49q-20 0 -30 -14.5t-16 -45.5v-252q5 -28 16 -41t31 -13q40 0 40 48v269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    d: "M21 0zM94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368zM48 535v93h67v-93h-67zM162 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM48 723v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM42 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM137 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM129 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 279,
    d: "M269 -208q-9 -5 -22 -7.5t-27 -2.5q-36 0 -53.5 16t-17.5 57v29q0 42 21 69t59 42v5h-33l-17 162h-82l-16 -162h-74l78 664h107l79 -664q-72 -36 -72 -96v-27q0 -18 8.5 -24.5t27.5 -6.5q8 0 17.5 1t16.5 4v-59zM104 227h68l-32 315h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 266,
    d: "M245 -208q-19 -10 -49 -10q-36 0 -54 16t-18 57v29q0 42 23 70t63 42v4h-30l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22 q108 0 108 -85v-402q-71 -36 -71 -96v-27q0 -18 8 -24.5t27 -6.5q9 0 18.5 1t16.5 4v-59zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 272,
    d: "M19 0zM182 271h71v-150q0 -125 -115 -125q-60 0 -89.5 32.5t-29.5 94.5v419q0 126 117 126q57 0 87 -30t30 -96v-116h-71v119q0 53 -44 53t-44 -53v-427q0 -53 43 -53q45 0 45 52v154zM106 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 266,
    d: "M21 0zM176 178h69v-69q0 -57 -26.5 -85t-85.5 -28q-112 0 -112 113v265q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-265q0 -48 43 -48q42 0 42 48v69zM102 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 272,
    d: "M19 0zM182 271h71v-150q0 -125 -115 -125q-60 0 -89.5 32.5t-29.5 94.5v419q0 126 117 126q57 0 87 -30t30 -96v-116h-71v119q0 53 -44 53t-44 -53v-427q0 -53 43 -53q45 0 45 52v154zM100 711v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 266,
    d: "M21 0zM176 178h69v-69q0 -57 -26.5 -85t-85.5 -28q-112 0 -112 113v265q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-265q0 -48 43 -48q42 0 42 48v69zM97 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 272,
    d: "M19 0zM182 271h71v-150q0 -125 -115 -125q-60 0 -89.5 32.5t-29.5 94.5v419q0 126 117 126q57 0 87 -30t30 -96v-116h-71v119q0 53 -44 53t-44 -53v-427q0 -53 43 -53q45 0 45 52v154zM104 695l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 266,
    d: "M21 0zM176 178h69v-69q0 -57 -26.5 -85t-85.5 -28q-112 0 -112 113v265q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-265q0 -48 43 -48q42 0 42 48v69zM101 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 277,
    d: "M19 0zM19 0v664h124q115 0 115 -116v-425q0 -63 -29 -93t-86 -30h-124zM138 68q26 0 35 18.5t9 51.5v390q0 32 -10 50t-39 18h-40v-528h45zM104 695l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 354,
    d: "M21 0zM94 107q0 -26 10.5 -37t30.5 -11t30 12.5t16 41.5v257q-5 30 -14.5 42.5t-30.5 12.5q-20 0 -31 -11.5t-11 -37.5v-269zM186 0l-2 49h-4q-22 -53 -75 -53q-40 0 -62 24.5t-22 69.5v304q0 45 22.5 69t61.5 24q25 0 42 -10.5t28 -34.5h4v230h71v-672h-64zM271 464 q17 10 24.5 25t7.5 40v40h-32v103h74v-134q0 -51 -19 -79.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M186 0l-2 49h-4q-22 -53 -75 -53q-40 0 -62 24.5t-22 69.5v304q0 45 22.5 69t61.5 24q25 0 42 -10.5t28 -34.5h4v112h-85v46h85v72h71v-72h21v-46h-21v-554h-64zM94 107q0 -26 10.5 -37t30.5 -11t30 12.5t16 41.5v257q-5 30 -14.5 42.5t-30.5 12.5q-20 0 -31 -11.5 t-11 -37.5v-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM23 723v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM46 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 218,
    d: "M14 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM116 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM134 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54 q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM78 711v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM97 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 218,
    d: "M205 -208q-9 -5 -22 -7.5t-27 -2.5q-36 0 -53.5 16t-17.5 57v29q0 42 21.5 69t59.5 42v5h-147v664h182v-68h-108v-214h98v-68h-98v-246h114v-68q-72 -36 -72 -96v-27q0 -18 8.5 -24.5t27.5 -6.5q8 0 17.5 1t16.5 4v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 269,
    d: "M181 -208q-9 -5 -22 -7.5t-27 -2.5q-36 0 -53.5 16t-17.5 57v29q0 37 17.5 63.5t47.5 43.5v5q-105 3 -105 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57q0 -28 -5.5 -46t-15.5 -29.5t-22.5 -19t-25.5 -13.5q-10 -5 -22 -12 t-22 -18t-17 -27.5t-7 -39.5v-27q0 -18 8.5 -24.5t28.5 -6.5q8 0 17 1t16 4v-59zM177 375q0 49 -43 49t-43 -49v-99h86v99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 218,
    d: "M11 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM79 695l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM102 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 272,
    d: "M19 0zM204 0l-4 35h-3q-9 -17 -25 -28t-47 -11q-51 0 -78.5 32.5t-27.5 94.5v416q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 43 -52q38 0 45 46v167h-50v67h121v-345h-49zM138 681q-45 0 -73.5 34t-28.5 98h52 q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    d: "M21 0zM250 -120q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-21 -46 -73 -46q-43 0 -62 27t-19 82v283q0 43 21 69t63 26q28 0 45.5 -13.5t29.5 -39.5h4l2 49h64v-603zM94 125q0 -31 9 -45t31 -14q25 0 33.5 19.5t13.5 48.5v221 q-5 29 -13 49.5t-33 20.5q-41 0 -41 -49v-251zM138 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 272,
    d: "M19 0zM204 0l-4 35h-3q-9 -17 -25 -28t-47 -11q-51 0 -78.5 32.5t-27.5 94.5v416q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 43 -52q38 0 45 46v167h-50v67h121v-345h-49zM101 711v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    d: "M21 0zM250 -120q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-21 -46 -73 -46q-43 0 -62 27t-19 82v283q0 43 21 69t63 26q28 0 45.5 -13.5t29.5 -39.5h4l2 49h64v-603zM94 125q0 -31 9 -45t31 -14q25 0 33.5 19.5t13.5 48.5v221 q-5 29 -13 49.5t-33 20.5q-41 0 -41 -49v-251zM99 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 272,
    d: "M19 0zM204 0l-4 35h-3q-9 -17 -25 -28t-47 -11q-51 0 -78.5 32.5t-27.5 94.5v416q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 43 -52q38 0 45 46v167h-50v67h121v-345h-49zM106 -183q16 4 24 13t8 30v29h-33v93h65 v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    d: "M21 0zM250 -120q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-21 -46 -73 -46q-43 0 -62 27t-19 82v283q0 43 21 69t63 26q28 0 45.5 -13.5t29.5 -39.5h4l2 49h64v-603zM94 125q0 -31 9 -45t31 -14q25 0 33.5 19.5t13.5 48.5v221 q-5 29 -13 49.5t-33 20.5q-41 0 -41 -49v-251zM168.001 699.989q-15.999 -4 -23.998 -13q-8 -8.99902 -8 -29.998v-28.998h32.998v-92.9941h-64.9961v103.993q0 46.9971 14.999 68.9961t48.9971 26.998v-34.9971z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 280,
    d: "M185 0v319h-90v-319h-76v498h-20v46h20v120h76v-120h90v120h76v-120h19v-46h-19v-498h-76zM185 387v111h-90v-111h90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 273,
    d: "M93 554v-115h4q20 48 75 48q45 0 63 -28t18 -70v-389h-73v379q0 45 -40 45q-21 0 -33 -13.5t-14 -45.5v-365h-72v554h-21v46h21v72h72v-72h84v-46h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u045B",
    horizAdvX: 273,
    d: "M93 554v-115h4q20 48 75 48q45 0 63 -28t18 -70v-389h-73v379q0 45 -40 45q-21 0 -33 -13.5t-14 -45.5v-365h-72v554h-21v46h21v72h72v-72h84v-46h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 152,
    d: "M0 0zM38 0v664h76v-664h-76zM178 739q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 182,
    d: "M0 0zM193 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23zM54 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 155,
    d: "M0 0zM39 0v664h76v-664h-76zM-11 716v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 150,
    d: "M0 0zM-14 547v46h178v-46h-178zM38 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 157,
    d: "M0 0zM40 0v664h76v-664h-76zM78 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 177,
    d: "M0 0zM87 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34zM52 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 121,
    d: "M100 -208q-9 -5 -22 -7.5t-27 -2.5q-36 0 -53.5 16t-17.5 57v29q0 42 22 69.5t60 41.5v5h-36v664h76v-664q-72 -36 -72 -96v-27q0 -18 8.5 -24.5t27.5 -6.5q8 0 17.5 1t16.5 4v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 121,
    d: "M99 -208q-19 -10 -49 -10q-36 0 -53.5 16t-17.5 57v29q0 42 21 69t59 42v5h-31v483h72v-483q-71 -36 -71 -96v-27q0 -18 8.5 -24.5t26.5 -6.5q9 0 18.5 1t16.5 4v-59zM28 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 114,
    d: "M19 0zM19 0v664h76v-664h-76zM21 704v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 114,
    d: "M21 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 373,
    d: "M19 0zM19 0v664h76v-664h-76zM280 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-116 0 -116 125v122h71v-126q0 -52 44 -52q45 0 45 52v547z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 256,
    d: "M21 0v483h72v-483h-72zM21 535v93h72v-93h-72zM22 -52h72v-72q0 -44 34 -44t34 44v607h73v-607q0 -54 -26 -81.5t-82 -27.5q-55 0 -80 27.5t-25 81.5v72zM162 535v93h73v-93h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 276,
    d: "M19 0zM192 0l-62 284h-3l-31 -85v-199h-77v664h77v-278h4q4 15 10 34.5t16.5 50.5t26.5 77.5t40 115.5h76l-87 -260l86 -404h-76zM101 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 270,
    d: "M21 0zM187 0l-60 200h-4l-30 -64v-136h-72v672h72v-393h4q3 7 7 17.5t13 32t25.5 58t43.5 96.5h78l-85 -199l84 -284h-76zM100 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 224,
    d: "M14 0zM19 0v664h76v-595h116v-69h-192zM42 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 123,
    d: "M6 0zM21 0v672h72v-672h-72zM34 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 224,
    d: "M19 0zM19 0v664h76v-595h116v-69h-192zM80 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 114,
    d: "M21 0zM21 0v672h72v-672h-72zM25 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 232,
    d: "M19 0zM19 0v664h76v-595h116v-69h-192zM131 464q17 10 24.5 25t7.5 40v40h-32v103h74v-134q0 -51 -19 -79.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 197,
    d: "M21 0zM21 0v672h72v-672h-72zM114 464q17 10 24.5 25t7.5 40v40h-32v103h74v-134q0 -51 -19 -79.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 224,
    d: "M19 0v664h76v-182l90 45v-65l-90 -45v-348h116v-69h-192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 156,
    d: "M42 0v292l-38 -16v56l38 16v324h72v-293l38 16v-56l-38 -16v-323h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 294,
    d: "M19 0zM183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM117 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73zM105 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 294,
    d: "M19 0zM183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM111 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73zM104 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 294,
    d: "M19 0zM183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM115 695l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73zM104 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 294,
    d: "M275 -119q0 -58 -31 -86t-85 -28q-12 0 -18.5 0.5t-11.5 2.5v65q4 -2 9.5 -2.5t10.5 -0.5q42 0 42 49v76l-106 563h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-783v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 273,
    d: "M121 -166q5 -2 9.5 -2h9.5q40 0 40 48v499q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-513q0 -57 -28 -85t-76 -28q-19 0 -28 3v64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM47 723v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM46 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM135 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20 t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM134 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54 q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM50 698l66 145l46 -27l-79 -135zM139 698l67 145l46 -27l-80 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM48 522l66 145l46 -27l-79 -135zM137 522l67 145l46 -27l-80 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 365,
    d: "M175 0q-16 -4 -39 -4q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5q10 0 19 -1t17 -3h177v-68h-109q16 -24 16 -59v-155h82v-68h-82v-193q0 -34 -15 -53h113v-68h-178zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 419,
    d: "M400 109q0 -113 -115 -113q-50 0 -75 21q-26 -21 -76 -21q-58 0 -85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27q51 0 76 -22q25 22 75 22q115 0 115 -113v-150h-158v-117q0 -48 43 -48t43 48v59h72v-57zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265z M329 375q0 49 -44 49q-43 0 -43 -49v-99h87v99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 272,
    d: "M19 0zM19 0v664h140q53 0 74 -26.5t21 -74.5v-152q0 -68 -50 -80v-4q25 -5 38.5 -23.5t13.5 -56.5v-247h-74v253q0 22 -8 32t-30 10h-51v-295h-74zM182 554q0 42 -40 42h-49v-239h50q18 0 28.5 10.5t10.5 36.5v150zM98 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 207,
    d: "M21 0zM21 0v483h67l2 -56h4q11 29 28.5 44.5t44.5 15.5q16 0 28 -6v-66q-12 7 -31 7q-31 0 -47.5 -17t-23.5 -62v-343h-72zM76 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 272,
    d: "M19 0zM19 0v664h140q53 0 74 -26.5t21 -74.5v-152q0 -68 -50 -80v-4q25 -5 38.5 -23.5t13.5 -56.5v-247h-74v253q0 22 -8 32t-30 10h-51v-295h-74zM182 554q0 42 -40 42h-49v-239h50q18 0 28.5 10.5t10.5 36.5v150zM103 -183q16 4 24 13t8 30v29h-33v93h65v-104 q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 207,
    d: "M21 0zM21 0v483h67l2 -56h4q11 29 28.5 44.5t44.5 15.5q16 0 28 -6v-66q-12 7 -31 7q-31 0 -47.5 -17t-23.5 -62v-343h-72zM24 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 272,
    d: "M19 0zM19 0v664h140q53 0 74 -26.5t21 -74.5v-152q0 -68 -50 -80v-4q25 -5 38.5 -23.5t13.5 -56.5v-247h-74v253q0 22 -8 32t-30 10h-51v-295h-74zM182 554q0 42 -40 42h-49v-239h50q18 0 28.5 10.5t10.5 36.5v150zM99 695l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 207,
    d: "M6 0zM21 0v483h67l2 -56h4q11 29 28.5 44.5t44.5 15.5q16 0 28 -6v-66q-12 7 -31 7q-31 0 -47.5 -17t-23.5 -62v-343h-72zM74 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 282,
    d: "M16 0zM186 461v85q0 24 -11.5 38t-35.5 14q-23 0 -34.5 -12.5t-11.5 -32.5v-71q0 -29 5.5 -42.5t21.5 -28.5q13 -13 28 -25t30.5 -23t29.5 -22.5t24 -22.5q17 -18 25 -40.5t8 -60.5v-97q0 -61 -29 -92.5t-95 -31.5t-95.5 32.5t-29.5 96.5v74h71v-80q0 -54 51 -54 q48 0 48 49v84q0 35 -6.5 51t-24.5 33q-27 26 -54.5 46.5t-48.5 47.5q-33 43 -33 110v68q0 51 28.5 82.5t90.5 31.5q33 0 56 -9.5t36.5 -27t19.5 -41.5t6 -52v-77h-70zM107 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 265,
    d: "M18 0zM175 335v56q0 37 -42 37q-43 0 -43 -33v-54q0 -17 4.5 -25.5t21.5 -19.5q23 -16 47 -27t46 -27q19 -14 28.5 -33t9.5 -54v-63q0 -49 -27 -72.5t-85 -23.5q-62 0 -89.5 25.5t-27.5 74.5v59h68v-61q0 -20 10.5 -29.5t35.5 -9.5q43 0 43 36v62q0 16 -5.5 26t-25.5 24 q-7 4 -18.5 11t-25 15t-26.5 16.5t-22 16.5q-17 15 -23.5 33.5t-6.5 45.5v60q0 40 27.5 63t81.5 23q56 0 84 -26t28 -73v-53h-68zM100 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 282,
    d: "M16 0zM186 461v85q0 24 -11.5 38t-35.5 14q-23 0 -34.5 -12.5t-11.5 -32.5v-71q0 -29 5.5 -42.5t21.5 -28.5q13 -13 28 -25t30.5 -23t29.5 -22.5t24 -22.5q17 -18 25 -40.5t8 -60.5v-97q0 -61 -29 -92.5t-95 -31.5t-95.5 32.5t-29.5 96.5v74h71v-80q0 -54 51 -54 q48 0 48 49v84q0 35 -6.5 51t-24.5 33q-27 26 -54.5 46.5t-48.5 47.5q-33 43 -33 110v68q0 51 28.5 82.5t90.5 31.5q33 0 56 -9.5t36.5 -27t19.5 -41.5t6 -52v-77h-70zM107 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u0218",
    horizAdvX: 282,
    d: "M16 0zM186 461v85q0 24 -11.5 38t-35.5 14q-23 0 -34.5 -12.5t-11.5 -32.5v-71q0 -29 5.5 -42.5t21.5 -28.5q13 -13 28 -25t30.5 -23t29.5 -22.5t24 -22.5q17 -18 25 -40.5t8 -60.5v-97q0 -61 -29 -92.5t-95 -31.5t-95.5 32.5t-29.5 96.5v74h71v-80q0 -54 51 -54 q48 0 48 49v84q0 35 -6.5 51t-24.5 33q-27 26 -54.5 46.5t-48.5 47.5q-33 43 -33 110v68q0 51 28.5 82.5t90.5 31.5q33 0 56 -9.5t36.5 -27t19.5 -41.5t6 -52v-77h-70zM107 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 265,
    d: "M18 0zM175 335v56q0 37 -42 37q-43 0 -43 -33v-54q0 -17 4.5 -25.5t21.5 -19.5q23 -16 47 -27t46 -27q19 -14 28.5 -33t9.5 -54v-63q0 -49 -27 -72.5t-85 -23.5q-62 0 -89.5 25.5t-27.5 74.5v59h68v-61q0 -20 10.5 -29.5t35.5 -9.5q43 0 43 36v62q0 16 -5.5 26t-25.5 24 q-7 4 -18.5 11t-25 15t-26.5 16.5t-22 16.5q-17 15 -23.5 33.5t-6.5 45.5v60q0 40 27.5 63t81.5 23q56 0 84 -26t28 -73v-53h-68zM101 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u0219",
    horizAdvX: 265,
    d: "M18 0zM175 335v56q0 37 -42 37q-43 0 -43 -33v-54q0 -17 4.5 -25.5t21.5 -19.5q23 -16 47 -27t46 -27q19 -14 28.5 -33t9.5 -54v-63q0 -49 -27 -72.5t-85 -23.5q-62 0 -89.5 25.5t-27.5 74.5v59h68v-61q0 -20 10.5 -29.5t35.5 -9.5q43 0 43 36v62q0 16 -5.5 26t-25.5 24 q-7 4 -18.5 11t-25 15t-26.5 16.5t-22 16.5q-17 15 -23.5 33.5t-6.5 45.5v60q0 40 27.5 63t81.5 23q56 0 84 -26t28 -73v-53h-68zM101 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 282,
    d: "M16 0zM186 461v85q0 24 -11.5 38t-35.5 14q-23 0 -34.5 -12.5t-11.5 -32.5v-71q0 -29 5.5 -42.5t21.5 -28.5q13 -13 28 -25t30.5 -23t29.5 -22.5t24 -22.5q17 -18 25 -40.5t8 -60.5v-97q0 -61 -29 -92.5t-95 -31.5t-95.5 32.5t-29.5 96.5v74h71v-80q0 -54 51 -54 q48 0 48 49v84q0 35 -6.5 51t-24.5 33q-27 26 -54.5 46.5t-48.5 47.5q-33 43 -33 110v68q0 51 28.5 82.5t90.5 31.5q33 0 56 -9.5t36.5 -27t19.5 -41.5t6 -52v-77h-70zM108 695l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 265,
    d: "M18 0zM175 335v56q0 37 -42 37q-43 0 -43 -33v-54q0 -17 4.5 -25.5t21.5 -19.5q23 -16 47 -27t46 -27q19 -14 28.5 -33t9.5 -54v-63q0 -49 -27 -72.5t-85 -23.5q-62 0 -89.5 25.5t-27.5 74.5v59h68v-61q0 -20 10.5 -29.5t35.5 -9.5q43 0 43 36v62q0 16 -5.5 26t-25.5 24 q-7 4 -18.5 11t-25 15t-26.5 16.5t-22 16.5q-17 15 -23.5 33.5t-6.5 45.5v60q0 40 27.5 63t81.5 23q56 0 84 -26t28 -73v-53h-68zM98 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u0162",
    horizAdvX: 263,
    d: "M13 0zM93 0v596h-80v68h237v-68h-82v-596h-75zM99 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u021A",
    horizAdvX: 263,
    d: "M13 0zM93 0v596h-80v68h237v-68h-82v-596h-75zM99 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u0163",
    horizAdvX: 257,
    d: "M21 0zM174 274h62v-165q0 -58 -22 -85.5t-80 -27.5q-59 0 -86 27.5t-27 85.5v507h71v-133h144v-65h-144v-309q0 -48 43 -48q21 0 30 11.5t9 36.5v165zM98 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u021B",
    horizAdvX: 257,
    d: "M21 0zM174 274h62v-165q0 -58 -22 -85.5t-80 -27.5q-59 0 -86 27.5t-27 85.5v507h71v-133h144v-65h-144v-309q0 -48 43 -48q21 0 30 11.5t9 36.5v165zM98 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 263,
    d: "M13 0zM93 0v596h-80v68h237v-68h-82v-596h-75zM98 690l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 330,
    d: "M21 0zM174 274h62v-165q0 -58 -22 -85.5t-80 -27.5q-59 0 -86 27.5t-27 85.5v507h71v-133h144v-65h-144v-309q0 -48 43 -48q21 0 30 11.5t9 36.5v165zM247 464q17 10 24.5 25t7.5 40v40h-32v103h74v-134q0 -51 -19 -79.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 263,
    d: "M93 0v329h-50v46h50v221h-80v68h237v-68h-82v-221h52v-46h-52v-329h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 257,
    d: "M92 316v-207q0 -48 43 -48q21 0 30 11.5t9 36.5v153h62v-153q0 -58 -22 -85.5t-80 -27.5q-59 0 -86 27.5t-27 85.5v507h71v-133h144v-65h-144v-60h136v-42h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM240 746q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4 t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM239 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5 t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM50 723v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM48 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM136 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM135 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM138 712q17 0 25 12t8 32t-8 32t-25 12t-25 -12t-8 -32t8 -32t25 -12zM138 681q-33 0 -49 20.5t-16 54.5t16 54.5t49 20.5t49 -20.5t16 -54.5 t-16 -54.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM137 536q17 0 25 12t8 32t-8 32t-25 12t-25 -12t-8 -32t8 -32t25 -12zM137 505q-33 0 -49 20.5t-16 54.5t16 54.5t49 20.5 t49 -20.5t16 -54.5t-16 -54.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM52 698l66 145l46 -27l-79 -135zM141 698l67 145l46 -27l-80 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM51 522l66 145l46 -27l-79 -135zM140 522l67 145l46 -27l-80 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 276,
    d: "M172 -208q-19 -10 -49 -10q-36 0 -53.5 16t-17.5 57v29q0 39 19 65.5t51 41.5v6q-103 8 -103 124v543h74v-547q0 -52 44 -52q45 0 45 52v547h74v-541q0 -53 -21.5 -83t-63.5 -43q-38 -11 -53.5 -36.5t-15.5 -56.5v-27q0 -18 8.5 -24.5t26.5 -6.5q9 0 18.5 1t16.5 4v-59z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 272,
    d: "M250 -208q-19 -10 -49 -10q-36 0 -53.5 16t-17.5 57v29q0 42 21.5 69.5t59.5 41.5v5h-27l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483q-71 -36 -71 -96v-27q0 -18 8.5 -24.5t26.5 -6.5 q9 0 18.5 1t16.5 4v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 410,
    d: "M7 0zM62 0l-55 664h73l35 -522h4l43 522h86l45 -522h4l34 522h71l-55 -664h-99l-41 522h-4l-41 -522h-100zM273 682l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 375,
    d: "M6 0zM55 0l-49 483h68l32 -364h4l37 364h80l39 -364h4l31 364h67l-49 -483h-92l-38 370h-4l-38 -370h-92zM256 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 276,
    d: "M6 0zM102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75zM210 682l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    d: "M21 0zM94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368zM209 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 276,
    d: "M6 0zM102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75zM49 704v93h67v-93h-67zM163 704v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u03AB",
    horizAdvX: 276,
    d: "M6 0zM102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75zM49 704v93h67v-93h-67zM163 704v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 252,
    d: "M13 0zM13 0v69l148 527h-147v68h222v-68l-146 -528h150v-68h-227zM96 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 230,
    d: "M14 0zM14 0v68l126 350h-124v65h197v-65l-125 -352h128v-66h-202zM84 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 252,
    d: "M13 0zM13 0v69l148 527h-147v68h222v-68l-146 -528h150v-68h-227zM87 711v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 230,
    d: "M14 0zM14 0v68l126 350h-124v65h197v-65l-125 -352h128v-66h-202zM75 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 252,
    d: "M13 0zM13 0v69l148 527h-147v68h222v-68l-146 -528h150v-68h-227zM94 691l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 230,
    d: "M14 0zM14 0v68l126 350h-124v65h197v-65l-125 -352h128v-66h-202zM82 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018E",
    unicode: "\u018E",
    horizAdvX: 218,
    d: "M198 664v-664h-181v68h107v214h-97v68h97v246h-113v68h187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u018F",
    horizAdvX: 269,
    d: "M21 374q0 113 114 113q113 0 113 -113v-265q0 -113 -113 -113q-114 0 -114 113v151h157v116q0 48 -43 48t-43 -48v-59h-71v57zM92 108q0 -49 43 -49t43 49v99h-86v-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u04D8",
    horizAdvX: 269,
    d: "M21 374q0 113 114 113q113 0 113 -113v-265q0 -113 -113 -113q-114 0 -114 113v151h157v116q0 48 -43 48t-43 -48v-59h-71v57zM92 108q0 -49 43 -49t43 49v99h-86v-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 234,
    d: "M161 400l-45 -494q-4 -45 -24 -62t-62 -17h-26v67h13q26 0 29 24l43 482h-46v47h51l13 146q4 45 24.5 62t62.5 17h29v-67h-16q-28 0 -29 -24l-12 -134h57v-47h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0194",
    unicode: "\u0194",
    horizAdvX: 309,
    d: "M155 -233q-50 0 -69 27t-19 70q0 12 2 28t7.5 48t16 85.5t27.5 141.5l-104 497h76l58 -317h7l59 317h76l-104 -497q17 -84 27.5 -136.5t16 -84t7.5 -49t2 -30.5q0 -45 -18 -72.5t-68 -27.5zM151 -1q-6 -30 -10.5 -51.5t-7.5 -37.5t-4.5 -27.5t-1.5 -21.5q0 -41 27 -41 q15 0 21 10t6 32q0 10 -1.5 21.5t-5 27t-8 37t-10.5 51.5h-5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni019D",
    unicode: "\u019D",
    horizAdvX: 294,
    d: "M183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-452q0 -57 -25 -85t-68 -28q-18 0 -25 3v64q4 -2 8.5 -2h8.5q36 0 36 48v784h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohorn",
    unicode: "\u01A0",
    horizAdvX: 315,
    d: "M255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 63 31 96t87 33q23 0 48 -3.5t47 -3.5q23 0 31 7.5t8 27.5q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55.5t-38.5 -17.5q-12 0 -30 3q24 -30 24 -82v-417zM180 545q0 53 -45 53 q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohorn",
    unicode: "\u01A1",
    horizAdvX: 303,
    d: "M247 109q0 -59 -27 -86t-86 -27q-58 0 -85.5 27t-27.5 86v265q0 113 109 113q26 0 47.5 -4t41.5 -4q21 0 29 8t8 28q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55.5t-37 -17.5h-9t-9 1q14 -26 14 -63v-265zM177 374q0 48 -43 48t-43 -48v-265 q0 -48 43 -48t43 48v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhorn",
    unicode: "\u01AF",
    horizAdvX: 342,
    d: "M182 664h82q17 0 24 7.5t7 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55t-37.5 -17q-13 0 -33 5v-500q0 -127 -118 -127q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhorn",
    unicode: "\u01B0",
    horizAdvX: 334,
    d: "M94 483v-380q0 -44 39 -44q19 0 29 10.5t17 34.5v379h79q16 0 22.5 7.5t6.5 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55t-38 -17q-7 0 -14.5 1t-15.5 3v-441h-67l-2 49h-3q-11 -25 -28.5 -39.5t-46.5 -14.5q-25 0 -41 9.5t-25.5 26t-13 40 t-3.5 50.5v362h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u01DD",
    horizAdvX: 269,
    d: "M21 374q0 113 114 113q113 0 113 -113v-265q0 -113 -113 -113q-114 0 -114 113v151h157v116q0 48 -43 48t-43 -48v-59h-71v57zM92 108q0 -49 43 -49t43 49v99h-86v-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u04D9",
    horizAdvX: 269,
    d: "M21 374q0 113 114 113q113 0 113 -113v-265q0 -113 -113 -113q-114 0 -114 113v151h157v116q0 48 -43 48t-43 -48v-59h-71v57zM92 108q0 -49 43 -49t43 49v99h-86v-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E6",
    unicode: "\u01E6",
    horizAdvX: 272,
    d: "M19 0zM204 0l-4 35h-3q-9 -17 -25 -28t-47 -11q-51 0 -78.5 32.5t-27.5 94.5v416q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 43 -52q38 0 45 46v167h-50v67h121v-345h-49zM107 695l-68 99l32 25l69 -81l69 81 l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E7",
    unicode: "\u01E7",
    d: "M21 0zM250 -120q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-21 -46 -73 -46q-43 0 -62 27t-19 82v283q0 43 21 69t63 26q28 0 45.5 -13.5t29.5 -39.5h4l2 49h64v-603zM94 125q0 -31 9 -45t31 -14q25 0 33.5 19.5t13.5 48.5v221 q-5 29 -13 49.5t-33 20.5q-41 0 -41 -49v-251zM104 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F4",
    unicode: "\u01F4",
    horizAdvX: 272,
    d: "M19 0zM204 0l-4 35h-3q-9 -17 -25 -28t-47 -11q-51 0 -78.5 32.5t-27.5 94.5v416q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 43 -52q38 0 45 46v167h-50v67h121v-345h-49zM107 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F5",
    unicode: "\u01F5",
    d: "M21 0zM250 -120q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-21 -46 -73 -46q-43 0 -62 27t-19 82v283q0 43 21 69t63 26q28 0 45.5 -13.5t29.5 -39.5h4l2 49h64v-603zM94 125q0 -31 9 -45t31 -14q25 0 33.5 19.5t13.5 48.5v221 q-5 29 -13 49.5t-33 20.5q-41 0 -41 -49v-251zM107 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F8",
    unicode: "\u01F8",
    horizAdvX: 294,
    d: "M19 0zM183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM61 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F9",
    unicode: "\u01F9",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73zM49 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 127,
    d: "M-122 -27h69v-93q0 -48 43 -48q44 0 44 48v603h72v-603q0 -113 -115 -113q-59 0 -86 28t-27 85v93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0241",
    unicode: "\u0241",
    horizAdvX: 257,
    d: "M88 0v218q0 35 4 56t12 38q11 25 28.5 49t27.5 45q5 12 7.5 26t2.5 37v80q0 26 -8.5 37.5t-33.5 11.5q-29 0 -37 -14.5t-8 -45.5v-67h-71v65q0 33 4 57.5t16.5 41t35.5 25t60 8.5q35 0 57 -7.5t34.5 -22.5t17 -37.5t4.5 -53.5v-72q0 -17 -1 -29.5t-2.5 -21.5t-4 -17 t-6.5 -16q-11 -25 -26.5 -44.5t-26.5 -44.5q-6 -14 -8 -29.5t-2 -51.5v-221h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0242",
    unicode: "\u0242",
    horizAdvX: 268,
    d: "M97 0v101q0 16 3.5 30t8.5 25q11 25 28.5 45t28.5 40q11 19 11 41v96q0 26 -9 37.5t-33 11.5q-26 0 -35 -13t-9 -40v-72h-69v62q0 68 24.5 98t87.5 30q61 0 87 -27.5t26 -87.5v-96q0 -28 -10 -48q-12 -27 -30.5 -46.5t-29.5 -45.5q-8 -19 -8 -40v-101h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024C",
    unicode: "\u024C",
    horizAdvX: 299,
    d: "M46 0v295h-43v62h43v307h140q53 0 74 -26.5t21 -74.5v-152q0 -34 -13.5 -54t-37.5 -26v-4q26 -5 39.5 -23.5t13.5 -56.5v-247h-74v253q0 22 -8 32t-30 10h-51v-295h-74zM208 554q0 21 -9 31.5t-30 10.5h-49v-239h49q18 0 28.5 10.5t10.5 36.5v150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024D",
    unicode: "\u024D",
    horizAdvX: 222,
    d: "M36 0v199h-32v46h32v238h67l2 -56h4q11 29 28.5 44.5t44.5 15.5q16 0 28 -6v-66q-12 7 -31 7q-31 0 -47.5 -17t-23.5 -62v-98h73v-46h-73v-199h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0263",
    unicode: "\u0263",
    horizAdvX: 266,
    d: "M164 95l33 -151q5 -25 9 -46.5t4 -40.5q0 -90 -78 -90q-76 0 -76 89q0 20 4 41.5t9 46.5l32 148l-95 391h74l49 -242h6l51 242h73zM129 -40q-11 -48 -15.5 -72.5t-4.5 -37.5q0 -18 5 -25.5t18 -7.5q24 0 24 32q0 11 -4.5 37t-16.5 74h-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0272",
    unicode: "\u0272",
    horizAdvX: 273,
    d: "M180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-499q0 -57 -27.5 -85t-75.5 -28q-19 0 -28 3v64q5 -2 9.5 -2h9.5q40 0 40 48v603h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 244,
    d: "M191 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 242,
    d: "M89 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 0,
    d: "M-48 547zM-226 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 248,
    d: "M123 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 111,
    d: "M19 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 169,
    d: "M84 536q17 0 25 12t8 32t-8 32t-25 12t-25 -12t-8 -32t8 -32t25 -12zM84 505q-33 0 -49 20.5t-16 54.5t16 54.5t49 20.5t49 -20.5t16 -54.5t-16 -54.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 154,
    d: "M133 -208q-9 -5 -22 -7.5t-27 -2.5q-35 0 -53 16t-18 57v29q0 45 26 73.5t70 42.5h26q-72 -36 -72 -96v-27q0 -18 8.5 -24.5t27.5 -6.5q8 0 18 1t16 4v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 244,
    d: "M224 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 241,
    d: "M20 522l66 145l46 -27l-79 -135zM109 522l67 145l46 -27l-80 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M-77 505zM-226 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M-58 505zM-179 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M-37 506zM-68 506l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M-35 521zM-35 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M-48 547zM-226 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M-34 505zM-138 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M-101 535zM-173 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M-47 535zM-228 535v93h67v-93h-67zM-114 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb",
    unicode: "\u0309",
    horizAdvX: 0,
    d: "M-164 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M-72 505zM-137 536q17 0 25 12t8 32t-8 32t-25 12t-25 -12t-8 -32t8 -32t25 -12zM-137 505q-33 0 -49 20.5t-16 54.5t16 54.5t49 20.5t49 -20.5t16 -54.5t-16 -54.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M-31 505zM-233 522l66 145l46 -27l-79 -135zM-144 522l67 145l46 -27l-80 -135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M-37 519zM-170 519l-68 99l32 25l69 -81l69 81l31 -25l-67 -99h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0313",
    unicode: "\u0313",
    horizAdvX: 0,
    d: "M-104 514zM-104.999 679.989q-15.999 -4 -23.998 -13q-8 -8.99902 -8 -29.998v-28.998h32.998v-92.9941h-64.9961v103.993q0 46.9971 14.999 68.9961t48.9971 26.998v-34.9971z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B",
    unicode: "\u031B",
    horizAdvX: 53,
    d: "M-80 483q28 -3 53 -3q21 0 27 7t6 26q0 12 -1 22.5t-3 18.5h40q7 -16 7 -46q0 -38 -12 -55t-38 -17q-17 0 -38.5 6.5t-40.5 14.5v26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    horizAdvX: 0,
    d: "M-172 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M-105 -18zM-169 -183q16 4 24 13t8 30v29h-33v93h65v-104q0 -47 -15 -69t-49 -27v35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M-76 0zM-78 -208q-9 -5 -22 -7.5t-27 -2.5q-35 0 -53 16t-18 57v29q0 45 26 73.5t70 42.5h26q-72 -36 -72 -96v-27q0 -18 8.5 -24.5t27.5 -6.5q8 0 18 1t16 4v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032D",
    unicode: "\u032D",
    horizAdvX: 0,
    d: "M-37 -57zM-68 -189l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tonos",
    unicode: "\u0384",
    horizAdvX: 75,
    d: "M12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresistonos",
    unicode: "\u0385",
    horizAdvX: 0,
    d: "M-15 525zM-158 525v181h59l-14 -181h-45zM-253 535v93h72v-93h-72zM-87 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Alphatonos",
    unicode: "\u0386",
    horizAdvX: 303,
    d: "M12 0zM220 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM128 227h68l-32 315h-4zM12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "anoteleia",
    unicode: "\u0387",
    horizAdvX: 112,
    d: "M19 326zM19 326v103h74v-103h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Epsilontonos",
    unicode: "\u0388",
    horizAdvX: 282,
    d: "M12 0zM82 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etatonos",
    unicode: "\u0389",
    horizAdvX: 342,
    d: "M12 0zM247 0v319h-90v-319h-76v664h76v-277h90v277h76v-664h-76zM12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iotatonos",
    unicode: "\u038A",
    horizAdvX: 176,
    d: "M12 0zM81 0v664h76v-664h-76zM12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omicrontonos",
    unicode: "\u038C",
    horizAdvX: 330,
    d: "M12 0zM314 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM239 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilontonos",
    unicode: "\u038E",
    horizAdvX: 349,
    d: "M12 0zM175 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75zM12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omegatonos",
    unicode: "\u038F",
    horizAdvX: 350,
    d: "M12 0zM221 0v61q17 8 25 38t8 91v359q0 49 -49 49t-49 -49v-359q0 -61 8 -91t25 -38v-61h-118v65h53v4q-22 18 -33.5 46t-11.5 76v366q0 55 33 83t93 28t93 -28t33 -83v-366q0 -48 -11.5 -76t-33.5 -46v-4h53v-65h-118zM12 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresistonos",
    unicode: "\u0390",
    horizAdvX: 224,
    d: "M0 0zM162 0q-89 0 -89 91v392h72v-392q0 -27 18 -27h12v-64h-13zM87 525v181h59l-14 -181h-45zM-8 535v93h72v-93h-72zM158 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0393",
    horizAdvX: 224,
    d: "M19 0v664h192v-69h-116v-595h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 224,
    d: "M19 0v664h192v-69h-116v-595h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    horizAdvX: 279,
    d: "M7 0l78 664h107l79 -664h-264zM140 542h-4l-48 -473h101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Theta",
    unicode: "\u0398",
    d: "M255 121q0 -64 -31 -94.5t-88 -30.5q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM100 314v68h71v-68h-71zM185 545q0 53 -50 53t-50 -53v-428q0 -52 51 -52q49 0 49 52v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lambda",
    unicode: "\u039B",
    horizAdvX: 279,
    d: "M193 664l78 -664h-75l-56 530h-4l-55 -530h-73l78 664h107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Xi",
    unicode: "\u039E",
    horizAdvX: 218,
    d: "M11 0v68h196v-68h-196zM27 314v68h164v-68h-164zM17 596v68h184v-68h-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u03A0",
    horizAdvX: 280,
    d: "M185 0v596h-90v-596h-76v664h242v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 280,
    d: "M185 0v596h-90v-596h-76v664h242v-664h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sigma",
    unicode: "\u03A3",
    horizAdvX: 218,
    d: "M13 0v68l77 267l-78 264v65h189v-68h-116l75 -260l-76 -268h122v-68h-193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u03A6",
    horizAdvX: 384,
    d: "M156 0v134h-47q-52 0 -73.5 26.5t-21.5 74.5v229q0 48 21.5 74.5t73.5 26.5h47v99h73v-99h46q52 0 73.5 -26.5t21.5 -74.5v-229q0 -48 -21.5 -74.5t-73.5 -26.5h-46v-134h-73zM303 453q0 47 -40 47h-34v-301h34q40 0 40 47v207zM156 500h-36q-39 0 -39 -47v-207 q0 -47 39 -47h36v301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 384,
    d: "M156 0v134h-47q-52 0 -73.5 26.5t-21.5 74.5v229q0 48 21.5 74.5t73.5 26.5h47v99h73v-99h46q52 0 73.5 -26.5t21.5 -74.5v-229q0 -48 -21.5 -74.5t-73.5 -26.5h-46v-134h-73zM303 453q0 47 -40 47h-34v-301h34q40 0 40 47v207zM156 500h-36q-39 0 -39 -47v-207 q0 -47 39 -47h36v301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Psi",
    unicode: "\u03A8",
    horizAdvX: 390,
    d: "M158 0v145h-46q-52 0 -73.5 26.5t-21.5 74.5v418h66v-407q0 -47 40 -47h35v454h73v-454h35q40 0 40 47v407h67v-418q0 -48 -21.5 -74.5t-74.5 -26.5h-46v-145h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 290,
    d: "M161 0v61q17 8 25 38t8 91v359q0 49 -49 49t-49 -49v-359q0 -61 8 -91t25 -38v-61h-118v65h53v4q-22 18 -33.5 46t-11.5 76v366q0 55 33 83t93 28t93 -28t33 -83v-366q0 -48 -11.5 -76t-33.5 -46v-4h53v-65h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alphatonos",
    unicode: "\u03AC",
    horizAdvX: 290,
    d: "M21 0zM267 0q-35 0 -53.5 11.5t-24.5 37.5h-4q-23 -53 -82 -53q-48 0 -65 32.5t-17 88.5v277q0 45 22 69t62 24q28 0 45.5 -12.5t29.5 -40.5h4l2 49h64v-391q0 -28 17 -28h12v-64h-12zM94 107q0 -26 10.5 -37t30.5 -11q21 0 30.5 12t15.5 40v262q-7 29 -16.5 40.5 t-29.5 11.5q-41 0 -41 -49v-269zM110 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilontonos",
    unicode: "\u03AD",
    horizAdvX: 264,
    d: "M19 0zM108 525v181h59l-14 -181h-45zM244 93q0 -97 -111 -97q-60 0 -87 24.5t-27 68.5v92q0 38 17 53.5t40 19.5v4q-50 9 -50 62v77q0 90 106 90q56 0 84 -24.5t28 -71.5v-69h-69v63q0 40 -42 40q-41 0 -41 -41v-70q0 -17 10 -26t34 -9h30v-48h-29q-48 0 -48 -42v-91 q0 -40 43 -40t43 47v68h69v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etatonos",
    unicode: "\u03AE",
    horizAdvX: 273,
    d: "M21 0zM180 -233v612q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-626h-73zM112 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotatonos",
    unicode: "\u03AF",
    horizAdvX: 134,
    d: "M21 0zM110 0q-89 0 -89 91v392h72v-392q0 -27 18 -27h12v-64h-13zM36 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresistonos",
    unicode: "\u03B0",
    horizAdvX: 266,
    d: "M12 0zM107 525v181h59l-14 -181h-45zM176 483h69v-374q0 -59 -27 -86t-86 -27q-57 0 -84 27t-27 86v374h70v-374q0 -48 43 -48q42 0 42 48v374zM12 535v93h72v-93h-72zM178 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alpha",
    unicode: "\u03B1",
    horizAdvX: 290,
    d: "M267 0q-35 0 -53.5 11.5t-24.5 37.5h-4q-23 -53 -82 -53q-48 0 -65 32.5t-17 88.5v277q0 45 22 69t62 24q28 0 45.5 -12.5t29.5 -40.5h4l2 49h64v-391q0 -28 17 -28h12v-64h-12zM94 107q0 -26 10.5 -37t30.5 -11q21 0 30.5 12t15.5 40v262q-7 29 -16.5 40.5t-29.5 11.5 q-41 0 -41 -49v-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "beta",
    unicode: "\u03B2",
    horizAdvX: 272,
    d: "M21 -233v817q0 49 26 70.5t89 21.5q58 0 84.5 -20t26.5 -71v-148q0 -55 -51 -69v-4q26 -8 40.5 -28.5t14.5 -58.5v-168q0 -33 -8 -55t-21.5 -34.5t-31.5 -18t-38 -5.5q-18 0 -31.5 5t-23.5 13h-5v-247h-71zM179 264q0 14 -1 27t-5.5 22.5t-13.5 15t-24 5.5h-12v57h12 q30 0 36.5 14t6.5 34v125q0 24 -8.5 35.5t-34.5 11.5t-34.5 -11.5t-8.5 -35.5v-480q8 -10 19.5 -17.5t25.5 -7.5q19 0 30.5 10t11.5 37v158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u03B3",
    horizAdvX: 255,
    d: "M93 -233v193l-87 523h74l48 -370h4l47 370h70l-85 -523v-193h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 255,
    d: "M93 -233v193l-87 523h74l48 -370h4l47 370h70l-85 -523v-193h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "delta",
    unicode: "\u03B4",
    horizAdvX: 268,
    d: "M21 339q0 29 11.5 50.5t30.5 34.5v7q-14 11 -20.5 25.5t-6.5 38.5v81q0 52 30.5 76t90.5 24q13 0 30.5 -1t31.5 -3v-65q-13 4 -28.5 5.5t-28.5 1.5q-31 0 -44 -9.5t-13 -28.5v-78q0 -16 7 -25t24 -18q14 -7 37.5 -19t38.5 -24q17 -13 26 -35t9 -62v-206q0 -59 -27 -86 t-86 -27t-86 27t-27 86v230zM177 318q0 26 -7 38.5t-21 22.5q-7 5 -15.5 9t-16.5 9q-12 -9 -19 -24t-7 -35v-229q0 -48 43 -48t43 48v209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilon",
    unicode: "\u03B5",
    horizAdvX: 264,
    d: "M244 93q0 -97 -111 -97q-60 0 -87 24.5t-27 68.5v92q0 38 17 53.5t40 19.5v4q-50 9 -50 62v77q0 90 106 90q56 0 84 -24.5t28 -71.5v-69h-69v63q0 40 -42 40q-41 0 -41 -41v-70q0 -17 10 -26t34 -9h30v-48h-29q-48 0 -48 -42v-91q0 -40 43 -40t43 47v68h69v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeta",
    unicode: "\u03B6",
    horizAdvX: 243,
    d: "M150 -182v168q0 14 -13 14h-47q-69 0 -69 73v184q0 36 5.5 59.5t18.5 50.5l114 240h-130v65h201v-65l-123 -267q-8 -16 -11 -32.5t-3 -41.5v-175q0 -27 24 -27h56q49 0 49 -56v-190h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eta",
    unicode: "\u03B7",
    horizAdvX: 273,
    d: "M180 -233v612q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-626h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "theta",
    unicode: "\u03B8",
    horizAdvX: 268,
    d: "M21 560q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-451q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v451zM177 320h-86v-211q0 -48 43 -48t43 48v211zM177 560q0 49 -43 49t-43 -49v-185h86v185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iota",
    unicode: "\u03B9",
    horizAdvX: 134,
    d: "M110 0q-89 0 -89 91v392h72v-392q0 -27 18 -27h12v-64h-13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u03BA",
    horizAdvX: 270,
    d: "M187 0l-60 200h-4l-30 -64v-136h-72v483h72v-206h4q2 6 5 15.5t11.5 30.5t25.5 59t47 101h78l-85 -199l84 -284h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 270,
    d: "M187 0l-60 200h-4l-30 -64v-136h-72v483h72v-206h4q2 6 5 15.5t11.5 30.5t25.5 59t47 101h78l-85 -199l84 -284h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lambda",
    unicode: "\u03BB",
    d: "M260 0h-26q-32 0 -45 13t-17 37l-38 261h-5l-51 -311h-72l94 499l-12 88q-3 21 -23 21h-17v64h37q35 0 51 -12.5t21 -50.5l76 -528q3 -17 19 -17h8v-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 272,
    d: "M21 -233v716h73v-380q0 -44 39 -44q20 0 30 12t16 35v377h72v-483h-67l-2 49h-4q-11 -24 -25.5 -37.5t-35.5 -13.5q-8 0 -16 1.5t-13 6.5h-4l10 -239h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "xi",
    unicode: "\u03BE",
    horizAdvX: 258,
    d: "M161 -182v168q0 14 -12 14h-59q-69 0 -69 73v236q0 38 16.5 53.5t39.5 20.5v4q-49 10 -49 61v138q0 90 106 90q56 0 83.5 -24.5t27.5 -71.5v-71h-69v65q0 40 -41 40t-41 -41v-131q0 -17 10 -26t33 -9h29v-48h-26q-47 0 -47 -42v-226q0 -27 24 -27h67q49 0 49 -56v-190 h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 334,
    d: "M293 0q-89 0 -89 91v327h-76v-418h-72v418h-45v65h311v-65h-47v-327q0 -27 19 -27h11v-64h-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rho",
    unicode: "\u03C1",
    horizAdvX: 268,
    d: "M177 374q0 48 -43 48t-43 -48v-270q6 -24 15.5 -34.5t29.5 -10.5t30.5 11t10.5 37v267zM21 -233v607q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-284q0 -45 -21 -69.5t-59 -24.5q-51 0 -71 45h-4v-274h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma1",
    unicode: "\u03C2",
    horizAdvX: 266,
    d: "M172 -182v168q0 14 -12 14h-70q-69 0 -69 73v301q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-283q0 -27 24 -27h81q49 0 49 -56v-190h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma",
    unicode: "\u03C3",
    horizAdvX: 284,
    d: "M272 418h-35q7 -18 7 -47v-262q0 -58 -25.5 -85.5t-84.5 -27.5t-86 27.5t-27 85.5v261q0 58 27 85.5t86 27.5h138v-65zM176 371q0 29 -9 47q-17 0 -31 -1t-24 -5.5t-15.5 -14.5t-5.5 -27v-261q0 -24 10 -36t33 -12t32.5 12t9.5 36v262z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tau",
    unicode: "\u03C4",
    horizAdvX: 214,
    d: "M161 0q-90 0 -90 91v327h-60v65h192v-65h-60v-327q0 -27 19 -27h11v-64h-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilon",
    unicode: "\u03C5",
    horizAdvX: 266,
    d: "M176 483h69v-374q0 -59 -27 -86t-86 -27q-57 0 -84 27t-27 86v374h70v-374q0 -48 43 -48q42 0 42 48v374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u03C6",
    horizAdvX: 381,
    d: "M156 -233v233h-60q-34 0 -54.5 23t-20.5 63v311q0 40 20.5 63t54.5 23h60v189h69v-189h60q34 0 54.5 -23t20.5 -63v-311q0 -40 -20.5 -63t-54.5 -23h-60v-233h-69zM156 423h-36q-32 0 -32 -40v-283q0 -40 32 -40h36v363zM225 60h36q32 0 32 40v283q0 40 -32 40h-36v-363z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 381,
    d: "M156 -233v233h-60q-34 0 -54.5 23t-20.5 63v311q0 40 20.5 63t54.5 23h60v189h69v-189h60q34 0 54.5 -23t20.5 -63v-311q0 -40 -20.5 -63t-54.5 -23h-60v-233h-69zM156 423h-36q-32 0 -32 -40v-283q0 -40 32 -40h36v363zM225 60h36q32 0 32 40v283q0 40 -32 40h-36v-363z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "chi",
    unicode: "\u03C7",
    horizAdvX: 267,
    d: "M186 -233l-51 267h-4l-50 -267h-75l81 363l-78 353h74l51 -253h4l48 253h73l-78 -343l81 -373h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omega",
    unicode: "\u03C9",
    horizAdvX: 392,
    d: "M301 396q0 54 -18 87h69q19 -26 19 -87v-284q0 -62 -21.5 -89t-66.5 -27q-26 0 -47 9.5t-38 32.5h-4q-17 -23 -38 -32.5t-47 -9.5q-45 0 -66.5 27t-21.5 89v284q0 61 19 87h69q-18 -33 -18 -87v-286q0 -49 36 -49q38 0 38 49v230h62v-230q0 -49 38 -49q36 0 36 49v286z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresis",
    unicode: "\u03CA",
    horizAdvX: 177,
    d: "M0 0zM138 0q-89 0 -89 91v392h72v-392q0 -27 18 -27h12v-64h-13zM-5 535v93h67v-93h-67zM109 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresis",
    unicode: "\u03CB",
    horizAdvX: 266,
    d: "M21 0zM176 483h69v-374q0 -59 -27 -86t-86 -27q-57 0 -84 27t-27 86v374h70v-374q0 -48 43 -48q42 0 42 48v374zM43 535v93h67v-93h-67zM157 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omicrontonos",
    unicode: "\u03CC",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM109 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilontonos",
    unicode: "\u03CD",
    horizAdvX: 266,
    d: "M21 0zM106 525v181h59l-14 -181h-45zM176 483h69v-374q0 -59 -27 -86t-86 -27q-57 0 -84 27t-27 86v374h70v-374q0 -48 43 -48q42 0 42 48v374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omegatonos",
    unicode: "\u03CE",
    horizAdvX: 392,
    d: "M21 0zM301 396q0 54 -18 87h69q19 -26 19 -87v-284q0 -62 -21.5 -89t-66.5 -27q-26 0 -47 9.5t-38 32.5h-4q-17 -23 -38 -32.5t-47 -9.5q-45 0 -66.5 27t-21.5 89v284q0 61 19 87h69q-18 -33 -18 -87v-286q0 -49 36 -49q38 0 38 49v230h62v-230q0 -49 38 -49q36 0 36 49 v286zM167 525v181h59l-14 -181h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 326,
    d: "M76 596h-63v68h206v-68h-68v-187h4q16 22 32.5 32.5t43.5 10.5q75 0 75 -89v-483q0 -113 -115 -113t-115 113v80h75v-80q0 -48 39 -48q40 0 40 48v462q0 23 -9.5 32.5t-26.5 9.5q-20 0 -28.5 -11.5t-14.5 -39.5v-333h-75v596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 224,
    d: "M19 0zM83 681l-28 29l111 133l38 -44zM19 0v664h192v-69h-116v-595h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 272,
    d: "M253 121q0 -125 -116 -125q-59 0 -88.5 32.5t-29.5 94.5v416q0 62 30 95.5t86 33.5q58 0 88 -34t30 -96v-62h-71v69q0 53 -44 53t-44 -53v-165h81v-62h-81v-201q0 -52 44 -52t44 52v76h71v-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 465,
    d: "M291 387h64q54 0 75 -24t21 -73v-189q0 -46 -21 -73.5t-75 -27.5h-139v596h-75l-7 -190q-3 -78 -6 -137.5t-7 -103t-9.5 -72t-11.5 -45.5q-11 -29 -30 -38.5t-46 -9.5h-11v69h6q11 0 18 4.5t12 20.5q3 13 6.5 36.5t6.5 61t5.5 90.5t4.5 125l8 257h211v-277zM340 67 q24 0 32 13t8 38v155q0 28 -8 38t-31 10h-50v-254h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 435,
    d: "M261 387h64q54 0 74.5 -24t20.5 -73v-189q0 -46 -21 -73.5t-74 -27.5h-140v321h-90v-321h-76v664h76v-277h90v277h76v-277zM310 67q23 0 31 13t8 38v155q0 28 -8 38t-31 10h-49v-254h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 326,
    d: "M76 596h-63v68h206v-68h-68v-187h4q16 22 32.5 32.5t43.5 10.5q75 0 75 -89v-363h-76v342q0 23 -9.5 32.5t-26.5 9.5t-26 -10t-17 -34v-340h-75v596z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 276,
    d: "M19 0zM192 0l-62 284h-3l-31 -85v-199h-77v664h77v-278h4q4 15 10 34.5t16.5 50.5t26.5 77.5t40 115.5h76l-87 -260l86 -404h-76zM100 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 294,
    d: "M19 0zM61 799l38 44l111 -133l-28 -29zM202 0v467h-3l-101 -467h-79v664h73v-438h4l96 438h83v-664h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 276,
    d: "M19 0zM137 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34zM182 293h-4q-10 -20 -30.5 -30.5t-45.5 -10.5q-83 0 -83 126v286h74v-291q0 -26 9 -39t31 -13q38 0 49 44v299h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5 q-57 0 -88 30.5t-31 94.5v100h74v-104q0 -52 44 -52q45 0 45 52v176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 280,
    d: "M111 -154v154h-92v664h76v-595h90v595h76v-664h-93v-154h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 268,
    d: "M95 595v-208h64q49 0 72 -24.5t23 -78.5v-183q0 -46 -21 -73.5t-74 -27.5h-140v664h192v-69h-116zM144 67q23 0 31 13t8 38v155q0 28 -8 38t-31 10h-49v-254h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 335,
    d: "M267 -154v154h-199v-154h-57v223h9q12 0 19 8q7 7 12 24t9 53.5t7.5 97t6.5 155.5l8 257h210v-595h31v-223h-56zM217 596h-75l-6 -190q-3 -77 -5.5 -134t-6 -97.5t-8 -66.5t-10.5 -39h111v527z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 436,
    d: "M6 0l115 338l-111 326h78l89 -264h4v264h74v-264h4l90 264h77l-111 -326l115 -338h-79l-92 289h-4v-289h-74v289h-4l-92 -289h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 294,
    d: "M202 0v467h-3l-101 -467h-79v664h73v-438h4l96 438h83v-664h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 294,
    d: "M19 0zM148 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34zM202 0v467h-3l-101 -467h-79v664h73v-438h4l96 438h83v-664h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 311,
    d: "M216 0v596h-75l-7 -190q-3 -78 -6 -137.5t-7 -103t-9.5 -72t-11.5 -45.5q-11 -29 -30 -38.5t-46 -9.5h-11v69h6q11 0 18 4.5t12 20.5q3 13 6.5 36.5t6.5 61t5.5 90.5t4.5 125l8 257h211v-664h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 276,
    d: "M182 293h-4q-10 -20 -30.5 -30.5t-45.5 -10.5q-83 0 -83 126v286h74v-291q0 -26 9 -39t31 -13q38 0 49 44v299h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 30.5t-31 94.5v100h74v-104q0 -52 44 -52q45 0 45 52v176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 302,
    d: "M234 -154v154h-215v664h76v-595h90v595h76v-595h30v-223h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 276,
    d: "M182 0v292h-4q-14 -8 -32 -12.5t-39 -4.5q-48 0 -68 25.5t-20 87.5v276h74v-272q0 -26 8.5 -37t31.5 -11q14 0 27.5 4t21.5 13v303h74v-664h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 415,
    d: "M19 0v664h76v-595h77v595h71v-595h77v595h76v-664h-377z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 438,
    d: "M370 -154v154h-351v664h76v-595h77v595h71v-595h77v595h76v-595h30v-223h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 355,
    d: "M105 595h-92v69h168v-277h64q57 0 76.5 -29t19.5 -86v-171q0 -46 -21 -73.5t-75 -27.5h-140v595zM230 67q23 0 31.5 11.5t8.5 36.5v161q0 25 -9 35t-34 10h-46v-254h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 379,
    d: "M19 0zM284 0v664h76v-664h-76zM95 387h64q54 0 74.5 -24t20.5 -73v-189q0 -46 -21 -73.5t-74 -27.5h-140v664h76v-277zM144 67q23 0 31 13t8 38v155q0 28 -8 38t-31 10h-49v-254h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 268,
    d: "M95 387h64q54 0 74.5 -24t20.5 -73v-189q0 -46 -21 -73.5t-74 -27.5h-140v664h76v-277zM144 67q23 0 31 13t8 38v155q0 28 -8 38t-31 10h-49v-254h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 272,
    d: "M19 193h71v-76q0 -52 44 -52t44 52v201h-81v62h81v165q0 53 -44 53t-44 -53v-69h-71v62q0 62 30 96t87 34t87 -33.5t30 -95.5v-416q0 -62 -29.5 -94.5t-88.5 -32.5q-116 0 -116 125v72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 409,
    d: "M19 0v664h76v-280h56v155q0 62 31 95.5t88 33.5t88 -34.5t31 -96.5v-416q0 -63 -30.5 -94t-87.5 -31q-59 0 -89.5 32.5t-30.5 94.5v194h-56v-317h-76zM315 545q0 53 -45 53t-45 -53v-428q0 -52 45 -52t45 52v428z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 268,
    d: "M6 0l56 288q-29 13 -38.5 41t-9.5 67v147q0 29 3.5 51.5t14 38t29 23.5t48.5 8h140v-664h-76v280h-41l-50 -280h-76zM85 390q0 -26 10 -36.5t29 -10.5h49v253h-49q-22 0 -30.5 -13.5t-8.5 -39.5v-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    d: "M177 376q0 49 -41 49q-20 0 -29.5 -11t-15.5 -35v-272q0 -26 10.5 -37t32.5 -11t32.5 11t10.5 37v269zM250 89q0 -45 -28 -69t-86 -24q-60 0 -87.5 27t-27.5 86v425q0 36 3.5 62t12.5 43t25 25t41 8h52q32 0 38 37h44q0 -102 -57 -102h-49q-23 0 -32.5 -17.5t-9.5 -55.5 v-92h4q22 45 74 45q39 0 61 -24t22 -69v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 267,
    d: "M243 324q0 -56 -48 -65v-4q55 -9 55 -73v-87q0 -47 -25.5 -71t-84.5 -24h-119v483h120q102 0 102 -82v-77zM93 231v-172h48q21 0 30 10.5t9 30.5v91q0 40 -43 40h-44zM177 389q0 33 -37 33h-47v-143h45q39 0 39 31v79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 183,
    d: "M21 0v483h150v-65h-78v-418h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 316,
    d: "M248 -150v150h-180v-150h-57v214h11q11 0 18.5 10.5t13 36.5t9 69.5t6.5 109.5l8 193h197v-419h30v-214h-56zM201 418h-69l-7 -116q-3 -55 -5.5 -95t-5.5 -68t-6.5 -46t-8.5 -29h102v354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 405,
    d: "M323 0l-82 212h-4v-212h-70v212h-4l-81 -212h-76l102 248l-98 235h75l78 -190h4v190h70v-190h4l79 190h74l-98 -235l103 -248h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 264,
    d: "M245 89q0 -44 -26.5 -68.5t-86.5 -24.5q-112 0 -112 97v80h69v-68q0 -47 44 -47q41 0 41 40v91q0 42 -47 42h-28v48h29q24 0 33.5 9t9.5 26v70q0 41 -40 41q-43 0 -43 -40v-51h-68v57q0 47 28 71.5t84 24.5q105 0 105 -90v-77q0 -52 -49 -62v-4q23 -4 40 -19.5t17 -53.5 v-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 283,
    d: "M190 0v316h-3l-91 -316h-75v483h71v-314h4l89 314h77v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 283,
    d: "M21 0zM141 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34zM190 0v316h-3l-91 -316h-75v483h71v-314h4l89 314h77v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 290,
    d: "M197 0v418h-70l-6 -111q-4 -69 -7.5 -117t-7.5 -79.5t-9 -50t-11 -29.5q-9 -17 -24 -24t-41 -7h-10v64h6q16 0 25 15q4 8 7.5 23t6 41t5 66t4.5 99l7 175h197v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 360,
    d: "M276 0v264q0 36 0.5 58t2.5 43h-4l-64 -365h-63l-63 365h-4q1 -20 1.5 -42.5t0.5 -58.5v-264h-62v483h106l53 -349h3l52 349h104v-483h-63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 274,
    d: "M181 0v219h-88v-219h-72v483h72v-199h88v199h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 274,
    d: "M181 0v418h-88v-418h-72v483h232v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 230,
    d: "M79 0v418h-66v65h204v-65h-66v-418h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 295,
    d: "M227 -142v142h-206v483h72v-419h88v419h72v-419h31v-206h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 273,
    d: "M180 0v205h-4q-12 -7 -29 -11t-42 -4q-46 0 -66 17.5t-20 58.5v217h72v-199q0 -17 9.5 -24.5t34.5 -7.5q30 0 45 10v221h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 401,
    d: "M21 0v483h72v-419h75v419h65v-419h75v419h73v-483h-360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 423,
    d: "M355 -142v142h-334v483h72v-419h75v419h65v-419h75v419h73v-419h30v-206h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 324,
    d: "M155 303h61q51 0 71.5 -20t20.5 -60v-148q0 -35 -20.5 -55t-71.5 -20h-133v418h-75v65h147v-180zM202 62q22 0 30 9.5t8 26.5v111q0 34 -38 34h-47v-181h47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 368,
    d: "M21 0zM93 303h61q51 0 71.5 -20.5t20.5 -60.5v-147q0 -35 -20.5 -55t-71.5 -20h-133v483h72v-180zM140 62q38 0 38 35v112q0 34 -38 34h-47v-181h47zM274 0v483h72v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 262,
    d: "M93 303h61q51 0 71.5 -20.5t20.5 -60.5v-147q0 -35 -20.5 -55t-71.5 -20h-133v483h72v-180zM140 62q38 0 38 35v112q0 34 -38 34h-47v-181h47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 266,
    d: "M97 227v52h78v98q0 48 -43 48q-22 0 -31.5 -11t-9.5 -29v-48h-68v50q0 48 25 74t83 26q114 0 114 -113v-265q0 -113 -113 -113q-59 0 -85 27.5t-26 84.5v62h69v-65q0 -47 42 -47q43 0 43 48v121h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 394,
    d: "M373 109q0 -59 -27.5 -86t-86.5 -27q-58 0 -84.5 27t-26.5 86v111h-57v-220h-70v483h70v-199h57v90q0 59 26.5 86t84.5 27q59 0 86.5 -27t27.5 -86v-265zM303 374q0 48 -44 48q-43 0 -43 -48v-265q0 -48 43 -48q44 0 44 48v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 267,
    d: "M6 0l61 193q-29 8 -37.5 29t-8.5 52v134q0 36 20 55.5t71 19.5h134v-483h-72v188h-40l-53 -188h-75zM89 279q0 -20 10 -27t28 -7h47v176h-47q-23 0 -30.5 -10t-7.5 -29v-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 273,
    d: "M93 554v-115h4q20 48 75 48q45 0 63 -28t18 -70v-509q0 -113 -116 -113q-59 0 -86 28t-27 85v93h69v-93q0 -48 43 -48q44 0 44 48v499q0 45 -40 45q-21 0 -33 -13.5t-14 -45.5v-365h-72v554h-21v46h21v72h72v-72h84v-46h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 183,
    d: "M21 0zM61 505l-28 29l111 133l38 -44zM21 0v483h150v-65h-78v-418h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 266,
    d: "M91 227v-121q0 -48 43 -48q42 0 42 47v65h69v-62q0 -57 -26.5 -84.5t-84.5 -27.5q-113 0 -113 113v265q0 113 113 113q58 0 83.5 -26t25.5 -74v-50h-68v48q0 18 -9.5 29t-31.5 11q-43 0 -43 -48v-98h77v-52h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 438,
    d: "M197 0v418h-70l-6 -111q-4 -69 -7.5 -117t-7.5 -79.5t-9 -50t-11 -29.5q-9 -17 -24 -24t-41 -7h-10v64h6q16 0 25 15q4 8 7.5 23t6 41t5 66t4.5 99l7 175h197v-180h62q51 0 71 -20.5t20 -60.5v-147q0 -35 -20.5 -55t-70.5 -20h-134zM316 62q38 0 38 35v112q0 34 -38 34 h-47v-181h47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 422,
    d: "M253 303h62q51 0 71 -20.5t20 -60.5v-147q0 -35 -20 -55t-71 -20h-134v243h-88v-243h-72v483h72v-180h88v180h72v-180zM300 62q38 0 38 35v112q0 34 -38 34h-47v-181h47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 270,
    d: "M21 0zM108 505l-28 29l111 133l38 -44zM187 0l-60 200h-4l-30 -64v-136h-72v483h72v-206h4q2 6 5 15.5t11.5 30.5t25.5 59t47 101h78l-85 -199l84 -284h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 283,
    d: "M21 0zM54 623l38 44l111 -133l-28 -29zM190 0v316h-3l-91 -316h-75v483h71v-314h4l89 314h77v-483h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    d: "M21 0zM94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368zM138 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65 t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 274,
    d: "M108 -142v142h-87v483h72v-419h88v419h72v-483h-88v-142h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 222,
    d: "M19 0v664h135v144h57v-213h-116v-595h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 183,
    d: "M21 0v483h94v127h56v-192h-78v-418h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 237,
    d: "M32 0v293h-28v58h28v313h192v-69h-117v-244h75v-58h-75v-293h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 193,
    d: "M31 0v195h-27v46h27v242h151v-65h-79v-177h79v-46h-79v-195h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 472,
    d: "M6 0l115 338l-111 326h78l89 -264h4v264h74v-264h4l90 264h77l-111 -326l91 -269h55v-205h-57v136h-53l-92 289h-4v-289h-74v289h-4l-92 -289h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 443,
    d: "M375 -136v136h-52l-82 212h-4v-212h-70v212h-4l-81 -212h-76l102 248l-98 235h75l78 -190h4v190h70v-190h4l79 190h74l-98 -235l74 -179h62v-205h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 267,
    d: "M77 -149q7 -3 16.5 -4t18.5 -1q18 0 26.5 6.5t8.5 24.5v27q0 25 -8 49t-27 44q-93 11 -93 124v72h71v-76q0 -52 44 -52q45 0 45 52v155q0 23 -11.5 35.5t-38.5 12.5h-31v62h34q26 0 35.5 12.5t9.5 33.5v123q0 20 -10.5 33.5t-32.5 13.5q-21 0 -32.5 -13t-11.5 -35v-74 h-71v67q0 58 30 91.5t85 33.5q30 0 51 -9.5t34.5 -25t20 -35.5t6.5 -40v-123q0 -70 -52 -79v-4q24 -5 41.5 -24.5t17.5 -60.5v-144q0 -57 -25 -89t-74 -36v-6q21 -20 32 -48t11 -60v-29q0 -41 -17.5 -57t-53.5 -16q-30 0 -49 10v59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 264,
    d: "M245 89q0 -42 -24 -66.5t-78 -26.5v-7q25 -17 38.5 -43.5t13.5 -61.5v-29q0 -41 -18 -57t-53 -16q-14 0 -27 2.5t-22 7.5v59q6 -3 16 -4t18 -1q19 0 27.5 6.5t8.5 24.5v27q0 28 -12.5 53t-40.5 43q-72 15 -72 93v80h69v-68q0 -47 44 -47q41 0 41 40v91q0 42 -47 42h-28 v48h29q24 0 33.5 9t9.5 26v70q0 41 -40 41q-43 0 -43 -40v-51h-68v57q0 47 28 71.5t84 24.5q105 0 105 -90v-77q0 -52 -49 -62v-4q23 -4 40 -19.5t17 -53.5v-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 319,
    d: "M251 -136v136h-59l-62 284h-3l-31 -85v-199h-77v664h77v-278h4q8 29 21 64t25 67l47 147h76l-87 -260l71 -335h54v-205h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 305,
    d: "M237 -136v136h-50l-60 200h-4l-30 -64v-136h-72v483h72v-204h4l18 54l71 150h78l-85 -199l63 -215h51v-205h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 385,
    d: "M129 0v595h-116v69h192v-278h4q9 29 22 64t25 67l46 147h77l-87 -260l86 -404h-76l-62 284h-4l-31 -85v-199h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 341,
    d: "M91 0v418h-78v65h151v-204h3l18 54l71 150h78l-85 -199l84 -284h-76l-60 200h-4l-29 -62v-138h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 302,
    d: "M234 -136v136h-49v319h-90v-319h-76v664h76v-277h90v277h76v-595h30v-205h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 305,
    d: "M237 -136v136h-56v219h-88v-219h-72v483h72v-199h88v199h72v-414h40v-205h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 272,
    d: "M82 -149q7 -3 16.5 -4t17.5 -1q19 0 27.5 6.5t8.5 24.5v27q0 29 -13 54t-43 43q-77 20 -77 122v419q0 126 117 126q57 0 86 -30t30 -96l1 -116h-71v119q0 53 -44 53t-44 -53v-427q0 -53 43 -53q45 0 45 52v154h71v-150q0 -62 -27.5 -92.5t-81.5 -32.5v-4q58 -34 58 -108 v-29q0 -41 -17.5 -57t-53.5 -16q-30 0 -49 10v59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 266,
    d: "M74 -149q7 -3 16.5 -4t17.5 -1q19 0 27.5 6.5t8.5 24.5v27q0 29 -13.5 54.5t-45.5 43.5q-64 19 -64 107v265q0 113 113 113q58 0 84.5 -28t26.5 -85v-67h-69v67q0 48 -42 48q-43 0 -43 -48v-265q0 -48 43 -48q42 0 42 48v69h69v-69q0 -57 -25.5 -84t-81.5 -29v-5 q56 -34 56 -107v-29q0 -41 -17.5 -57t-53.5 -16q-14 0 -27 2.5t-22 7.5v59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 326,
    d: "M281 664l-87 -318l72 -277h48v-205h-56v136h-51l-60 250h-4l-60 -250h-76l91 336l-88 328h76l59 -237h4l58 237h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 304,
    d: "M259 483l-79 -231l59 -183h53v-205h-56v136h-50l-51 173h-4l-51 -173h-74l82 246l-79 237h74l51 -164h4l48 164h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 302,
    d: "M234 -136v136h-52v292h-4q-14 -8 -32 -12.5t-39 -4.5q-48 0 -68 25.5t-20 87.5v276h74v-272q0 -26 8.5 -37t31.5 -11q14 0 27.5 4t21.5 13v303h74v-595h35v-205h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 298,
    d: "M230 -136v136h-50v205h-4q-12 -7 -29 -11t-42 -4q-46 0 -66 17.5t-20 58.5v217h72v-199q0 -17 9.5 -24.5t34.5 -7.5q30 0 45 10v221h72v-414h35v-205h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 276,
    d: "M94 664v-292h4q14 8 32 12.5t39 4.5q48 0 68 -25.5t20 -87.5v-276h-73v272q0 26 -9 37t-32 11q-13 0 -27 -4t-22 -13v-303h-74v664h74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 276,
    d: "M151 -168q42 0 42 48v120l-63 284h-3l-31 -85v-199h-77v664h77v-278h4q8 29 21 64t25 67l47 147h76l-87 -260l86 -404v-120q0 -113 -117 -113v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 270,
    d: "M147 -168q43 0 43 48v103l-63 217h-4l-30 -64v-136h-72v483h72v-204h4l18 54l71 150h78l-85 -199l84 -284v-120q0 -113 -116 -113v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 280,
    d: "M141 -168q44 0 44 48v439h-90v-319h-76v664h76v-277h90v277h76v-784q0 -57 -30.5 -85t-88.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 274,
    d: "M137 -168q44 0 44 48v339h-88v-219h-72v483h72v-199h88v199h72v-603q0 -113 -115 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    d: "M255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 307h-89v-190q0 -52 45 -52q44 0 44 52v190zM91 374h89v171q0 53 -45 53q-44 0 -44 -53v-171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 268,
    d: "M247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 223h-86v-114q0 -48 43 -48t43 48v114zM91 269h86v105q0 48 -43 48t-43 -48v-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 276,
    d: "M19 0zM50 723v46h178v-46h-178zM182 293h-4q-10 -20 -30.5 -30.5t-45.5 -10.5q-83 0 -83 126v286h74v-291q0 -26 9 -39t31 -13q38 0 49 44v299h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 30.5t-31 94.5v100h74v-104q0 -52 44 -52q45 0 45 52v176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    d: "M21 0zM94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368zM50 547v46h178v-46h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0512",
    unicode: "\u0512",
    horizAdvX: 311,
    d: "M172 -168q44 0 44 48v716h-75l-7 -190q-3 -78 -6 -137.5t-7 -103t-9.5 -72t-11.5 -45.5q-11 -29 -30 -38.5t-46 -9.5h-11v69h6q11 0 18 4.5t12 20.5q3 13 6.5 36.5t6.5 61t5.5 90.5t4.5 125l8 257h211v-784q0 -57 -30.5 -85t-89.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0513",
    unicode: "\u0513",
    horizAdvX: 290,
    d: "M153 -168q44 0 44 48v538h-70l-6 -111q-4 -69 -7.5 -117t-7.5 -79.5t-9 -50t-11 -29.5q-9 -17 -24 -24t-41 -7h-10v64h6q16 0 25 15q4 8 7.5 23t6 41t5 66t4.5 99l7 175h197v-603q0 -113 -116 -113v65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni058F",
    unicode: "\u058F",
    horizAdvX: 293,
    d: "M173 0v155h-111v46h111v92h-111v46h111v208q0 52 -45 52q-44 0 -44 -52v-134h-71v130q0 125 116 125q59 0 88.5 -32.5t29.5 -94.5v-202h34v-46h-34v-92h34v-46h-34v-155h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0C",
    unicode: "\u1E0C",
    horizAdvX: 277,
    d: "M19 0zM19 0v664h124q115 0 115 -116v-425q0 -63 -29 -93t-86 -30h-124zM138 68q26 0 35 18.5t9 51.5v390q0 32 -10 50t-39 18h-40v-528h45zM94 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0D",
    unicode: "\u1E0D",
    d: "M21 0zM94 107q0 -26 10.5 -37t30.5 -11t30 12.5t16 41.5v257q-5 30 -14.5 42.5t-30.5 12.5q-20 0 -31 -11.5t-11 -37.5v-269zM186 0l-2 49h-4q-22 -53 -75 -53q-40 0 -62 24.5t-22 69.5v304q0 45 22.5 69t61.5 24q25 0 42 -10.5t28 -34.5h4v230h71v-672h-64zM102 -141v92 h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E12",
    unicode: "\u1E12",
    horizAdvX: 277,
    d: "M18 0zM19 0v664h124q115 0 115 -116v-425q0 -63 -29 -93t-86 -30h-124zM138 68q26 0 35 18.5t9 51.5v390q0 32 -10 50t-39 18h-40v-528h45zM188 -189l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E13",
    unicode: "\u1E13",
    d: "M21 0zM94 107q0 -26 10.5 -37t30.5 -11t30 12.5t16 41.5v257q-5 30 -14.5 42.5t-30.5 12.5q-20 0 -31 -11.5t-11 -37.5v-269zM186 0l-2 49h-4q-22 -53 -75 -53q-40 0 -62 24.5t-22 69.5v304q0 45 22.5 69t61.5 24q25 0 42 -10.5t28 -34.5h4v230h71v-672h-64zM202 -189 l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E24",
    unicode: "\u1E24",
    horizAdvX: 280,
    d: "M19 0zM185 0v319h-90v-319h-76v664h76v-277h90v277h76v-664h-76zM104 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E25",
    unicode: "\u1E25",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 45 -40 45q-21 0 -33 -13.5t-14 -45.5v-365h-72v672h72v-233h4q20 48 75 48q45 0 63 -28t18 -70v-389h-73zM100 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3C",
    unicode: "\u1E3C",
    horizAdvX: 224,
    d: "M14 0zM19 0v664h76v-595h116v-69h-192zM184 -189l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3D",
    unicode: "\u1E3D",
    horizAdvX: 119,
    d: "M0 0zM23 0v672h72v-672h-72zM127 -189l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E44",
    unicode: "\u1E44",
    horizAdvX: 294,
    d: "M19 0zM183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM108 706v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E45",
    unicode: "\u1E45",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73zM99 535v93h72v-93h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4A",
    unicode: "\u1E4A",
    horizAdvX: 294,
    d: "M19 0zM183 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM210 -189l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4B",
    unicode: "\u1E4B",
    horizAdvX: 273,
    d: "M21 0zM180 0v379q0 46 -40 46q-20 0 -30 -11t-17 -35v-379h-72v483h67l2 -49h4q23 53 76 53q38 0 60.5 -23.5t22.5 -70.5v-393h-73zM205 -189l-69 89l-69 -89l-32 25l68 107h65l68 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5A",
    unicode: "\u1E5A",
    horizAdvX: 272,
    d: "M19 0zM19 0v664h140q53 0 74 -26.5t21 -74.5v-152q0 -68 -50 -80v-4q25 -5 38.5 -23.5t13.5 -56.5v-247h-74v253q0 22 -8 32t-30 10h-51v-295h-74zM182 554q0 42 -40 42h-49v-239h50q18 0 28.5 10.5t10.5 36.5v150zM100 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5B",
    unicode: "\u1E5B",
    horizAdvX: 207,
    d: "M18 0zM21 0v483h67l2 -56h4q11 29 28.5 44.5t44.5 15.5q16 0 28 -6v-66q-12 7 -31 7q-31 0 -47.5 -17t-23.5 -62v-343h-72zM18 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E62",
    unicode: "\u1E62",
    horizAdvX: 282,
    d: "M16 0zM186 461v85q0 24 -11.5 38t-35.5 14q-23 0 -34.5 -12.5t-11.5 -32.5v-71q0 -29 5.5 -42.5t21.5 -28.5q13 -13 28 -25t30.5 -23t29.5 -22.5t24 -22.5q17 -18 25 -40.5t8 -60.5v-97q0 -61 -29 -92.5t-95 -31.5t-95.5 32.5t-29.5 96.5v74h71v-80q0 -54 51 -54 q48 0 48 49v84q0 35 -6.5 51t-24.5 33q-27 26 -54.5 46.5t-48.5 47.5q-33 43 -33 110v68q0 51 28.5 82.5t90.5 31.5q33 0 56 -9.5t36.5 -27t19.5 -41.5t6 -52v-77h-70zM103 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E63",
    unicode: "\u1E63",
    horizAdvX: 265,
    d: "M18 0zM175 335v56q0 37 -42 37q-43 0 -43 -33v-54q0 -17 4.5 -25.5t21.5 -19.5q23 -16 47 -27t46 -27q19 -14 28.5 -33t9.5 -54v-63q0 -49 -27 -72.5t-85 -23.5q-62 0 -89.5 25.5t-27.5 74.5v59h68v-61q0 -20 10.5 -29.5t35.5 -9.5q43 0 43 36v62q0 16 -5.5 26t-25.5 24 q-7 4 -18.5 11t-25 15t-26.5 16.5t-22 16.5q-17 15 -23.5 33.5t-6.5 45.5v60q0 40 27.5 63t81.5 23q56 0 84 -26t28 -73v-53h-68zM98 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6C",
    unicode: "\u1E6C",
    horizAdvX: 263,
    d: "M13 0zM93 0v596h-80v68h237v-68h-82v-596h-75zM95 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6D",
    unicode: "\u1E6D",
    horizAdvX: 257,
    d: "M21 0zM174 274h62v-165q0 -58 -22 -85.5t-80 -27.5q-59 0 -86 27.5t-27 85.5v507h71v-133h144v-65h-144v-309q0 -48 43 -48q21 0 30 11.5t9 36.5v165zM97 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 410,
    d: "M7 0zM62 0l-55 664h73l35 -522h4l43 522h86l45 -522h4l34 522h71l-55 -664h-99l-41 522h-4l-41 -522h-100zM117 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 375,
    d: "M6 0zM55 0l-49 483h68l32 -364h4l37 364h80l39 -364h4l31 364h67l-49 -483h-92l-38 370h-4l-38 -370h-92zM100 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 410,
    d: "M7 0zM62 0l-55 664h73l35 -522h4l43 522h86l45 -522h4l34 522h71l-55 -664h-99l-41 522h-4l-41 -522h-100zM176 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 375,
    d: "M6 0zM55 0l-49 483h68l32 -364h4l37 364h80l39 -364h4l31 364h67l-49 -483h-92l-38 370h-4l-38 -370h-92zM156 505l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 410,
    d: "M7 0zM62 0l-55 664h73l35 -522h4l43 522h86l45 -522h4l34 522h71l-55 -664h-99l-41 522h-4l-41 -522h-100zM113 711v93h67v-93h-67zM227 711v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 375,
    d: "M6 0zM55 0l-49 483h68l32 -364h4l37 364h80l39 -364h4l31 364h67l-49 -483h-92l-38 370h-4l-38 -370h-92zM96 535v93h67v-93h-67zM210 535v93h67v-93h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E92",
    unicode: "\u1E92",
    horizAdvX: 252,
    d: "M13 0zM13 0v69l148 527h-147v68h222v-68l-146 -528h150v-68h-227zM90 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E93",
    unicode: "\u1E93",
    horizAdvX: 230,
    d: "M14 0zM14 0v68l126 350h-124v65h197v-65l-125 -352h128v-66h-202zM79 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 308,
    d: "M126 69q9 -5 19.5 -6.5t20.5 -1.5q26 0 37.5 11t11.5 38v205q0 20 -10.5 29t-27.5 9q-15 0 -36 -8v66l61 185h-53q-54 0 -54 -58v-538h-76v539q0 61 30.5 93t88.5 32h135v-64l-63 -189q34 0 56 -21.5t22 -69.5v-208q0 -65 -25.5 -90.5t-79.5 -25.5q-17 0 -33 2t-24 5v66z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA0",
    unicode: "\u1EA0",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM102 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1",
    unicode: "\u1EA1",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM96 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA2",
    unicode: "\u1EA2",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM118 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3",
    unicode: "\u1EA3",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM110 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA4",
    unicode: "\u1EA4",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM206 681l-68 86l-69 -86l-32 25l68 103h65l68 -103zM224 773l-28 28l91 103l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5",
    unicode: "\u1EA5",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM205 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM223 597l-28 28l91 103l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA6",
    unicode: "\u1EA6",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM204 681l-68 86l-69 -86l-32 25l68 103h65l68 -103zM159 862l37 42l92 -103l-28 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7",
    unicode: "\u1EA7",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM199 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM154 686l37 42l92 -103l-28 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA8",
    unicode: "\u1EA8",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM209 681l-69 86l-69 -86l-31 25l67 103h66l68 -103zM225 761q0 16 7 25.5t15 16t15 12.5t7 17q0 20 -23 20q-22 0 -39 -16l-13 40q12 10 29 15t31 5q24 0 40 -15.5t16 -41.5 q0 -18 -7.5 -28.5t-17 -18t-17 -14t-7.5 -17.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9",
    unicode: "\u1EA9",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM195 505l-69 86l-69 -86l-31 25l67 103h66l68 -103zM211 585q0 16 7 25.5t15 16t15 12.5t7 17q0 20 -23 20q-22 0 -39 -16l-13 40q12 10 29 15t31 5q24 0 40 -15.5t16 -41.5q0 -18 -7.5 -28.5t-17 -18 t-17 -14t-7.5 -17.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAA",
    unicode: "\u1EAA",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM205 681l-68 81l-69 -81l-32 25l68 98h65l68 -98zM241 869q-7 -25 -21.5 -36t-34.5 -11q-12 0 -23 4t-21.5 8.5t-21 8.5t-22.5 4q-10 0 -17 -4t-12 -18l-32 18q6 25 20.5 36 t34.5 11q12 0 23 -4t21.5 -8.5t21.5 -8t23 -3.5q9 0 16 4t12 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB",
    unicode: "\u1EAB",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM198 505l-68 81l-69 -81l-32 25l68 98h65l68 -98zM234 693q-7 -25 -21.5 -36t-34.5 -11q-12 0 -23 4t-21.5 8.5t-21 8.5t-22.5 4q-10 0 -17 -4t-12 -18l-32 18q6 25 20.5 36t34.5 11q12 0 23 -4 t21.5 -8.5t21.5 -8t23 -3.5q9 0 16 4t12 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAC",
    unicode: "\u1EAC",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM207 682l-69 89l-69 -89l-32 25l68 107h65l68 -107zM103 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD",
    unicode: "\u1EAD",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM200 506l-69 89l-69 -89l-32 25l68 107h65l68 -107zM96 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAE",
    unicode: "\u1EAE",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM141 680q-45 0 -73 27t-28 86h52q1 -73 49 -73t49 73h54q0 -60 -29 -86.5t-74 -26.5zM129 762l-28 29l97 109l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF",
    unicode: "\u1EAF",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM135 504q-45 0 -73 27t-28 86h52q1 -73 49 -73t49 73h54q0 -60 -29 -86.5t-74 -26.5zM123 586l-28 29l97 109l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB0",
    unicode: "\u1EB0",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM143 680q-46 0 -74.5 26.5t-28.5 86.5h53q3 -73 50 -73q46 0 49 73h52q0 -60 -28 -86.5t-73 -26.5zM49 854l37 43l97 -106l-27 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1",
    unicode: "\u1EB1",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM133 504q-46 0 -74.5 26.5t-28.5 86.5h53q3 -73 50 -73q46 0 49 73h52q0 -60 -28 -86.5t-73 -26.5zM39 678l37 43l97 -106l-27 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB2",
    unicode: "\u1EB2",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM139 680q-45 0 -73.5 27t-28.5 86h52q1 -73 49 -73t50 73h53q0 -59 -28.5 -86t-73.5 -27zM112 771q0 16 7 24.5t15 14.5t15 12t7 17q0 19 -23 19q-20 0 -39 -15l-12 38q11 9 28 14 t31 5q25 0 40.5 -15t15.5 -40q0 -18 -7.5 -28t-17 -16.5t-17 -13t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3",
    unicode: "\u1EB3",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM133 504q-45 0 -73.5 27t-28.5 86h52q1 -73 49 -73t50 73h53q0 -59 -28.5 -86t-73.5 -27zM106 595q0 16 7 24.5t15 14.5t15 12t7 17q0 19 -23 19q-20 0 -39 -15l-12 38q11 9 28 14t31 5q25 0 40.5 -15 t15.5 -40q0 -18 -7.5 -28t-17 -16.5t-17 -13t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB4",
    unicode: "\u1EB4",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM138 680q-45 0 -73.5 27t-28.5 86h52q1 -73 49 -73t50 73h53q0 -59 -28.5 -86t-73.5 -27zM240 864q-6 -25 -21 -36.5t-34 -11.5q-13 0 -24 4t-21.5 9t-21 9t-22.5 4 q-10 0 -17.5 -4.5t-12.5 -18.5l-31 19q6 25 20.5 36.5t34.5 11.5q12 0 23.5 -4t22 -9t21 -9t21.5 -4t18 4.5t12 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5",
    unicode: "\u1EB5",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM131 504q-45 0 -73.5 27t-28.5 86h52q1 -73 49 -73t50 73h53q0 -59 -28.5 -86t-73.5 -27zM233 688q-6 -25 -21 -36.5t-34 -11.5q-13 0 -24 4t-21.5 9t-21 9t-22.5 4q-10 0 -17.5 -4.5t-12.5 -18.5 l-31 19q6 25 20.5 36.5t34.5 11.5q12 0 23.5 -4t22 -9t21 -9t21.5 -4t18 4.5t12 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB6",
    unicode: "\u1EB6",
    horizAdvX: 279,
    d: "M7 0zM196 0l-17 162h-82l-16 -162h-74l78 664h107l79 -664h-75zM104 227h68l-32 315h-4zM138 681q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34zM102 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7",
    unicode: "\u1EB7",
    horizAdvX: 266,
    d: "M16 0zM175 258q-11 -8 -19.5 -10.5t-26.5 -8.5q-26 -8 -34.5 -19t-8.5 -33v-92q0 -36 39 -36q20 0 31 9t19 27v163zM180 0l-2 42h-4q-11 -18 -28.5 -32t-52.5 -14q-42 0 -59.5 22t-17.5 60v96q0 25 5 42t16 29.5t29 21t44 16.5q29 8 46.5 16t17.5 25v68q0 33 -41 33 q-44 0 -44 -36v-61h-67v69q0 46 30 68t86 22q108 0 108 -85v-402h-66zM129 505q-45 0 -73.5 34t-28.5 98h52q2 -45 14 -65t36 -20t36.5 20t13.5 65h54q0 -64 -29 -98t-75 -34zM94 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB8",
    unicode: "\u1EB8",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM75 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB9",
    unicode: "\u1EB9",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM98 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBA",
    unicode: "\u1EBA",
    horizAdvX: 218,
    d: "M19 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM95 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBB",
    unicode: "\u1EBB",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM113 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5 q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 218,
    d: "M9 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM214 746q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM236 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5 t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBE",
    unicode: "\u1EBE",
    horizAdvX: 218,
    d: "M13 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM182 681l-68 86l-69 -86l-32 25l68 103h65l68 -103zM200 773l-28 28l91 103l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBF",
    unicode: "\u1EBF",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM204 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM222 597l-28 28l91 103l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC0",
    unicode: "\u1EC0",
    horizAdvX: 218,
    d: "M11 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM180 681l-68 86l-69 -86l-32 25l68 103h65l68 -103zM135 862l37 42l92 -103l-28 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC1",
    unicode: "\u1EC1",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM198 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM153 686l37 42l92 -103l-28 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC2",
    unicode: "\u1EC2",
    horizAdvX: 218,
    d: "M12 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM181 681l-69 86l-69 -86l-31 25l67 103h66l68 -103zM197 761q0 16 7 25.5t15 16t15 12.5t7 17q0 20 -23 20q-22 0 -39 -16l-13 40q12 10 29 15t31 5q24 0 40 -15.5t16 -41.5q0 -18 -7.5 -28.5t-17 -18 t-17 -14t-7.5 -17.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC3",
    unicode: "\u1EC3",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM198 505l-69 86l-69 -86l-31 25l67 103h66l68 -103zM214 585q0 16 7 25.5t15 16t15 12.5 t7 17q0 20 -23 20q-22 0 -39 -16l-13 40q12 10 29 15t31 5q24 0 40 -15.5t16 -41.5q0 -18 -7.5 -28.5t-17 -18t-17 -14t-7.5 -17.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC4",
    unicode: "\u1EC4",
    horizAdvX: 218,
    d: "M14 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM183 681l-68 81l-69 -81l-32 25l68 98h65l68 -98zM219 869q-7 -25 -21.5 -36t-34.5 -11q-12 0 -23 4t-21.5 8.5t-21 8.5t-22.5 4q-10 0 -17 -4t-12 -18l-32 18q6 25 20.5 36t34.5 11q12 0 23 -4 t21.5 -8.5t21.5 -8t23 -3.5q9 0 16 4t12 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC5",
    unicode: "\u1EC5",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM202 505l-68 81l-69 -81l-32 25l68 98h65l68 -98zM238 693q-7 -25 -21.5 -36t-34.5 -11 q-12 0 -23 4t-21.5 8.5t-21 8.5t-22.5 4q-10 0 -17 -4t-12 -18l-32 18q6 25 20.5 36t34.5 11q12 0 23 -4t21.5 -8.5t21.5 -8t23 -3.5q9 0 16 4t12 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC6",
    unicode: "\u1EC6",
    horizAdvX: 218,
    d: "M15 0zM19 0v664h182v-68h-108v-214h98v-68h-98v-246h114v-68h-188zM185 682l-69 89l-69 -89l-32 25l68 107h65l68 -107zM80 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC7",
    unicode: "\u1EC7",
    horizAdvX: 269,
    d: "M21 0zM248 109q0 -113 -115 -113q-112 0 -112 113v265q0 113 113 113q114 0 114 -113v-150h-157v-117q0 -48 43 -48t43 48v59h71v-57zM177 375q0 49 -43 49t-43 -49v-99h86v99zM203 506l-69 89l-69 -89l-32 25l68 107h65l68 -107zM97 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC8",
    unicode: "\u1EC8",
    horizAdvX: 122,
    d: "M6 0zM19 0v664h76v-664h-76zM36 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC9",
    unicode: "\u1EC9",
    horizAdvX: 121,
    d: "M6 0zM21 0v483h72v-483h-72zM36 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECA",
    unicode: "\u1ECA",
    horizAdvX: 114,
    d: "M19 0zM19 0v664h76v-664h-76zM21 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECB",
    unicode: "\u1ECB",
    horizAdvX: 114,
    d: "M20 0zM21 0v483h72v-483h-72zM21 535v93h72v-93h-72zM20 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECC",
    unicode: "\u1ECC",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM100 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECD",
    unicode: "\u1ECD",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM99 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECE",
    unicode: "\u1ECE",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM114 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39 q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECF",
    unicode: "\u1ECF",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM112 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5 q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED0",
    unicode: "\u1ED0",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM207 681l-68 86l-69 -86l-32 25l68 103h65l68 -103zM225 773l-28 28 l91 103l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED1",
    unicode: "\u1ED1",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM202 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM220 597l-28 28l91 103l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED2",
    unicode: "\u1ED2",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM205 681l-68 86l-69 -86l-32 25l68 103h65l68 -103zM160 862l37 42 l92 -103l-28 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED3",
    unicode: "\u1ED3",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM200 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM155 686l37 42l92 -103l-28 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED4",
    unicode: "\u1ED4",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM204 681l-69 86l-69 -86l-31 25l67 103h66l68 -103zM220 761q0 16 7 25.5 t15 16t15 12.5t7 17q0 20 -23 20q-22 0 -39 -16l-13 40q12 10 29 15t31 5q24 0 40 -15.5t16 -41.5q0 -18 -7.5 -28.5t-17 -18t-17 -14t-7.5 -17.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED5",
    unicode: "\u1ED5",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM201 505l-69 86l-69 -86l-31 25l67 103h66l68 -103zM217 585q0 16 7 25.5t15 16t15 12.5 t7 17q0 20 -23 20q-22 0 -39 -16l-13 40q12 10 29 15t31 5q24 0 40 -15.5t16 -41.5q0 -18 -7.5 -28.5t-17 -18t-17 -14t-7.5 -17.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED6",
    unicode: "\u1ED6",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM205 681l-68 81l-69 -81l-32 25l68 98h65l68 -98zM241 869 q-7 -25 -21.5 -36t-34.5 -11q-12 0 -23 4t-21.5 8.5t-21 8.5t-22.5 4q-10 0 -17 -4t-12 -18l-32 18q6 25 20.5 36t34.5 11q12 0 23 -4t21.5 -8.5t21.5 -8t23 -3.5q9 0 16 4t12 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED7",
    unicode: "\u1ED7",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM204 505l-68 81l-69 -81l-32 25l68 98h65l68 -98zM240 693q-7 -25 -21.5 -36t-34.5 -11 q-12 0 -23 4t-21.5 8.5t-21 8.5t-22.5 4q-10 0 -17 -4t-12 -18l-32 18q6 25 20.5 36t34.5 11q12 0 23 -4t21.5 -8.5t21.5 -8t23 -3.5q9 0 16 4t12 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED8",
    unicode: "\u1ED8",
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM180 545q0 53 -45 53q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM205 682l-69 89l-69 -89l-32 25l68 107h65l68 -107zM100 -141v92h72v-92 h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED9",
    unicode: "\u1ED9",
    horizAdvX: 268,
    d: "M21 0zM247 109q0 -59 -27.5 -86t-85.5 -27t-85.5 27t-27.5 86v265q0 59 27.5 86t85.5 27t85.5 -27t27.5 -86v-265zM177 374q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265zM204 506l-69 89l-69 -89l-32 25l68 107h65l68 -107zM99 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDA",
    unicode: "\u1EDA",
    horizAdvX: 315,
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 63 31 96t87 33q23 0 48 -3.5t47 -3.5q23 0 31 7.5t8 27.5q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55.5t-38.5 -17.5q-12 0 -30 3q24 -30 24 -82v-417zM180 545q0 53 -45 53 q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM100 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDB",
    unicode: "\u1EDB",
    horizAdvX: 303,
    d: "M21 0zM103 505l-28 29l111 133l38 -44zM247 109q0 -59 -27 -86t-86 -27q-58 0 -85.5 27t-27.5 86v265q0 113 109 113q26 0 47.5 -4t41.5 -4q21 0 29 8t8 28q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55.5t-37 -17.5h-9t-9 1q14 -26 14 -63v-265zM177 374 q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDC",
    unicode: "\u1EDC",
    horizAdvX: 315,
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 63 31 96t87 33q23 0 48 -3.5t47 -3.5q23 0 31 7.5t8 27.5q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55.5t-38.5 -17.5q-12 0 -30 3q24 -30 24 -82v-417zM180 545q0 53 -45 53 q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM48 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDD",
    unicode: "\u1EDD",
    horizAdvX: 303,
    d: "M21 0zM47 623l38 44l111 -133l-28 -29zM247 109q0 -59 -27 -86t-86 -27q-58 0 -85.5 27t-27.5 86v265q0 113 109 113q26 0 47.5 -4t41.5 -4q21 0 29 8t8 28q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55.5t-37 -17.5h-9t-9 1q14 -26 14 -63v-265zM177 374 q0 48 -43 48t-43 -48v-265q0 -48 43 -48t43 48v265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDE",
    unicode: "\u1EDE",
    horizAdvX: 315,
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 63 31 96t87 33q23 0 48 -3.5t47 -3.5q23 0 31 7.5t8 27.5q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55.5t-38.5 -17.5q-12 0 -30 3q24 -30 24 -82v-417zM180 545q0 53 -45 53 q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM114 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDF",
    unicode: "\u1EDF",
    horizAdvX: 303,
    d: "M21 0zM247 109q0 -59 -27 -86t-86 -27q-58 0 -85.5 27t-27.5 86v265q0 113 109 113q26 0 47.5 -4t41.5 -4q21 0 29 8t8 28q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55.5t-37 -17.5h-9t-9 1q14 -26 14 -63v-265zM177 374q0 48 -43 48t-43 -48v-265 q0 -48 43 -48t43 48v265zM115 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE0",
    unicode: "\u1EE0",
    horizAdvX: 315,
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 63 31 96t87 33q23 0 48 -3.5t47 -3.5q23 0 31 7.5t8 27.5q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55.5t-38.5 -17.5q-12 0 -30 3q24 -30 24 -82v-417zM180 545q0 53 -45 53 q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM239 746q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE1",
    unicode: "\u1EE1",
    horizAdvX: 303,
    d: "M21 0zM247 109q0 -59 -27 -86t-86 -27q-58 0 -85.5 27t-27.5 86v265q0 113 109 113q26 0 47.5 -4t41.5 -4q21 0 29 8t8 28q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55.5t-37 -17.5h-9t-9 1q14 -26 14 -63v-265zM177 374q0 48 -43 48t-43 -48v-265 q0 -48 43 -48t43 48v265zM237 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE2",
    unicode: "\u1EE2",
    horizAdvX: 315,
    d: "M16 0zM255 121q0 -63 -31 -94t-88 -31q-59 0 -89.5 32.5t-30.5 94.5v416q0 63 31 96t87 33q23 0 48 -3.5t47 -3.5q23 0 31 7.5t8 27.5q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55.5t-38.5 -17.5q-12 0 -30 3q24 -30 24 -82v-417zM180 545q0 53 -45 53 q-44 0 -44 -53v-428q0 -52 45 -52q44 0 44 52v428zM100 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE3",
    unicode: "\u1EE3",
    horizAdvX: 303,
    d: "M21 0zM247 109q0 -59 -27 -86t-86 -27q-58 0 -85.5 27t-27.5 86v265q0 113 109 113q26 0 47.5 -4t41.5 -4q21 0 29 8t8 28q0 8 -1 19.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55.5t-37 -17.5h-9t-9 1q14 -26 14 -63v-265zM177 374q0 48 -43 48t-43 -48v-265 q0 -48 43 -48t43 48v265zM99 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE4",
    unicode: "\u1EE4",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM100 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE5",
    unicode: "\u1EE5",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM101 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE6",
    unicode: "\u1EE6",
    horizAdvX: 276,
    d: "M19 0zM182 664h74v-541q0 -62 -29.5 -94.5t-88.5 -32.5q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM115 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14 t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE7",
    unicode: "\u1EE7",
    horizAdvX: 272,
    d: "M21 0zM94 483v-372q0 -29 9 -40.5t31 -11.5t31 12t14 42v370h72v-483h-67l-2 49h-4q-13 -29 -30 -41t-45 -12q-49 0 -65.5 31t-16.5 84v372h73zM116 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28 t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE8",
    unicode: "\u1EE8",
    horizAdvX: 342,
    d: "M19 0zM182 664h82q17 0 24 7.5t7 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55t-37.5 -17q-13 0 -33 5v-500q0 -127 -118 -127q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM104 681l-28 29l111 133l38 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE9",
    unicode: "\u1EE9",
    horizAdvX: 334,
    d: "M21 0zM105 505l-28 29l111 133l38 -44zM94 483v-380q0 -44 39 -44q19 0 29 10.5t17 34.5v379h79q16 0 22.5 7.5t6.5 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55t-38 -17q-7 0 -14.5 1t-15.5 3v-441h-67l-2 49h-3q-11 -25 -28.5 -39.5t-46.5 -14.5 q-25 0 -41 9.5t-25.5 26t-13 40t-3.5 50.5v362h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEA",
    unicode: "\u1EEA",
    horizAdvX: 342,
    d: "M19 0zM182 664h82q17 0 24 7.5t7 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55t-37.5 -17q-13 0 -33 5v-500q0 -127 -118 -127q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM51 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEB",
    unicode: "\u1EEB",
    horizAdvX: 334,
    d: "M21 0zM49 623l38 44l111 -133l-28 -29zM94 483v-380q0 -44 39 -44q19 0 29 10.5t17 34.5v379h79q16 0 22.5 7.5t6.5 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55t-38 -17q-7 0 -14.5 1t-15.5 3v-441h-67l-2 49h-3q-11 -25 -28.5 -39.5t-46.5 -14.5 q-25 0 -41 9.5t-25.5 26t-13 40t-3.5 50.5v362h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEC",
    unicode: "\u1EEC",
    horizAdvX: 342,
    d: "M19 0zM182 664h82q17 0 24 7.5t7 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55t-37.5 -17q-13 0 -33 5v-500q0 -127 -118 -127q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM117 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18 t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EED",
    unicode: "\u1EED",
    horizAdvX: 334,
    d: "M21 0zM94 483v-380q0 -44 39 -44q19 0 29 10.5t17 34.5v379h79q16 0 22.5 7.5t6.5 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55t-38 -17q-7 0 -14.5 1t-15.5 3v-441h-67l-2 49h-3q-11 -25 -28.5 -39.5t-46.5 -14.5q-25 0 -41 9.5t-25.5 26t-13 40 t-3.5 50.5v362h73zM115 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEE",
    unicode: "\u1EEE",
    horizAdvX: 342,
    d: "M19 0zM182 664h82q17 0 24 7.5t7 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55t-37.5 -17q-13 0 -33 5v-500q0 -127 -118 -127q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM239 739q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4 t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEF",
    unicode: "\u1EEF",
    horizAdvX: 334,
    d: "M21 0zM239 570q-6 -25 -20.5 -37t-34.5 -12q-13 0 -24 4t-21.5 9.5t-21 9.5t-21.5 4t-18 -4.5t-12 -18.5l-32 19q6 25 21 36.5t34 11.5q13 0 24 -4t21.5 -9.5t21 -9.5t22.5 -4q22 0 30 23zM94 483v-380q0 -44 39 -44q19 0 29 10.5t17 34.5v379h79q16 0 22.5 7.5t6.5 26.5 q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55t-38 -17q-7 0 -14.5 1t-15.5 3v-441h-67l-2 49h-3q-11 -25 -28.5 -39.5t-46.5 -14.5q-25 0 -41 9.5t-25.5 26t-13 40t-3.5 50.5v362h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF0",
    unicode: "\u1EF0",
    horizAdvX: 342,
    d: "M19 0zM182 664h82q17 0 24 7.5t7 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11.5 -55t-37.5 -17q-13 0 -33 5v-500q0 -127 -118 -127q-57 0 -88 31t-31 94v543h74v-547q0 -52 44 -52q45 0 45 52v547zM100 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF1",
    unicode: "\u1EF1",
    horizAdvX: 334,
    d: "M21 0zM94 483v-380q0 -44 39 -44q19 0 29 10.5t17 34.5v379h79q16 0 22.5 7.5t6.5 26.5q0 7 -1 17.5t-3 18.5h40q4 -6 5.5 -18t1.5 -26q0 -38 -11 -55t-38 -17q-7 0 -14.5 1t-15.5 3v-441h-67l-2 49h-3q-11 -25 -28.5 -39.5t-46.5 -14.5q-25 0 -41 9.5t-25.5 26t-13 40 t-3.5 50.5v362h73zM101 -141v92h72v-92h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 276,
    d: "M6 0zM102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75zM51 799l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    d: "M21 0zM94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368zM49 623l38 44l111 -133l-28 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF6",
    unicode: "\u1EF6",
    horizAdvX: 276,
    d: "M6 0zM102 0v277l-96 387h75l57 -256h4l55 256h73l-93 -388v-276h-75zM121 691q0 16 7 25t15 15t15 12t7 17q0 18 -22 18t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF7",
    unicode: "\u1EF7",
    d: "M21 0zM94 115q0 -26 10.5 -37.5t30.5 -11.5t30 12t16 40v365h69v-603q0 -113 -115 -113q-58 0 -85 28t-27 85v90h69v-90q0 -48 43 -48q44 0 44 48v166h-4q-11 -26 -29 -36t-44 -10q-45 0 -63 26t-18 74v383h73v-368zM116 515q0 16 7 25t15 15t15 12t7 17q0 18 -22 18 t-40 -15l-12 39q11 11 28 16t31 5q24 0 40 -15.5t16 -40.5q0 -18 -7.5 -28t-17 -17.5t-17 -14t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 188,
    d: "M16 273v62h157v-62h-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 268,
    d: "M16 273v62h237v-62h-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 112,
    d: "M93 657q-17 -10 -24.5 -25t-7.5 -40v-40h32v-103h-74v133q0 51 18.5 79.5t55.5 38.5v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 112,
    d: "M19 464q17 10 24.5 25t7.5 40v40h-32v103h74v-134q0 -51 -19 -79.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 112,
    d: "M19 0zM19 -105q17 10 24.5 25t7.5 40v40h-32v103h74v-133q0 -52 -19 -80.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 220,
    d: "M19 449zM93 657q-17 -10 -24.5 -25t-7.5 -40v-40h32v-103h-74v133q0 51 18.5 79.5t55.5 38.5v-43zM201 657q-17 -10 -24.5 -25t-7.5 -40v-40h32v-103h-74v133q0 51 18.5 79.5t55.5 38.5v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 219,
    d: "M19 421zM19 464q17 10 24.5 25t7.5 40v40h-32v103h74v-134q0 -51 -19 -79.5t-55 -37.5v43zM126 464q17 10 24.5 25t7.5 40v40h-32v103h74v-134q0 -51 -19 -79.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 219,
    d: "M19 0zM19 -105q17 10 24.5 25t7.5 40v40h-32v103h74v-133q0 -52 -19 -80.5t-55 -37.5v43zM126 -105q17 10 24.5 25t7.5 40v40h-32v103h74v-133q0 -52 -19 -80.5t-55 -37.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 228,
    d: "M93 0v482h-74v42h74v140h45v-140h71v-42h-71v-482h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 227,
    d: "M93 0v140h-74v42h74v300h-74v42h74v140h45v-140h71v-42h-71v-300h71v-42h-71v-140h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 167,
    d: "M84 263q-27 0 -46 20t-19 49q0 31 19 50.5t46 19.5q26 0 45 -19.5t19 -50.5q0 -29 -19 -49t-45 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 334,
    d: "M130 0v103h73v-103h-73zM241 0v103h73v-103h-73zM19 0v103h74v-103h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 410,
    d: "M4 0zM28 -15l180 696h41l-181 -696h-40zM277 77q0 -41 -15.5 -60.5t-43.5 -19.5q-29 0 -44.5 21t-15.5 60v157q0 39 15.5 60t44.5 21q28 0 43.5 -19.5t15.5 -60.5v-159zM237 236q0 42 -20 42t-20 -42v-159q0 -42 20 -42t20 42v159zM406 77q0 -41 -15.5 -60.5t-43.5 -19.5 q-29 0 -44.5 21t-15.5 60v157q0 39 15.5 60t44.5 21q28 0 43.5 -19.5t15.5 -60.5v-159zM366 236q0 42 -20 42t-20 -42v-159q0 -42 20 -42t20 42v159zM123 427q0 -41 -15.5 -60.5t-43.5 -19.5q-29 0 -44.5 21t-15.5 60v157q0 39 15.5 60t44.5 21q28 0 43.5 -19.5t15.5 -60.5 v-159zM83 586q0 42 -20 42t-20 -42v-159q0 -42 20 -42t20 42v159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 130,
    d: "M8 318l84 118l29 -29l-64 -89l64 -89l-29 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 130,
    d: "M8 229l64 90l-64 88l30 29l83 -117l-83 -118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 62,
    d: "M-78 -15l180 696h41l-181 -696h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 157,
    d: "M19 347zM138 427q0 -41 -15.5 -60.5t-43.5 -19.5q-29 0 -44.5 21t-15.5 60v157q0 39 15.5 60t44.5 21q28 0 43.5 -19.5t15.5 -60.5v-159zM98 586q0 42 -20 42t-20 -42v-159q0 -42 20 -42t20 42v159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 155,
    d: "M16 350zM82 584h-3l-34 -133h37v133zM82 350v66h-66v34l55 214h50v-213h18v-35h-18v-66h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 154,
    d: "M19 347zM135 411q0 -64 -58 -64q-22 0 -40 12.5t-18 49.5v22h38v-24q0 -22 20 -22q19 0 19 23v88q0 12 -5 16t-12 4q-14 0 -21 -12h-39l6 160h103v-37h-68l-3 -90q11 14 34 14q18 0 31 -10.5t13 -40.5v-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 154,
    d: "M19 347zM135 410q0 -63 -57 -63q-59 0 -59 64v190q0 65 59 65q57 0 57 -58v-31h-38v29q0 22 -19 22q-20 0 -20 -23v-80h3q12 20 35 20q18 0 28.5 -11.5t10.5 -32.5v-91zM97 491q0 20 -16 20t-23 -18v-86q0 -22 20 -22q19 0 19 22v84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 131,
    d: "M16 350zM33 350q0 31 4.5 67.5t11 73.5t15 71.5t16.5 63.5h-64v38h99v-34q-9 -31 -17 -66.5t-13.5 -72.5t-9 -73t-3.5 -68h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 152,
    d: "M17 347zM76 628q-11 0 -14.5 -5t-3.5 -16v-58q0 -11 3.5 -16t14.5 -5t14.5 5t3.5 16v58q0 11 -3.5 16t-14.5 5zM76 347q-29 0 -44 16.5t-15 45.5v47q0 26 6 37.5t21 16.5v4q-23 5 -23 43v52q0 23 13 40t42 17t42.5 -17t13.5 -40v-52q0 -37 -25 -43v-4q15 -4 21.5 -16 t6.5 -38v-47q0 -29 -15 -45.5t-44 -16.5zM76 385q20 0 20 21v64q0 23 -20 23q-19 0 -19 -23v-64q0 -21 19 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 154,
    d: "M19 347zM19 599q0 33 12.5 50t45.5 17q34 0 46 -18.5t12 -53.5v-175q0 -32 -12 -52t-47 -20q-30 0 -43.5 16.5t-13.5 45.5v26h38v-28q0 -21 19 -21q20 0 20 28v80h-4q-6 -10 -14 -15.5t-20 -5.5q-18 0 -28.5 12t-10.5 33v81zM57 527q0 -19 16 -19q18 0 23 20v76 q0 24 -20 24q-19 0 -19 -22v-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 157,
    d: "M138 77q0 -41 -15.5 -60.5t-43.5 -19.5q-29 0 -44.5 21t-15.5 60v157q0 39 15.5 60t44.5 21q28 0 43.5 -19.5t15.5 -60.5v-159zM98 236q0 42 -20 42t-20 -42v-159q0 -42 20 -42t20 42v159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 104,
    d: "M45 0v253h-29v33q19 0 25.5 6.5t8.5 21.5h34v-314h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 152,
    d: "M19 0v68q0 19 4 32.5t15 27.5q11 13 25.5 25.5t22.5 22.5q6 8 8 15t2 20v45q0 22 -18 22q-11 0 -15 -5.5t-4 -18.5v-47h-39v44q0 16 2 28t8 20.5t17.5 12.5t30.5 4q35 0 46 -14.5t11 -44.5v-46q0 -36 -18 -54q-8 -9 -21.5 -22t-23.5 -24q-8 -9 -10.5 -16.5t-2.5 -18.5 v-40h76v-36h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 152,
    d: "M135 59q0 -62 -58 -62t-58 66v38h38v-40q0 -26 20 -26q19 0 19 22v64q0 25 -22 25h-16v34h17q12 0 15.5 5.5t3.5 18.5v51q0 12 -3.5 17.5t-14.5 5.5q-19 0 -19 -24v-35h-38v31q0 32 14.5 49t42.5 17q29 0 42.5 -17t13.5 -40v-52q0 -35 -25 -41v-3q12 -3 20 -12.5t8 -31.5 v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 155,
    d: "M82 234h-3l-34 -133h37v133zM82 0v66h-66v34l55 214h50v-213h18v-35h-18v-66h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 154,
    d: "M135 61q0 -64 -58 -64q-22 0 -40 12.5t-18 49.5v22h38v-24q0 -22 20 -22q19 0 19 23v88q0 12 -5 16t-12 4q-14 0 -21 -12h-39l6 160h103v-37h-68l-3 -90q11 14 34 14q18 0 31 -10.5t13 -40.5v-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 154,
    d: "M135 60q0 -63 -57 -63q-59 0 -59 64v190q0 65 59 65q57 0 57 -58v-31h-38v29q0 22 -19 22q-20 0 -20 -23v-80h3q12 20 35 20q18 0 28.5 -11.5t10.5 -32.5v-91zM97 141q0 20 -16 20t-23 -18v-86q0 -22 20 -22q19 0 19 22v84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 131,
    d: "M33 0q0 31 4.5 67.5t11 73.5t15 71.5t16.5 63.5h-64v38h99v-34q-9 -31 -17 -66.5t-13.5 -72.5t-9 -73t-3.5 -68h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 152,
    d: "M76 278q-11 0 -14.5 -5t-3.5 -16v-58q0 -11 3.5 -16t14.5 -5t14.5 5t3.5 16v58q0 11 -3.5 16t-14.5 5zM76 -3q-29 0 -44 16.5t-15 45.5v47q0 26 6 37.5t21 16.5v4q-23 5 -23 43v52q0 23 13 40t42 17t42.5 -17t13.5 -40v-52q0 -37 -25 -43v-4q15 -4 21.5 -16t6.5 -38v-47 q0 -29 -15 -45.5t-44 -16.5zM76 35q20 0 20 21v64q0 23 -20 23q-19 0 -19 -23v-64q0 -21 19 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 154,
    d: "M19 249q0 33 12.5 50t45.5 17q34 0 46 -18.5t12 -53.5v-175q0 -32 -12 -52t-47 -20q-30 0 -43.5 16.5t-13.5 45.5v26h38v-28q0 -21 19 -21q20 0 20 28v80h-4q-6 -10 -14 -15.5t-20 -5.5q-18 0 -28.5 12t-10.5 33v81zM57 177q0 -19 16 -19q18 0 23 20v76q0 24 -20 24 q-19 0 -19 -22v-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 408,
    d: "M72 0l-21 266h-44v40h41l-8 95h-33v40h30l-17 223h64l14 -223h50l17 223h77l17 -223h51l14 223h64l-18 -223h31v-40h-34l-7 -95h41v-40h-44l-21 -266h-88l-20 266h-49l-19 -266h-88zM270 306h31l6 95h-45zM106 306h32l7 95h-45zM182 306h43l-7 95h-29zM123 109l12 157 h-26l10 -157h4zM289 109l10 157h-26l12 -157h4zM192 441h23l-9 119h-5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AA",
    unicode: "\u20AA",
    horizAdvX: 328,
    d: "M179 97v460q0 19 -7 26.5t-21 7.5h-84v-591h-48v664h151q29 0 43.5 -16t14.5 -61v-490h-49zM148 566v-459q0 -35 29 -35h83v592h48v-664h-150q-30 0 -44 15.5t-14 60.5v490h48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dong",
    unicode: "\u20AB",
    horizAdvX: 229,
    d: "M151 110l-2 32h-4q-7 -15 -22 -25t-40 -10q-27 0 -44.5 15.5t-17.5 48.5v252q0 33 18 48t44 15q23 0 37.5 -8.5t20.5 -20.5h4v122h-101v40h101v53h53v-53h21v-40h-21v-469h-47zM74 187q0 -34 34 -34q29 0 38 31v223q-8 33 -38 33q-15 0 -24.5 -7.5t-9.5 -22.5v-223zM15 0 v40h183v-40h-183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 259,
    d: "M249 62q-19 -34 -43.5 -50t-59.5 -16q-50 0 -78 32.5t-28 94.5v122h-25l6 46h19v93h-25l6 47h19v108q0 63 30 96t90 33q42 0 63 -18l-12 -72q-20 20 -47 20q-49 0 -49 -53v-114h83l-6 -47h-77v-93h66l-7 -46h-59v-128q0 -52 40 -52q32 0 51 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AD",
    unicode: "\u20AD",
    horizAdvX: 310,
    d: "M192 332l96 -332h-76l-92 332h-4v-332h-76v332h-33v50h33v282h76v-282h4l93 282h76l-100 -282h105v-50h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AE",
    unicode: "\u20AE",
    horizAdvX: 263,
    d: "M168 357v-103l70 40v-54l-70 -39v-201h-75v159l-65 -36v53l65 36v103l-67 -37v53l67 37v228h-80v68h237v-68h-82v-187l69 39v-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B1",
    unicode: "\u20B1",
    horizAdvX: 297,
    d: "M267 388v-25q0 -48 -21.5 -74.5t-73.5 -26.5h-65v-262h-75v388h-32v36h32v76h-32v37h32v127h140q52 0 73.5 -26.5t21.5 -74.5v-26h30v-37h-30v-76h30v-36h-30zM107 424h89v76h-89v-76zM157 327q39 0 39 47v14h-89v-61h50zM107 537h89v17q0 42 -39 42h-50v-59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B2",
    unicode: "\u20B2",
    horizAdvX: 272,
    d: "M25 -15l13 55q-19 31 -19 83v416q0 62 29.5 95.5t86.5 33.5q32 0 57 -11l6 24h47l-15 -58q23 -32 23 -85v-79h-66l-28 -114h94v-345h-49l-4 35h-3q-9 -17 -25 -28t-47 -11q-27 0 -50 10l-5 -21h-45zM94 263h4l75 318q-12 17 -36 17q-43 0 -43 -53v-282zM143 278l-46 -185 q7 -28 40 -28q38 0 45 46v167h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 282,
    d: "M110 264q-8 -12 -11 -26t-3 -40v-84q0 -49 49 -49q50 0 50 54v80h71v-74q0 -64 -29 -96.5t-95 -32.5t-95 31.5t-29 92.5v97q0 14 1 25.5t3 21.5h-18v37h33l83 74h-116v36h158q17 15 22.5 28.5t5.5 42.5v71q0 20 -11.5 32.5t-35.5 12.5t-35 -14t-11 -38v-85h-71v77 q0 57 26 93.5t92 36.5q62 0 91 -31.5t29 -82.5v-68q0 -45 -13 -75h27v-36h-49l-81 -74h130v-37h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 236,
    d: "M90 0v475h-75v64h208v-64h-74v-475h-59zM15 601v63h208v-63h-208z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 231,
    d: "M104 0l-57 290v43h27q45 0 45 49v65h-103v50h103v68q0 47 -44 47h-59v52h200v-52h-44v-6q14 -12 14 -41v-68h30v-50h-30v-65q0 -38 -17 -61.5t-51 -31.5l61 -289h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 288,
    d: "M116 282v-214h44q44 0 44 51v90h71v-86q0 -63 -29 -93t-86 -30h-117v242l-30 -16v52l30 16v97l-30 -16v52l30 16v221h73v-180l108 60v-53l-108 -60v-96l108 60v-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BC",
    unicode: "\u20BC",
    horizAdvX: 390,
    d: "M231 664v-145h46q53 0 74.5 -26.5t21.5 -74.5v-418h-67v407q0 47 -40 47h-35v-454h-73v454h-35q-40 0 -40 -47v-407h-66v418q0 48 21 74.5t74 26.5h46v145h73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 297,
    d: "M123 130v-130h-75v130h-38v46h38v83h-38v47h38v358h139q53 0 74 -26.5t21 -74.5v-203q0 -48 -21 -74.5t-74 -26.5h-64v-83h123v-46h-123zM212 554q0 42 -40 42h-49v-290h49q40 0 40 47v201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BE",
    unicode: "\u20BE",
    horizAdvX: 314,
    d: "M127 397v197q-37 -9 -37 -45v-333q0 -55 19 -90.5t58 -61.5v-64h-156v65h79v5q-33 17 -52 50t-19 95v342q0 49 24 76.5t84 32.5v70h22v-68h9h11.5t11.5 -1v69h22v-71q51 -8 73 -35t22 -73v-111h-59v103q0 33 -36 44v-196h-22v200q-5 0 -9.5 0.5t-9.5 0.5q-9 0 -13 -1 v-200h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "litre",
    unicode: "\u2113",
    horizAdvX: 219,
    d: "M151 0q-13 -4 -31 -4q-42 0 -63 28.5t-21 91.5l-26 -7v57l26 5v403q0 94 82 94q85 0 85 -94v-220q0 -157 -117 -218q0 -53 10.5 -71.5t32.5 -18.5q5 0 11 1t11 3v-50zM86 191q70 47 70 167v217q0 39 -36 39q-34 0 -34 -39v-384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 479,
    d: "M186 0l-98 520h-4q1 -16 1.5 -33.5t1 -39.5t0.5 -50v-65v-332h-65v664h102l87 -497h4q-1 20 -1.5 42t-1 48.5t-0.5 59v74.5v273h66v-664h-92zM461 395q0 -98 -75 -98q-78 0 -78 100v173q0 98 78 98q75 0 75 -98v-175zM410 569q0 25 -7 35.5t-18 10.5q-12 0 -19 -10.5 t-7 -35.5v-171q0 -26 7 -36.5t19 -10.5q11 0 18 10t7 36v172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 265,
    d: "M258 121q0 -64 -31 -94.5t-88 -30.5q-59 0 -89.5 32.5t-30.5 94.5v416q0 62 31 95.5t88 33.5t88.5 -34t31.5 -96v-417zM227 538q0 48 -23.5 74t-65.5 26t-65 -25.5t-23 -73.5v-416q0 -97 89 -97q42 0 65 23t23 72v417zM84 176v310h66q44 0 44 -48v-87q0 -54 -44 -54h-34 v-121h-32zM163 435q0 22 -22 22h-25v-134h25q22 0 22 24v88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 285,
    d: "M45 423v211h-31v30h95v-30h-31v-211h-33zM235 423v176h-4l-21 -176h-32l-22 176h-4v-176h-29v241h52l17 -169h4l18 169h51v-241h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 299,
    d: "M16 0zM27 -15l180 696h41l-181 -696h-40zM45 350v253h-29v33q19 0 25.5 6.5t8.5 21.5h34v-314h-39zM286 59q0 -62 -58 -62t-58 66v38h38v-40q0 -26 20 -26q19 0 19 22v64q0 25 -22 25h-16v34h17q12 0 15.5 5.5t3.5 18.5v51q0 12 -3.5 17.5t-14.5 5.5q-19 0 -19 -24v-35 h-38v31q0 32 14.5 49t42.5 17q29 0 42.5 -17t13.5 -40v-52q0 -35 -25 -41v-3q12 -3 20 -12.5t8 -31.5v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 299,
    d: "M5 0zM45 -15l180 696h41l-181 -696h-40zM5 350v68q0 19 4 32.5t15 27.5q11 13 25.5 25.5t22.5 22.5q6 8 8 15t2 20v45q0 22 -18 22q-11 0 -15 -5.5t-4 -18.5v-47h-39v44q0 16 2 28t8 20.5t17.5 12.5t30.5 4q35 0 46 -14.5t11 -44.5v-46q0 -36 -18 -54q-8 -9 -21.5 -22 t-23.5 -24q-8 -9 -10.5 -16.5t-2.5 -18.5v-40h76v-36h-116zM292 59q0 -62 -58 -62t-58 66v38h38v-40q0 -26 20 -26q19 0 19 22v64q0 25 -22 25h-16v34h17q12 0 15.5 5.5t3.5 18.5v51q0 12 -3.5 17.5t-14.5 5.5q-19 0 -19 -24v-35h-38v31q0 32 14.5 49t42.5 17q29 0 42.5 -17 t13.5 -40v-52q0 -35 -25 -41v-3q12 -3 20 -12.5t8 -31.5v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 299,
    d: "M22 0zM22 -15l180 696h41l-181 -696h-40zM51 350v253h-29v33q19 0 25.5 6.5t8.5 21.5h34v-314h-39zM219 278q-11 0 -14.5 -5t-3.5 -16v-58q0 -11 3.5 -16t14.5 -5t14.5 5t3.5 16v58q0 11 -3.5 16t-14.5 5zM219 -3q-29 0 -44 16.5t-15 45.5v47q0 26 6 37.5t21 16.5v4 q-23 5 -23 43v52q0 23 13 40t42 17t42.5 -17t13.5 -40v-52q0 -37 -25 -43v-4q15 -4 21.5 -16t6.5 -38v-47q0 -29 -15 -45.5t-44 -16.5zM219 35q20 0 20 21v64q0 23 -20 23q-19 0 -19 -23v-64q0 -21 19 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 299,
    d: "M8 0zM40 -15l180 696h41l-181 -696h-40zM231 278q-11 0 -14.5 -5t-3.5 -16v-58q0 -11 3.5 -16t14.5 -5t14.5 5t3.5 16v58q0 11 -3.5 16t-14.5 5zM231 -3q-29 0 -44 16.5t-15 45.5v47q0 26 6 37.5t21 16.5v4q-23 5 -23 43v52q0 23 13 40t42 17t42.5 -17t13.5 -40v-52 q0 -37 -25 -43v-4q15 -4 21.5 -16t6.5 -38v-47q0 -29 -15 -45.5t-44 -16.5zM231 35q20 0 20 21v64q0 23 -20 23q-19 0 -19 -23v-64q0 -21 19 -21zM124 409q0 -62 -58 -62t-58 66v38h38v-40q0 -26 20 -26q19 0 19 22v64q0 25 -22 25h-16v34h17q12 0 15.5 5.5t3.5 18.5v51 q0 12 -3.5 17.5t-14.5 5.5q-19 0 -19 -24v-35h-38v31q0 32 14.5 49t42.5 17q29 0 42.5 -17t13.5 -40v-52q0 -35 -25 -41v-3q12 -3 20 -12.5t8 -31.5v-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 299,
    d: "M10 0zM40 -15l180 696h41l-181 -696h-40zM126 411q0 -64 -58 -64q-22 0 -40 12.5t-18 49.5v22h38v-24q0 -22 20 -22q19 0 19 23v88q0 12 -5 16t-12 4q-14 0 -21 -12h-39l6 160h103v-37h-68l-3 -90q11 14 34 14q18 0 31 -10.5t13 -40.5v-89zM229 278q-11 0 -14.5 -5 t-3.5 -16v-58q0 -11 3.5 -16t14.5 -5t14.5 5t3.5 16v58q0 11 -3.5 16t-14.5 5zM229 -3q-29 0 -44 16.5t-15 45.5v47q0 26 6 37.5t21 16.5v4q-23 5 -23 43v52q0 23 13 40t42 17t42.5 -17t13.5 -40v-52q0 -37 -25 -43v-4q15 -4 21.5 -16t6.5 -38v-47q0 -29 -15 -45.5 t-44 -16.5zM229 35q20 0 20 21v64q0 23 -20 23q-19 0 -19 -23v-64q0 -21 19 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 299,
    d: "M22 0zM23 -15l180 696h41l-181 -696h-40zM217 278q-11 0 -14.5 -5t-3.5 -16v-58q0 -11 3.5 -16t14.5 -5t14.5 5t3.5 16v58q0 11 -3.5 16t-14.5 5zM217 -3q-29 0 -44 16.5t-15 45.5v47q0 26 6 37.5t21 16.5v4q-23 5 -23 43v52q0 23 13 40t42 17t42.5 -17t13.5 -40v-52 q0 -37 -25 -43v-4q15 -4 21.5 -16t6.5 -38v-47q0 -29 -15 -45.5t-44 -16.5zM217 35q20 0 20 21v64q0 23 -20 23q-19 0 -19 -23v-64q0 -21 19 -21zM39 350q0 31 4.5 67.5t11 73.5t15 71.5t16.5 63.5h-64v38h99v-34q-9 -31 -17 -66.5t-13.5 -72.5t-9 -73t-3.5 -68h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 232,
    d: "M156 333q-8 23 -18.5 33t-26.5 10q-35 0 -35 -43v-238q0 -43 40 -43t40 45v236zM19 332q0 101 73 101q20 0 34 -8t26 -25h3v81q0 71 -15 101t-46 30q-11 0 -24.5 -4.5t-24.5 -15.5l-16 52q11 12 30.5 18t41.5 6q57 0 84.5 -47t27.5 -147v-373q0 -51 -24.5 -78t-75.5 -27 q-48 0 -71 24.5t-23 70.5v241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 227,
    d: "M151 -182v789h-75v-789h-57v846h189v-846h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 216,
    d: "M22 -182v53l74 370l-74 370v53h172v-57h-114l71 -366l-71 -366h114v-57h-172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 257,
    d: "M19 305v57h219v-57h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 238,
    d: "M73 0l-32 319h-34v57h78l23 -279h4l66 567h54l-86 -664h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 376,
    d: "M168 332q-24 60 -60 60q-20 0 -31 -14.5t-11 -43.5q0 -59 43 -59q34 0 59 57zM188 287q-17 -32 -39 -49t-51 -17q-79 0 -79 113q0 114 79 114q29 0 51 -17t39 -49q18 33 39.5 49.5t50.5 16.5q79 0 79 -114q0 -113 -79 -113q-54 0 -90 66zM208 332q23 -57 59 -57 q42 0 42 59q0 58 -42 58q-35 0 -59 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 191,
    d: "M19 -233v57h24q24 0 24 31v734q0 75 74 75h32v-57h-23q-26 0 -26 -31v-734q0 -75 -73 -75h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 257,
    d: "M19 222zM177 229q-15 0 -27.5 3t-24.5 7t-23.5 7t-23.5 3q-32 0 -59 -27v60q10 10 24 17t36 7q15 0 27.5 -3.5t24.5 -7l24 -7t24 -3.5q33 0 59 27v-60q-25 -23 -61 -23zM177 362q-15 0 -27.5 3t-24.5 7t-23.5 7t-23.5 3q-32 0 -59 -27v60q10 10 24 17t36 7 q15 0 27.5 -3.5t24.5 -7l24 -7t24 -3.5q33 0 59 27v-60q-25 -23 -61 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 257,
    d: "M16 -20l61 242h-58v57h73l27 108h-100v56h114l62 241h46l-62 -241h59v-56h-73l-27 -108h100v-57h-115l-61 -242h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 257,
    d: "M19 81zM19 302v61l219 106v-64l-156 -71v-4l156 -70v-63zM19 81v57h219v-57h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 257,
    d: "M19 81zM19 81v57h219v-57h-219zM19 197v63l156 70v4l-156 71v64l219 -106v-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 111,
    d: "M19 282zM19 282v103h74v-103h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 254,
    d: "M99 0l-80 332l80 332h60l75 -332l-76 -332h-59zM130 540h-5l-48 -208l48 -207h5l49 207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE000",
    unicode: "\uE000",
    horizAdvX: 272,
    d: "M409 -120q0 -113 -113 -113q-114 0 -114 113v155h-4q-8 -17 -23 -28t-44 -11q-43 0 -67.5 27.5t-24.5 88.5v427q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 43 -52q38 0 45 46v167h-50v67h121v-465q0 -48 44 -48 q43 0 43 48v93h69v-93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE001",
    unicode: "\uE001",
    d: "M179 -233v275h-4q-20 -46 -72 -46q-46 0 -64 29t-18 83v286q0 45 22 69t62 24q28 0 45.5 -12.5t29.5 -41.5h4l2 50h64v-716h-71zM94 107q0 -26 10.5 -37t30.5 -11t29.5 11.5t16.5 37.5v267q-7 27 -16.5 38.5t-29.5 11.5q-41 0 -41 -49v-269z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE002",
    unicode: "\uE002",
    horizAdvX: 249,
    d: "M108 303l58 -60l-35 -37l-127 124l127 126l35 -37l-58 -59h128v-57h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE003",
    unicode: "\uE003",
    horizAdvX: 249,
    d: "M134 360l-59 60l35 37l127 -124l-127 -126l-35 37l59 59h-129v57h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE004",
    unicode: "\uE004",
    horizAdvX: 472,
    d: "M388 -132q0 -101 -105 -101q-101 0 -101 101v167h-4q-8 -17 -23 -28t-45 -11q-42 0 -66.5 27.5t-24.5 88.5v427q0 62 29.5 95.5t86.5 33.5q58 0 88 -34t30 -96v-79h-71v86q0 53 -45 53q-43 0 -43 -53v-428q0 -52 42 -52q20 0 33 12t13 34v167h-50v67h121v-477 q0 -36 30 -36t30 36v105h75v-105zM313 0v596h-57v68h208v-68h-76v-596h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE005",
    unicode: "\uE005",
    horizAdvX: 276,
    d: "M19 0v69h19q23 0 33 8t15 31l20 83l-100 473h73l60 -318h4l55 318h72l-115 -571q-5 -26 -13.5 -44t-22.5 -29t-33.5 -15.5t-47.5 -4.5h-19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE006",
    unicode: "\uE006",
    horizAdvX: 214,
    d: "M203 418h-80v-318q0 -36 34 -36h38v-64h-39q-105 0 -105 100v318h-40v65h40v129h72v-129h80v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "psi",
    horizAdvX: 381,
    d: "M156 -233v233h-60q-34 0 -54.5 23t-20.5 63v397h67v-383q0 -40 32 -40h36v612h69v-612h36q32 0 32 40v383h67v-397q0 -40 -20.5 -63t-54.5 -23h-60v-233h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexhook",
    horizAdvX: 0,
    d: "M-71 505l-69 86l-69 -86l-31 25l67 103h66l68 -103zM-55 585q0 16 7 25.5t15 16t15 12.5t7 17q0 20 -23 20q-22 0 -39 -16l-13 40q12 10 29 15t31 5q24 0 40 -15.5t16 -41.5q0 -18 -7.5 -28.5t-17 -18t-17 -14t-7.5 -17.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breveacute",
    horizAdvX: 0,
    d: "M-138 504q-45 0 -73 27t-28 86h52q1 -73 49 -73t49 73h54q0 -60 -29 -86.5t-74 -26.5zM-150 586l-28 29l97 109l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevetilde",
    horizAdvX: 0,
    d: "M-137 504q-45 0 -73.5 27t-28.5 86h52q1 -73 49 -73t50 73h53q0 -59 -28.5 -86t-73.5 -27zM-35 688q-6 -25 -21 -36.5t-34 -11.5q-13 0 -24 4t-21.5 9t-21 9t-22.5 4q-10 0 -17.5 -4.5t-12.5 -18.5l-31 19q6 25 20.5 36.5t34.5 11.5q12 0 23.5 -4t22 -9t21 -9t21.5 -4 t18 4.5t12 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevehook",
    horizAdvX: 0,
    d: "M-137 504q-45 0 -73.5 27t-28.5 86h52q1 -73 49 -73t50 73h53q0 -59 -28.5 -86t-73.5 -27zM-164 595q0 16 7 24.5t15 14.5t15 12t7 17q0 19 -23 19q-20 0 -39 -15l-12 38q11 9 28 14t31 5q25 0 40.5 -15t15.5 -40q0 -18 -7.5 -28t-17 -16.5t-17 -13t-7.5 -16.5h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexacute",
    horizAdvX: 0,
    d: "M-68 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM-50 597l-28 28l91 103l38 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecircumflex",
    horizAdvX: 0,
    d: "M-68 505l-68 86l-69 -86l-32 25l68 103h65l68 -103zM-113 686l37 42l92 -103l-28 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevegrave",
    horizAdvX: 0,
    d: "M-136 504q-46 0 -74.5 26.5t-28.5 86.5h53q3 -73 50 -73q46 0 49 73h52q0 -60 -28 -86.5t-73 -26.5zM-230 678l37 43l97 -106l-27 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "carontilde",
    horizAdvX: 0,
    d: "M-68 505l-68 81l-69 -81l-32 25l68 98h65l68 -98zM-32 693q-7 -25 -21.5 -36t-34.5 -11q-12 0 -23 4t-21.5 8.5t-21 8.5t-22.5 4q-10 0 -17 -4t-12 -18l-32 18q6 25 20.5 36t34.5 11q12 0 23 -4t21.5 -8.5t21.5 -8t23 -3.5q9 0 16 4t12 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".ttfautohint",
    horizAdvX: 0,
    d: "M0 0z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "J",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "/",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF2",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E92",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E85",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E84",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E83",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E82",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E81",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E80",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E6C",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04A0",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0496",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u042A",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0416",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u040B",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0402",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u03B3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u039B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0394",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0179",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0178",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0176",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0175",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0174",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0164",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0162",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0104",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0102",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0100",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xDD",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "w",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Z",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Y",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "W",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "T",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "J",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "/",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0237",
    k: -131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012F",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0427",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u03C0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u042F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0427",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u03C0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "psi",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE004",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE001",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE000",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2014",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2013",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EED",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDD",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECD",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBD",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB6",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAE",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAD",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAC",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAA",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA8",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA6",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E93",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E85",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E83",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E81",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E63",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E62",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E5B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E4B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E45",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E13",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E0D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0512",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04EF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u049B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0498",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0497",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0491",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0454",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0453",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0449",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0448",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0446",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0439",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0438",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0433",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0432",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u041B",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0409",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0404",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AD",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u039B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0398",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0272",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01DD",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01B0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0177",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0175",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0173",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0171",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0169",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0161",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0160",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0157",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0155",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0153",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0152",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0151",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0150",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014E",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0148",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0146",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0144",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0123",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0121",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0120",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011E",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0119",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0117",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0115",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0113",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0111",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010F",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010D",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010B",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0107",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0106",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0105",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0103",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0102",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0101",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0100",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFD",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFA",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEB",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE8",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE6",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE5",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE1",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC6",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "z",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "y",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "w",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "u",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "s",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "r",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "q",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "p",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "o",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "n",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "m",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "g",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "e",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "d",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "c",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "a",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "S",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "Q",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "O",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "G",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "-",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2026",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201A",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ".",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ",",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2014",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2013",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "-",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2026",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201A",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAE",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1E6C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0513",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u04B2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u04A0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0496",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0459",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u043B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0434",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u042A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0416",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u040B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0402",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u039B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0394",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0164",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0162",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0104",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0102",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0100",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "T",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ".",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ",",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2026",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2019",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2018",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2014",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2013",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ".",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "-",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ",",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "'",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\"",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2026",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2019",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2018",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ".",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ",",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "'",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\"",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "5",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2026",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ".",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ",",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2026",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201E",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2014",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2013",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "-",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2026",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201A",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ".",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ",",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u2026",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201A",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0237",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "j",
    k: -71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03BB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03A6",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "/",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "psi",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE001",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EED",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAF",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAD",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E93",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E85",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E83",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E81",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E63",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E5B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E4B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E45",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E13",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E0D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04EF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04E9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04AB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04A3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u049B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0497",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0491",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0454",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0453",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044E",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0449",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0448",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0446",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0439",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0438",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0436",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0433",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0432",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CC",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03BA",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AC",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u039B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0394",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0272",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01E7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01DD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01B0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0177",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0175",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0173",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0171",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0169",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0148",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0146",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0144",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "w",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "?",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u03A6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "&",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2014",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2013",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EE3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EE1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ECF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ECD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAD",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E92",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E84",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E82",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E80",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E6C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E63",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E62",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E5B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E4B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E45",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E13",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E0D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0513",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0512",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04C8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04C4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04B2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04A3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04A0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u049B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0496",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0491",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045C",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045A",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0459",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0453",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044E",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044C",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0449",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0448",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0446",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043C",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043B",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0439",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0438",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0434",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0433",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0432",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u042A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u041B",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0416",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0414",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u040B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0409",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0402",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03CE",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03CC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C9",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BA",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u039B",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0394",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0272",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0237",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01E7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0179",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0178",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0176",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0174",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0164",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0162",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0161",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0160",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015E",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015A",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0159",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0157",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0155",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0151",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0148",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0146",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0144",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0123",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0121",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0119",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0117",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0115",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0113",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0111",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0107",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xDD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "r",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "p",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "n",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "m",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "j",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "T",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "S",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "-",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE005",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\uE005",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03BB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03B8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03B6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03A9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03A6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "/",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "psi",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE004",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE003",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE002",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE001",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE000",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2039",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EED",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDF",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECF",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBF",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAF",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAE",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAD",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAB",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA8",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E93",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E85",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E83",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E81",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E63",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E62",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E5B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E4B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E45",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E13",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E0D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04EF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C4",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04B3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04A3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u049B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0497",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0491",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045C",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0454",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0453",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044C",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0449",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0448",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0446",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043C",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0439",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0438",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0433",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0432",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0404",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03BA",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u039B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0398",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0394",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0272",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01DD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01B0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017C",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0175",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0160",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0148",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0146",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0144",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0123",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0121",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0111",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAB",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "z",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "w",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "/",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03C7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "?",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03A9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "/",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u03C7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0237",
    k: -130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012F",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0237",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u012F",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "?",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0237",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "j",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u012F",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u0237",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "j",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0237",
    k: -155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u03BB",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "?",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u03BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "/",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0237",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "j",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u012F",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0237",
    k: -129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012F",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "J",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "f",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03A9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "/",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u0237",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "\u0237",
    k: -107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u012F",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u03A6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "J",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "&",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "&",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "\u0237",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u0142",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\u03BB",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "\u03BB",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u03BB",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\uE005",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "?",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\uE005",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "?",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\uE005",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "?",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03BB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03B8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03B6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03A9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03A6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "J",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "/",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "\u03BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "/",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03BB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03B8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03B6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03A9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03A6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "J",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "/",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "\u03BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "/",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "\u0237",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "/",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03A9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "/",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "&",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03A9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "/",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u03C7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u03C7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u03C7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0237",
    u2: "\u012F",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u024C",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03A9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "/",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "&",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAE",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0513",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0512",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0459",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u043B",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0434",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u041B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0414",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0409",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03CA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03B9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03AF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u039B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0394",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0104",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0102",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0100",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03A6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1E6C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0513",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0512",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04B2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04A0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0496",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0459",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u043B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0434",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u042A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u041B",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0416",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0409",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u039B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0394",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0164",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0162",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0104",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0102",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0100",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "X",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\uE001",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EE3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EE1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ECF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ECD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB4",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAE",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAC",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAA",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA4",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1E13",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1E0D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04E9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04B2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04AB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0496",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0454",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0416",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03CE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03CC",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03AD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03AC",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u039B",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0394",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u01DD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u01A1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0153",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0151",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u014F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u014D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u011B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0119",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0117",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0115",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0113",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0111",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0107",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0104",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0102",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0100",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xEB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xEA",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC4",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "q",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "o",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "e",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "d",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "c",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "X",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "A",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03BB",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AC",
    u2: "\u03C7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AF",
    u2: "\u03C7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B1",
    u2: "\u03C7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    g2: "psi",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\uE001",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EF1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EED",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE3",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDF",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDD",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED9",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED7",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED3",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECF",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECD",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC7",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC3",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBF",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBD",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EB9",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E5B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E4B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E45",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E13",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E0D",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04E9",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04AB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u049B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0491",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0454",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0453",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044E",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0449",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0448",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0446",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0442",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0439",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0438",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0433",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0432",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C3",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03BA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AD",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AC",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0272",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01F9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01DD",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01B0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01A1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0173",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0171",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0169",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0159",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0157",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0155",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0153",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0151",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014F",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014D",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0148",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0146",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0144",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u011B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0119",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0117",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0115",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0113",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0111",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010F",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010D",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0107",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFA",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF8",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF4",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF3",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEA",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE9",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE8",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE7",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "u",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "r",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "q",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "p",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "o",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "n",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "m",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "e",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "d",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "c",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u1E6C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u04A0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u042A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u040B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0402",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0164",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0162",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B9",
    u2: "\u03C7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    g2: "psi",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\uE001",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201D",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201C",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2019",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2018",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EF1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EED",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EB9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E85",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E83",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E81",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E13",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E0D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04E9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04AB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04A1",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0454",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u044A",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CD",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01DD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01B0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01A1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0175",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0173",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0171",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0169",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0153",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0151",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u011B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0119",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0117",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0115",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0113",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0111",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0107",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE9",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "w",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "v",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "u",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "o",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "e",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "c",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "'",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\"",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\uE001",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EE3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EE1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDF",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDD",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDB",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ECF",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ECD",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBF",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBD",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBB",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EB9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1E13",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1E0D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u04E9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u04AB",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0454",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03CC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C2",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03B5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03B1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03AD",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03AC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u01DD",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u01A1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0153",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0151",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u014F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u014D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u011B",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0119",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0117",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0115",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0113",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0111",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010B",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0107",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF8",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF4",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF2",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xEB",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xEA",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE8",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "q",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "o",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "e",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "d",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "c",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    g2: "psi",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\uE001",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u2026",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u201E",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u201A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EF1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EEF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EED",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EEB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDD",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ECF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ECD",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBD",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EB9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E85",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E83",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E81",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E13",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E0D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04E9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04AB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04A1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0454",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u044A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0442",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CD",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CA",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C6",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AD",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01DD",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01B0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01A1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0175",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0173",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0171",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0169",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0153",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0151",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u014F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u014D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u011B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0119",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0117",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0115",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0113",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0111",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0107",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFC",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFA",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF6",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xEB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xEA",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "w",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "u",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "q",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "o",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "e",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "d",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "c",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: ".",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: ",",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\uE001",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EB9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E13",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E0D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04AB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03CC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01DD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01A1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0153",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0151",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u011B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0119",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0117",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0115",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0113",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0111",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0107",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\uE001",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDD",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECD",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBD",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EB9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E13",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E0D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04E9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04AB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0454",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03CC",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AD",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AC",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01DD",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01A1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0153",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0151",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u011B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0119",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0117",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0115",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0113",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0111",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0107",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEA",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "q",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "o",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "e",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "d",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "c",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\uE001",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EB9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E13",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E0D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04E9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04AB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0499",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u044D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0437",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01DD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01A1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0153",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0151",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u011B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0119",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0117",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0115",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0113",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0111",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0107",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE8",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "q",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "o",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "e",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "d",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "c",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03BB",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03BB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CA",
    u2: "\u03C7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03BB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\uE005",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "/",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\uE005",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "/",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u03A6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "J",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1E6C",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0513",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04A0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0459",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u043B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u039B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0394",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0164",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0162",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0104",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0102",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0100",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "X",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "T",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03C7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "?",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\uE005",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "/",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\uE005",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "/",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0513",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0459",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u043B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2026",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201E",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201D",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201A",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2019",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2018",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E85",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E83",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E81",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0513",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0497",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0459",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u044A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u043B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0436",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03C4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03B3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0175",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "w",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: ".",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: ",",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "'",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\"",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03BB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03BB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03BB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03BB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "/",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "\u03A6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "J",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03BB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u0427",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u03A6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "?",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0447",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0431",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "?",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "&",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "\u03BB",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\uE005",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "?",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03BB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03B8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03B6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03A9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03A6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "J",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "/",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "\u03BB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "/",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "/",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "/",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "?",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "/",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03C1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "\u03C7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2019",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2018",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAC",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAA",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E84",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E82",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E80",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E6C",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04B2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04A0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0496",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u042A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0416",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u040B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0402",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u039B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0394",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0178",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0176",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0174",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0164",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0162",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0104",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0102",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0100",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xDD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "Y",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "W",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "T",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "'",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\"",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u0427",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03C7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03C0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "f",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "?",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "f",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "/",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE6",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03A9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "/",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "&",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u042F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03A9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "?",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "/",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "&",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u042F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u042F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "J",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "3",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "/",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "/",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0427",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u03C0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "/",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "/",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u03C0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0427",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u03C0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "J",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "f",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE002",
    u2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE002",
    u2: "J",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "f",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u042F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C7",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03BB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03B8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03B6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03A9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03A6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "f",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "J",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "?",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "/",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "&",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    g2: "psi",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE004",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE001",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE000",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2026",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201E",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201A",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2014",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2013",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEF",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EED",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEB",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB6",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB2",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB0",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAE",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAC",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAA",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA8",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA6",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA2",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA0",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E93",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E85",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E83",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E81",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E63",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E62",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E5B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E4B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E45",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E13",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E0D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0512",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04EF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C8",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04B3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u049B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0498",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0497",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0491",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045E",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0454",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0453",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0449",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0448",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0446",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0442",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043D",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043C",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0439",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0438",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0436",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0433",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0432",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u041B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0414",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0409",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0404",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CD",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C4",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03BA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B7",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u039B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0398",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0394",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0272",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F9",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01DD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01B0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u018F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017C",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0177",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0175",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0173",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0171",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016B",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0169",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0161",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0160",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015F",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015A",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0159",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0157",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0155",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0153",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0152",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0151",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0150",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0148",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0146",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0144",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0122",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0121",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0120",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0119",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0117",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0115",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0113",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0111",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0107",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0106",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0104",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0102",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0100",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFB",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFA",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF1",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC6",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC5",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC4",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC2",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC1",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "z",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "w",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "v",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "u",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "s",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "r",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "p",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "n",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "m",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "g",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "d",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "S",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "Q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "O",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "G",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "A",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ".",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "-",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ",",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "f",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "J",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "hyphen,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "uni042D,uni0498",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "iotatonos,iota,iotadieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "omega,omegatonos",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Alphatonos,Epsilontonos,Etatonos,Iotatonos,Omicrontonos,Upsilontonos,Omegatonos",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "hyphen,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "uni042D,uni0498",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "iotatonos,iota,iotadieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "hyphen,endash,emdash",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "hyphen,endash,emdash",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "j,dotlessj",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "hyphen,endash,emdash",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "hyphen,endash,emdash",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni042D,uni0498",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "iotatonos,iota,iotadieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "omega,omegatonos",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "j,dotlessj",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "j,dotlessj",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "hyphen,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "uni042D,uni0498",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "iotatonos,iota,iotadieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "omega,omegatonos",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "hyphen,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni042D,uni0498",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "iotatonos,iota,iotadieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "omega,omegatonos",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0437,uni044D,uni0499",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "hyphen,endash,emdash",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "iotatonos,iota,iotadieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "omega,omegatonos",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "uni0437,uni044D,uni0499",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "hyphen,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "j,dotlessj",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij,dotlessj",
    g2: "j,dotlessj",
    k: -117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "hyphen,endash,emdash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "j,dotlessj",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "uni0437,uni044D,uni0499",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "j,dotlessj",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "hyphen,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "hyphen,endash,emdash",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "hyphen,endash,emdash",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "omega,omegatonos",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "omega,omegatonos",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "uni0437,uni044D,uni0499",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "hyphen,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "hyphen,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "uni042D,uni0498",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "j,dotlessj",
    k: -126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "uni0437,uni044D,uni0499",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "hyphen,endash,emdash",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "uni0437,uni044D,uni0499",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "hyphen,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "omega,omegatonos",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "iotatonos,iota,iotadieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "j,dotlessj",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni042D,uni0498",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Alphatonos,Epsilontonos,Etatonos,Iotatonos,Omicrontonos,Upsilontonos,Omegatonos",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "j,dotlessj",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "hyphen,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "uni042D,uni0498",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "j,dotlessj",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "j,dotlessj",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni042D,uni0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 33
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolveticaCompressedRgRegular);
export default __webpack_public_path__ + "static/media/CoolveticaCompressedRg-Regular.8e1542a71274bacbf612920c1f348850.svg";
export { ForwardRef as ReactComponent };